import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  DataTable, TableBody, TableColumn,
  TableHeader, 
  Button, Cell, DatePicker,
  DialogContainer, Grid, SelectField, SelectionControlGroup, TextField,
  TimePicker, CardTitle,
  FontIcon
} from 'react-md';
import {TableRow as TableRowReact} from 'react-md';
import MultiSelectReact from 'react-multi-select-ext';
import { NotificationManager } from 'react-notifications';
import { browserHistory } from 'react-router';
import Toggle from 'react-toggle';
import ReactTooltip from 'react-tooltip';
import ApiRequestService from '../component/ApiRequestService';
import LoadingSpinner from '../component/LoadingSpinner';
import Properties from '../component/Properties';
import SelectBox from '../component/SelectBox';
import TableRow from '../component/TableRow';
import SectionDropDown from '../component/SectionDropDown';
//import 'react-datepicker/dist/react-datepicker.css';
import '../css/datePickerStyle.css';
import '../css/QuizCreationStyle.css';
import styles from '../css/styles.css.js';
import crossIcon from '../images/png/crossIcon.png';
import downArrowIcon from '../images/png/down_arrow.png';
import successIcon from '../images/png/success.png';
import upArrowIcon from '../images/png/up.png';
import HelpText from '../lib/help-text';
import EditWindow from '../pages/EditWindow';
import CollapsableColumn from '../component/CollapsableColumn';
import editIcon from '../images/png/edit.png';
import { AppProperties } from '../common/function';


let RichTextEditor = null;


let hideSubcategoryDiv = { display: 'none' };
let showSubcategoryDiv = { display: 'block' };
let tempAddedQuizData = [];

const subcategoryDuplicateErrorMessageStart = 'The following subcategories are present multiple times in the selected list. \n '
const subcategoryDuplicateErrorMessageEnd = '\nPlease remove the above from your subcategory list.'

const isValidDate = function(d) {
  return d instanceof Date && !isNaN(d);
}
const numberGreaterThenZero = /^(?:[1-9]|\d\d\d*)$/;

const MAX_QUESTION_COUNT_FOR_ONE_PAGE_TEST = 30;

let selectedSectionIDArray = []
export default class QuizCreation extends Component {
  helpTextModel = new HelpText();
  appProperties = AppProperties();
  baseFolder = this.appProperties.baseFolder;
  
  static propTypes = {
    onChange: PropTypes.func,
    updateData: PropTypes.func
  };
  constructor(props) {
    super(props);
    //bug-tracker#241  -maximumAttendPerQuestion: 2,
    this.state = {
      subjects: [],
      topics: [],
      sections: [],
      propSections:[],
      selectSectionID:0, //For LTI Single Section to be Selected
      subjectId: 0,
      topicId: 0,
      categories: [],
      subCategories: [],
      pageLoading: true, //Show Loading Screen until all Dynamic Modules are loaded
      categoriesTable: [],
      showSubcategoryData: 'none',
      categorySelected: [],
      subcategoriesSelected: [],
      addedQuizSubDivList: [],
      quizInfoArr: [],
      startDate: '',
      endDate: '',
      startTime: '',
      endTime: '',
      quizORTest: false,
      assignmentName: '',
      masteryCondition: 3,
      numbersQuestion:'',
      maximumAttendPerQuestion: 2,
      removeCategoriesList: [],
      course_id: this.props.location.query.course_id,
      section_id: this.props.location.query.section_id,
      quiz_id: this.props.location.query.quiz_id,
      course_name: this.props.location.query.course_name,
      section_name: this.props.location.query.section_name,
      subsection: this.props.location.query.subsection,
      subsection_name: this.props.location.query.subsection_name,
      subsection_id: this.props.location.query.subsection_id,
      sectionTabs: this.props.location.query.sectionTabs,
      is_lti_enabled: this.props.location.query.is_lti_enabled,
      defaultStartDate: '',
      defaultEndDate: '',
      quizInsertArr: [],
      quizDeleteArr: [],
      DBSnapShotArr: [],
      hoverState: false,
      rowDispalyArrow: false,
      insertSection: [],
      deleteSection: [],
      quizOrderByArr: [],
      randomizeCategories: 1,
      isTestTimerEnabled: false,
      isAbsoluteTimerEnabled: true,
      isFullMarkOptionEnabled:false,
      categoriesSet: new Set(),
      masteryUnit: 0,
      DBSnapShotSectionArr: [],
      splashScreenText: '',
      NOCQC: 1,
      LockOutN: 20,
      loadingTopics: false,
	  loadingCategoryOptionButton:false,
      loadingCategories: false,
      loadingSave: false,
      enableSurvey:false,
      visible: false,
      isEnableSubsection: false,
      studentEditIsEnable:false,
      sectionForQuizTime:[],
      CMWindowVisible:false,
      categoriesUniqueArr : [],
      categoriesQuestionsCountMap : {},
      categoryDetailsMap:{},
      altSplashScreenTextVisible:false,
      altSplashScreenText:"",
      altSplashScreenObj:"",
      freeChoiceCount:0,
      allCategoriesAreRequired:false,
      allRandomSubcatOrder:false,
      isQuizAttendedByUser: false,
      resetAttendQuizButtonLoader: false,
      SectionAndSubsectionTableVisible: false,
      SectionAndSubsectionAddVisible:false,
      selectedSectionIDInAdd: 0,
      subsectionList:[],
      selectedSectionAndSubsectionList:[],
      SectionsListInAdd: [],
      DBSnapShotSubSectionArr: [],
      isSubmitEnable: false,
      DBIsSubsectionEnable : false,
      EditMode: false,
      EditSectionId: 0,
      isEnableSubsectionLTI: false,   // LTI Enable subsection
      isEnableLTI: this.appProperties.enableLTI,
      DBIsSubsectionEnableLTi: false,
      DBSnapshotSubsectionLTI: [],
      isSubsectionEnabled: false,
      showEnableSection:false,
      NocqcAlertVisible: false,
      NocQcqAlertPopupGrant: true,
      Is_Nongraded:false,
      allowPractice: true,
      isAnonymous: false,
      anonymousLink: '',
      onePageMode: false,
      status: 0, // published or unpublished,
      allowPartialCredit: false,
      allowPauseCategory: false,
    };

    this.selectBoxSubjectHandleChange = this.selectBoxSubjectHandleChange.bind(
      this
    );
    this.selectBoxTopicHandleChange = this.selectBoxTopicHandleChange.bind(
      this
    );
    //this.selectBoxCategoryHandleChange = this.selectBoxCategoryHandleChange.bind(this);
    this.selectBoxSubcategoryHandleChange = this.selectBoxSubcategoryHandleChange.bind(
      this
    );
    this.checkBoxCategoryOnChange = this.checkBoxCategoryOnChange.bind(this);
    this.checkBoxSubcategoryOnChange = this.checkBoxSubcategoryOnChange.bind(
      this
    );
    this.addCategoryForQuiz = this.addCategoryForQuiz.bind(this);
    this.handleChangeStartDate = this.handleChangeStartDate.bind(this);
    this.handleChangeEndDate = this.handleChangeEndDate.bind(this);
    this.createQuiz = this.createQuiz.bind(this);
    this.checkBoxRandomizeCategoryOnChange = this.checkBoxRandomizeCategoryOnChange.bind(
      this
    );
    this.assignmentNameOnChange = this.assignmentNameOnChange.bind(this);
    this.masteryConditionOnChange = this.masteryConditionOnChange.bind(this);
    this.masteryUnitOnChange = this.masteryUnitOnChange.bind(this);
    this.maximumAttendPerQuestionOnChange = this.maximumAttendPerQuestionOnChange.bind(
      this
    );
    this.quizORTestOnChange = this.quizORTestOnChange.bind(this);
    this.nonGradedOnChange = this.nonGradedOnChange.bind(this);
    //this.deleteSelectedItem = this.deleteSelectedItem.bind(this);
    this.selectedDataOnChange = this.selectedDataOnChange.bind(this);
    this.goBack = this.goBack.bind(this);
    this.cancel = this.cancel.bind(this);
    this.deleteSelectedSubcategory = this.deleteSelectedSubcategory.bind(this);
    this.hoverOn = this.hoverOn.bind(this);
    this.hoverOff = this.hoverOff.bind(this);
    this.onSelectCategory = this.onSelectCategory.bind(this);
    this.checkBoxRandomizeSubcategoryOnChange = this.checkBoxRandomizeSubcategoryOnChange.bind(
      this
    );
    this.randomizeCategoriesOnChange = this.randomizeCategoriesOnChange.bind(
      this
    );
    this.orderCheck = this.orderCheck.bind(this);
    this.logicCheckforFindingNeighbours = this.logicCheckforFindingNeighbours.bind(this);
    this.testTimerOnChange = this.testTimerOnChange.bind(this);
    this.isTestTimerOnChange = this.isTestTimerOnChange.bind(this);
    this.FullMarkOptionOnChange = this.FullMarkOptionOnChange.bind(this);
    this.EnableSubsectionOnChange = this.EnableSubsectionOnChange.bind(this);
    this.isAbsoluteTimerOnChange = this.isAbsoluteTimerOnChange.bind(this);

    //this.optionClicked = this.optionClicked.bind(this);
    this.onSplashScreenTextChange = this.onSplashScreenTextChange.bind(this);
    this.noCQCOnChange = this.noCQCOnChange.bind(this);
    this.lockOutNChange = this.lockOutNChange.bind(this);
    //this.onEnableSurveyChange = this.onEnableSurveyChange.bind(this);
    this.handleGetQuizById = this.handleGetQuizById.bind(this);
    this.subcategoryWeightTextOnChange = this.subcategoryWeightTextOnChange.bind(this);
    this.hide = this.hide.bind(this);
    this.show = this.show.bind(this);
   
    this.CMHide = this.CMHide.bind(this);
    this.CMShow = this.CMShow.bind(this);
    this.NocqcAlertHide = this.NocqcAlertHide.bind(this);
    this.NocqcAlertHideandAllowtoSave = this.NocqcAlertHideandAllowtoSave.bind(this);
    this.categoryMasteryTextOnChange = this.categoryMasteryTextOnChange.bind(this);
    this.categoryNocqcOnChange = this.categoryNocqcOnChange.bind(this);
    this.CategoryMasteryDataBuild = this.CategoryMasteryDataBuild.bind(this);
    this.CategoryNocqcDataBuild = this.CategoryNocqcDataBuild.bind(this);
    this.CategoryRandomSubcatOrderDataBuild = this.CategoryRandomSubcatOrderDataBuild.bind(this);
    this.onAltSplashScreenTextChange = this.onAltSplashScreenTextChange.bind(this);
    this.onIsRequiredSwitchChange = this.onIsRequiredSwitchChange.bind(this);
    this.onRandomSubcatOrderSwitchChange = this.onRandomSubcatOrderSwitchChange.bind(this);
    this.CategoryIsRequiredDataBuild = this.CategoryIsRequiredDataBuild.bind(this);
    this.onFreeChoiceCountChanges = this.onFreeChoiceCountChanges.bind(this);
    this.onCategoryPositionSwitchChange = this.onCategoryPositionSwitchChange.bind(this);
    this.SectionAndSubsectionShow = this.SectionAndSubsectionShow.bind(this);
    this.SectionAndSubsectionHide = this.SectionAndSubsectionHide.bind(this);    
    this.SectionAndSubsectionAddShow =  this.SectionAndSubsectionAddShow.bind(this);
    this.SectionAndSubsectionAddHide = this.SectionAndSubsectionAddHide.bind(this);
    this.onSingleSectionSelectedInAdd = this.onSingleSectionSelectedInAdd.bind(this);
    this.onDeleteSectionTableClick = this.onDeleteSectionTableClick.bind(this);
    this.onEditSectionTableClick = this.onEditSectionTableClick.bind(this)
  }
  /*onEnableSurveyChange = (value)=>{
    
    this.setState({enableSurvey:eval(value)});
  }*/
  addBreadCrumbs = () => {
    console.debug('Sections AddBreadCrumbs',this.props.location.query.sectionDashboard);
    let sectionUrl = '';
    if (this.props.location.query.sectionDashboard !== undefined &&
      this.props.location.query.sectionDashboard !== null) {
      sectionUrl =
        'sectionsDashboard?section_id=' +
        this.state.section_id +
        '&course_id=' +
        this.state.course_id +
        '&course_name=' +
        this.state.course_name +
        '&section_name=' +
        this.state.section_name +
        '&is_lti_enabled=' +
        this.state.is_lti_enabled

    } else {
      sectionUrl =
        'quizList?section_id=' +
        this.state.section_id +
        '&course_id=' +
        this.state.course_id +
        '&course_name=' +
        this.state.course_name +
        '&section_name=' +
        this.state.section_name +
        '&is_lti_enabled=' +
        this.state.is_lti_enabled
    }
    if (
      this.props.location.query.section_id !== null &&
      this.props.location.query.section_id !== undefined
    ) {
      if(this.props.location.query.course_indx !== null &&
      this.props.location.query.course_indx !== undefined){
        this.props.replaceBreadCrumb([
          {
            name: this.state.course_name,
            type: 'Courses',
            onclickPath:
              'CoursesDashboard?course_indx=' +
              this.props.location.query.course_indx +
              '&is_lti_enabled=' +
              this.state.is_lti_enabled
          },
          {
            name: this.state.section_name,
            type: 'Section',
            onclickPath: sectionUrl +'&course_indx=' +
            this.props.location.query.course_indx +
            '&is_lti_enabled=' +
            this.state.is_lti_enabled
          }
        ]);
      }
      else{
        this.props.replaceBreadCrumb([
          {
            name:(this.appProperties.schoolMode?'All Standards':'All Courses'),
            type: '',
            onclickPath: '/'
          },
          {
            name: this.state.course_name,
            type: 'Courses',
            onclickPath:
              'sections?course_id=' +
              this.state.course_id +
              '&course_name=' +
              this.state.course_name + 
              '&is_lti_enabled=' +
              this.state.is_lti_enabled
          },
          (this.state.subsection !== "true" && this.state.sectionTabs !== "true")? 
          {
            name: this.state.section_name,
            type: 'Section',
            onclickPath: 'quizList?section_id=' +
            this.state.section_id +
            '&section_name=' +
            this.state.section_name +
            '&course_id=' +
            this.state.course_id +
            '&course_name=' +
            this.state.course_name +
            '&is_lti_enabled=' +
              this.state.is_lti_enabled
          } : '',
         ( this.state.subsection === "true" || this.state.sectionTabs === "true")? 
          {
            name: this.state.section_name,
            type: 'Sections',
            onclickPath: 
               'sectionTabs?section_id=' +
               this.state.section_id +
               '&section_name=' +
               this.state.section_name +
               '&course_id=' +
               this.state.course_id +
               '&course_name=' +
               this.state.course_name + 
               '&is_lti_enabled=' +
                this.state.is_lti_enabled
          } : '',
          (this.state.subsection === "true" && this.state.sectionTabs !== "true") ?
          {
            name: this.state.subsection_name,
            type: 'Subsetions',
            onclickPath: 
               'subSectionTabs?subsection_id=' +
               this.state.subsection_id +
               '&subsection_name=' +
               this.state.subsection_name +
               '&section_id=' +
               this.state.section_id +
               '&section_name=' +
               this.state.section_name +
               '&course_id=' +
               this.state.course_id +
               '&course_name=' +
               this.state.course_name +
               '&is_lti_enabled=' +
                this.state.is_lti_enabled
          } : ''
          
        ]);
      }
    } else {
      this.props.replaceBreadCrumb([
        {
          name: this.state.course_name,
          type: '',
          onclickPath: 'CoursesDashboard?course_indx=' + this.props.location.query.course_indx
        }
      ]);
    }
  };

  componentWillUnmount() {
    this.removeBreadCrumbs();
  }
  removeBreadCrumbs = () => {
      this.props.replaceBreadCrumb([
      ]);     

  };
  componentWillUpdate() {
    this.addBreadCrumbs();
    this.helpTextModel = new HelpText();
  }

  componentWillMount() {
    console.log('section_id=', this.props.location.query);
    //bug-tracker#205
    import('../component/TextEditor').then(reactRte => {
      //Loading React RTE Module On Demand
      RichTextEditor = reactRte.default; //Getting the Default Export of React RTE.

      //Loading Component Willmount once all Modules are Loaded.
      this.setState({ splashTextEditorObj: RichTextEditor.createEmptyValue() });
      tempAddedQuizData = [];
      this.loadSubjectData();
      this.loadSectiontData();


    });
    this.helpTextModel.getAllHelpText().then(res=>{
      this.setState({helpTextLoaded:true})
    });
  }

  handleAttendQuiz=()=>{
    let strToRemove = 'cpanel/'
    let isTest = this.state.quizORTest ? 1 :0
    let url = (this.appProperties.appURL)    
    url = url.replace(strToRemove, "");
    if (process.env.hasOwnProperty("REACT_APP_APPSETTING_REQUIRED")) {
      let hostArray = window.location.hostname.split(".");
      if (hostArray.length > 4) {
        url = `${window.location.protocol}//${hostArray[hostArray.length - 5]}.student.${hostArray[hostArray.length - 3]}.${hostArray[hostArray.length - 2]}.${hostArray[hostArray.length - 1]}/`
      }else if(hostArray.length == 4){
        url = `${window.location.protocol}//${hostArray[hostArray.length - 4]}.student.${hostArray[hostArray.length - 2]}.${hostArray[hostArray.length - 1]}/`
      }
    }
    if(this.appProperties.loginType === "shiboleth"){
      url = url+"student/";
    }

    // url = url+"takequiz/"+this.state.quiz_id+"/"+this.state.course_id+
    //   "/"+this.state.selectSectionID+"/"+this.state.assignmentName+"/"+isTest;

    url = url + `takequiz?quiz_id=${this.state.quiz_id}&course_id=${this.state.course_id}&section_id=${this.state.selectSectionID}&quiz_name=${this.state.assignmentName}&quiz_type=${isTest}`
      
    console.log("AppURL=", url)
    window.open(url)
    this.setState({isQuizAttendedByUser:true})
  }

  handleDeleteUserDataForQuiz =(showSuccessNotification) =>{
    this.setState({
      resetAttendQuizButtonLoader: true
    });
    ApiRequestService({
      method: 'post',
      url: '/deleteUserQuizAttendedData',
      data: {
        quiz_id: parseInt(this.state.quiz_id, 10)
      }
    }).then(res => {
      if(res != null &&
        res.data != null &&
        res.data.message !== null &&
        res.data.message !== ""){
        NotificationManager.error('Error while deleting the user record', 'ERROR', 3000);
      }else{
        if(showSuccessNotification){
          NotificationManager.success("User record deleted successfully!", 'Success', 3000);
        }
        this.setState({isQuizAttendedByUser:false})
      }
    }).catch(error => {
      NotificationManager.error('Error while deleting the user record', 'ERROR', 3000);
      console.error('Error while Deleting the User Data ', error);
    }).finally(()=>{
      this.setState({
        resetAttendQuizButtonLoader: false
      });
    });
  }

  handleGetQuizById(res){
    console.debug('Quizes by id = ', res);
    this.setState({ pageLoading: false });
    if (res.data.data !== null) {
      var tempQuizDeatilsArr = [];
      var tempQuizSubcatInfo = [];

      let isQuizAttendedByUser = res.data.data.isQuizAttended;

      tempQuizDeatilsArr = res.data.data.quiz_details;
      tempQuizSubcatInfo = res.data.data.quiz_subcat_info;
      console.debug('tempQuizDeatilsArr = ', tempQuizDeatilsArr);
      console.debug('tempQuizSubcatInfo = ', tempQuizSubcatInfo);
      var tempQuizInfoArr = [];
      var temDeleteDBArr = [];
      var tempCategoriesSet = new Set();
      var tempCategoriesUniqueArr = [];
      var tempCategoryDetailsMap = {};
      
      if (tempQuizSubcatInfo !== null && tempQuizSubcatInfo.length > 0) {        
        for (var i = 0; i < tempQuizSubcatInfo.length; i++) {
          var tempQuizInfo = {};
          tempQuizInfo['subject_id'] = tempQuizSubcatInfo[i].subject_id;
          tempQuizInfo['topic_id'] = tempQuizSubcatInfo[i].topic_id;
          tempQuizInfo['category_id'] = tempQuizSubcatInfo[i].category_id;
          tempQuizInfo['subcategory_id'] =
            tempQuizSubcatInfo[i].subcategory_id;
          tempQuizInfo['order'] = tempQuizSubcatInfo[i].order;
          tempQuizInfo['category_name'] =
            tempQuizSubcatInfo[i].category_Name;
          tempQuizInfo['subcategory_name'] =
            tempQuizSubcatInfo[i].subcategory_name;
          tempQuizInfo['randomize_questions'] =
            tempQuizSubcatInfo[i].randomize_questions;
            tempQuizInfo['question_count'] =
            tempQuizSubcatInfo[i].question_count;

          var index =
            tempQuizSubcatInfo[i].subject_id +
            '_' +
            tempQuizSubcatInfo[i].topic_id +
            '_' +
            tempQuizSubcatInfo[i].category_id +
            '_' +
            tempQuizSubcatInfo[i].subcategory_id;
          tempQuizInfo['index'] = index;
          tempQuizInfo['subcategory_weight'] = tempQuizSubcatInfo[i].subcategory_weight;
          tempQuizInfo['non_graded'] = tempQuizSubcatInfo[i].non_graded;
          tempQuizInfo['enable_analytics'] = tempQuizSubcatInfo[i].enable_analytics;
          tempQuizInfo['enable_feedback'] = tempQuizSubcatInfo[i].enable_feedback;
          tempQuizInfo['category_is_required'] = 1
          tempQuizInfo['category_at_last'] = 0
          tempQuizInfo['category_at_begining'] = 0
         
          tempQuizInfoArr.push(tempQuizInfo);
          temDeleteDBArr.push(tempQuizInfo);
          var tempCatId = tempQuizSubcatInfo[i].subject_id +
          '_' +
          tempQuizSubcatInfo[i].topic_id +
          '_' +
          tempQuizSubcatInfo[i].category_id;
          tempCategoriesSet.add(tempCatId);

          console.log("res.data.data.category_mastery_count",res.data.data.category_mastery_count);
          var tempCategoryMasteryCount = null;
          if(res.data.data.category_mastery_count !== undefined && 
             res.data.data.category_mastery_count !== null && 
             res.data.data.category_mastery_count !== ""){
             tempCategoryMasteryCount = JSON.parse(res.data.data.category_mastery_count);

            console.log("tempCategoryMasteryCount[tempCatId]",tempCategoryMasteryCount[tempCatId]);
            if(tempCategoryMasteryCount[tempCatId] !== undefined && tempCategoryMasteryCount[tempCatId] !== null
              && tempCategoryMasteryCount[tempCatId] !== ""){
              tempQuizInfo['category_mastery_count'] = tempCategoryMasteryCount[tempCatId];
            }
          }
                  
          console.log("res.data.data.category_ocqc",res.data.data.category_nocqc);
          var tempCategoryNocqcCount = null;
          if(res.data.data.category_nocqc !== undefined && 
            res.data.data.category_nocqc !== null && 
            res.data.data.category_nocqc !== ""){
              tempCategoryNocqcCount = JSON.parse(res.data.data.category_nocqc);

           console.log("tempCategoryNocqcCount[tempCatId]",tempCategoryNocqcCount[tempCatId]);
           if(tempCategoryNocqcCount[tempCatId] !== undefined && tempCategoryNocqcCount[tempCatId] !== null
             && tempCategoryNocqcCount[tempCatId] !== ""){
             tempQuizInfo['category_nocqc'] = tempCategoryNocqcCount[tempCatId];
           }
         }          
          
          console.log("res.data.data.random_subcategory_order",res.data.data.random_subcategory_order);
          var tempROS = null;
          if(res.data.data.random_subcategory_order !== undefined && 
             res.data.data.random_subcategory_order !== null && 
             res.data.data.random_subcategory_order !== ""){
              tempROS = JSON.parse(res.data.data.random_subcategory_order);
            console.log("tempROS[tempCatId]",tempROS);
            if(tempROS[tempCatId] !== undefined && tempROS[tempCatId] !== null
              && tempROS[tempCatId] !== ""){
              tempQuizInfo['random_subcategory_order'] = tempROS[tempCatId];
            }
          }
         
         console.log("res.data.data.category_number_of_questions",res.data.data.category_number_of_questions);          
          var tempCategoryNumberofQuestions = null;
          if(res.data.data.category_number_of_questions !== undefined && 
             res.data.data.category_number_of_questions !== null && 
             res.data.data.category_number_of_questions !== ""){
              tempCategoryNumberofQuestions = JSON.parse(res.data.data.category_number_of_questions);

            console.log("tempCategoryNumberofQuestions[tempCatId]",tempCategoryNumberofQuestions[tempCatId]);
            if(tempCategoryNumberofQuestions[tempCatId] !== undefined && tempCategoryNumberofQuestions[tempCatId] !== null
              && tempCategoryNumberofQuestions[tempCatId] !== ""){
              tempQuizInfo['category_number_of_questions'] = tempCategoryNumberofQuestions[tempCatId];
            }
          }

          console.log("res.data.data.category_is_required",res.data.data.category_is_required);
          var tempCategoryIsRequired = null;
          if(res.data.data.category_is_required !== undefined && 
             res.data.data.category_is_required !== null && 
             res.data.data.category_is_required !== ""){
              tempCategoryIsRequired = JSON.parse(res.data.data.category_is_required);
            console.log("tempCategoryIsRequired[tempCatId]",tempCategoryIsRequired);
            if(tempCategoryIsRequired[tempCatId] !== undefined && tempCategoryIsRequired[tempCatId] !== null
              && tempCategoryIsRequired[tempCatId] !== ""){
              tempQuizInfo['category_is_required'] = tempCategoryIsRequired[tempCatId];
            }
          }
          
          var tempCategoryIsRequired = null;
          if(res.data.data.category_position !== undefined && res.data.data.category_position !== null && 
             res.data.data.category_position !== "" && res.data.data.category_position !== {}){

            tempCategoryIsRequired = JSON.parse(res.data.data.category_position);
            console.log("tempCategoryIsRequired[tempCatId]",tempCategoryIsRequired);

            if(tempCategoryIsRequired[tempCatId] !== undefined && tempCategoryIsRequired[tempCatId] !== null && 
              tempCategoryIsRequired[tempCatId].category_at_begining !== undefined && 
              tempCategoryIsRequired[tempCatId].category_at_begining !== null &&
              tempCategoryIsRequired[tempCatId].category_at_last !== undefined && tempCategoryIsRequired[tempCatId].at_last !== null){
                tempQuizInfo['category_at_last'] = tempCategoryIsRequired[tempCatId].category_at_last;
                tempQuizInfo['category_at_begining'] = tempCategoryIsRequired[tempCatId].category_at_begining;
            }

          }

           if(res.data.data.fullScoreIfAttempted){
            this.setState({
              isFullMarkOptionEnabled:true,
            });
           } 
           if(res.data.data.fixedAbsoluteTimeEnabled){
            this.setState({
              isAbsoluteTimerEnabled:true,
            });
           } 


          if(tempCategoriesUniqueArr.includes(tempCatId) !== true){
            
            tempCategoriesUniqueArr.push(tempCatId);  

          }
          tempCategoryDetailsMap[tempCatId] = tempQuizInfo;
          
        }
      }

      let allCategoriesAreRequired = Object.keys(tempCategoryDetailsMap).some((element) =>{
        if(tempCategoryDetailsMap[element].category_is_required === 2){
          return true
        }
      })

      let allRandomSubcatOrder = Object.keys(tempCategoryDetailsMap).some((element) =>{
        if(tempCategoryDetailsMap[element].random_subcategory_order === 2){
          return true
        }
      })
      
      this.setState({
        allRandomSubcatOrder: allRandomSubcatOrder,
        allCategoriesAreRequired:allCategoriesAreRequired,
        categoriesSet: tempCategoriesSet,
        masteryUnit: tempCategoriesSet.size,
        categoriesUniqueArr:tempCategoriesUniqueArr,
        categoryDetailsMap:tempCategoryDetailsMap,
        freeChoiceCount:res.data.data.free_choice_count
      });

       


      console.log("categoryDetailsMap = ",this.state.categoryDetailsMap);

      var startDateAndTime =
        res.data.data.start_date + ' ' + res.data.data.start_time;
      var endDateAndTime =
        res.data.data.end_date + ' ' + res.data.data.end_time;

      var resStartDate = '';
      var resEndDate = '';

      if (
        res.data.data.start_date !== null &&
        res.data.data.start_date !== ''
      ) {
        resStartDate = moment(startDateAndTime, 'DD-MM-YYYY HH-mm');
      }
      if (
        res.data.data.end_date !== null &&
        res.data.data.end_date !== ''
      ) {
        resEndDate = moment(endDateAndTime, 'DD-MM-YYYY HH-mm');
      }

      console.debug(
        'res.data.data.quiz_type = ',
        res.data.data.quiz_type
      );
      //console.debug('res.data.data.testTimerEnabled = ', res.data.data.testTimerEnabled);
      /*console.debug(
        'res.data.data.test_time = ',
        res.data.data.test_time
      );*/
      var tempIsTest = false;
      var optionFullMark = false;
      var optionAbsoluteTime = false;
      var tempQuizType = false;
      var enableSurveyLocal = false;//enableSurvey
      var is_nongraded = false
      if (res.data.data.testTimerEnabled === 1) {
        tempIsTest = true;
      }
      if (res.data.data.fullScoreIfAttempted === 1) {
        optionFullMark = true;
      }
      if (res.data.data.fixedAbsoluteTimeEnabled === 1) {
        optionAbsoluteTime = true;
      }
      if (res.data.data.quiz_type === 1) {
        tempQuizType = true;
      }
      if(res.data.data.enableSurvey){
        enableSurveyLocal = res.data.data.enableSurvey;
      }
      if(res.data.data.is_nongraded === 1) {
        is_nongraded = true
      }
      console.debug('tempIsTest = ', tempIsTest);
      var tempResponseSection = [];
      tempResponseSection = res.data.data.sections_list;
      var tempSections = this.state.sections;
      var tempSectionForQuizTime = [];
      console.log('tempSections = ', tempSections);
      console.log('tempResponseSection = ', tempResponseSection);
      console.log('tempSections = ', tempSections);
      //if(!res.data.data.enable_subsection || this.state.isEnableLTI){
      for (var s = 0; s < tempSections.length; s++) {
        if(tempSections[s].value == null || tempSections[s].value == undefined){
            tempSections[s].value = false;
          }
          if (tempResponseSection !== null) {
            for (var m = 0; m < tempResponseSection.length; m++) {
              if (tempSections[s].id === tempResponseSection[m].id) {
                tempSectionForQuizTime.push(tempSections[s]);
                tempSections[s].value = true;
              }
            }
          }
        
      }
      //}

 let TempSelectSecAndSubArr = res.data.data.sections_list;
 let TempSelectedSecAndSubList = [];


 console.log('tempResponseSection',tempSectionForQuizTime)
 if(this.state.isEnableLTI){
    this.onSingleSectionSelected(tempResponseSection[0].id,tempResponseSection)
 }else if(TempSelectSecAndSubArr && TempSelectSecAndSubArr.length > 0 && res.data.data.enable_subsection){
   
    let TempSectionId = [];
    TempSelectSecAndSubArr.map((section) => {
            if(TempSectionId.length > 0 ){
                if(!TempSectionId.includes(section.id)){
                  TempSectionId.push(section.id)
                }
            }else {
              TempSectionId.push(section.id)
            }
          });
    console.log(TempSectionId);
    let sectionArr = [];
    sectionArr = TempSectionId.map((data) => {
    let subsection = []
    let subsectionArr = [];
    let TempSecObj = {};
    TempSecObj["id"] = data;
    TempSecObj["value"] = true;
    TempSelectSecAndSubArr.map((resdata)=>{
    if(resdata.id == data){
      TempSecObj["section_name"] = resdata.label;
    }
    });

    subsectionArr = TempSelectSecAndSubArr.map((resdata)=>{
    if(resdata.id == data){
      let TempSubObj = {};
      TempSubObj["id"] = resdata.subsection_id;
      TempSubObj["value"] = true;
      TempSubObj["label"] = resdata.subsection_name;
      return TempSubObj;
    }
    });

    subsection = TempSelectSecAndSubArr.map((resdata)=>{
    if(resdata.id == data){ 
      return resdata.subsection_name;
    }
    });
    subsectionArr = subsectionArr.filter((data)=> data!= undefined);
    TempSecObj["subsectionList"] = subsectionArr;
    subsection = subsection.filter((data)=> data!= undefined);
    TempSecObj["subsection"] = subsection;
    return TempSecObj;
    });

    console.log('sectionArr',sectionArr);
    TempSelectedSecAndSubList = sectionArr

 }

 console.log('TempSelectedSecAndSubList',TempSelectedSecAndSubList)

      var tempSplashTextDefaultId = res.data.data.splash_screen;
      var tempAltSplashTextDefaultId = res.data.data.alt_splash_screen;
      console.log("tempSectionForQuizTime =",tempSectionForQuizTime);

      this.setState({
        assignmentName: res.data.data.quiz_name,
        masteryCondition: res.data.data.mastery_condition,
        //masteryUnit: res.data.data.mastery_units,
        maximumAttendPerQuestion: res.data.data.maximum_attempted,
        defaultStartDate: res.data.data.start_date,
        defaultEndDate: res.data.data.end_date,
        startTime: res.data.data.start_time,
        endTime: res.data.data.end_time,
        //addedQuizSubDivList:tempAddedQuizData,
        quizInfoArr: tempQuizInfoArr,
        DBSnapShotArr: temDeleteDBArr,
        startDate: resStartDate,
        endDate: resEndDate,
        quizORTest: tempQuizType,
        isTestTimerEnabled: tempIsTest,
        fullScoreIfAttempted:optionFullMark,
        fixedAbsoluteTimeEnabled: optionAbsoluteTime,
        testTimerValue: res.data.data.test_time,
        randomizeCategories: res.data.data.randomize_categories,
        sections: tempSections,
        propSections: tempSections,
        selectSectionID:tempResponseSection && tempResponseSection.length>0?tempResponseSection[0].id:null,
        DBSnapShotSectionArr: tempResponseSection,
        splashTextEditorObj: RichTextEditor.createValueFromString(
          tempSplashTextDefaultId,
          'html'
        ),
        altSplashScreenObj: tempAltSplashTextDefaultId,
        NOCQC: res.data.data.NoCQC,
        LockOutN: res.data.data.lockoutN,
        splashScreenText: tempSplashTextDefaultId,
        altSplashScreenText: tempAltSplashTextDefaultId,
        enableSurvey:enableSurveyLocal,
        sectionForQuizTime:tempSectionForQuizTime,
        isQuizAttendedByUser : isQuizAttendedByUser,
        isEnableSubsection: res.data.data.enable_subsection,
        showEnableSection:res.data.data.show_enable_subsection,
        isEnableSubsectionLTI: res.data.data.enable_subsection,
        selectedSectionAndSubsectionList: TempSelectedSecAndSubList,
        DBSnapShotSubSectionArr: res.data.data.sections_list,
        DBIsSubsectionEnable: res.data.data.enable_subsection,
        DBSnapshotSubsectionLTI: tempResponseSection,
        DBIsSubsectionEnableLTi: res.data.data.enable_subsection,
        Is_Nongraded:is_nongraded,
        allowPractice: tempQuizType ? false : true,
        isAnonymous: res.data.data.is_anonymous,
        anonymousLink: res.data.data.anonymous_link,
        onePageMode: res.data.data.one_page_mode,
        status: res.data.data.status,
        allowPartialCredit: res.data.data.allow_partial_credit,
        allowPauseCategory: res.data.data.allow_pause_category,
      });
    }
  }
  loadSectiontData() {
    console.debug('course_id =', this.props.location.query.course_id);
    const payload = {
      course_id: parseInt(this.props.location.query.course_id, 10)
    };

    ApiRequestService({
      method: 'post',
      url: '/getAllSections',
      data: payload
    }).then(res => {
      console.debug('getAllSections = ', res);
      if (this.state.quiz_id == null) {
        this.setState({ pageLoading: false });
      }
      if (
        res !== null &&
        res.data !== null &&
        res.data.data !== null &&
        res.data.data.section_names !== null
      ) {
        var tempSectionList = [];
        var tempSectionArr = res.data.data.section_names;
        if (tempSectionArr !== null) {
          for (var i = 0; i < tempSectionArr.length; i++) {
            var tempObj = {};
            //tempObj["value"] = tempSectionArr[i].section_name;
            tempObj['label'] = tempSectionArr[i].section_name;
            tempObj['id'] = tempSectionArr[i].section_id;
            if (
              tempSectionArr[i].section_id ===
                parseInt(this.props.location.query.section_id, 10) &&
              this.state.quiz_id == null 
            ) {
              tempObj['value'] = true;
            } else {
              tempObj['value'] = false;
            }
            tempSectionList.push(tempObj);

      /* Check if section have subsection */

      if(tempSectionArr[i].enable_subsection === true && !this.state.isSubsectionEnabled){
        let payload = {
          section_id : tempSectionArr[i].section_id,
          course_id : tempSectionArr[i].course_id
        }

        ApiRequestService({
          method: 'post',
          url: '/getAllSubSections',
          data: payload
        }).then((res) => {
          if(res.data && res.data.data && res.data.data.subsection_names != null &&  res.data.data.subsection_names.length > 0){
           let isSubsectionEnabled = true; 
            this.setState({isSubsectionEnabled : isSubsectionEnabled })
            }
            });
            }
          }
        }
        this.setState({
          sections: tempSectionList,
          propSections: tempSectionList
        }, () =>{
          if (this.state.quiz_id != null) {
            const payload = {
              course_id: parseInt(this.state.course_id, 10),
              section_id: parseInt(this.state.section_id, 10),
              quiz_id: parseInt(this.state.quiz_id, 10)
            };
    
            this.setState({
              loading: true,
              pageLoading: true
            });
    
            ApiRequestService({
              method: 'post',
              url: '/getQuizById',
              data: payload
            }).then(res => {
              console.log("handleGetQuizById",res)
              this.handleGetQuizById(res);  
			  if (res.data.data.quiz_type === 1){
				  let resp = this.getCategoryQuestions();
				  resp.then(res => {
					if (res.data.data !== null && res.data.data !== undefined){
					  this.setState({
						categoriesQuestionsCountMap:res.data.data 
					  })
					}
							  
				  });
			  }          
            });
          }
        });
      }
    })
  }

  loadSubjectData() {
    //let answerIndex = 0;
    ApiRequestService({
      method: 'post',
      url: '/getAllSubjects'
    }).then(res => {
      //console.debug(res.data.data.subject_names);
      if (
        res !== null &&
        res.data !== null &&
        res.data.data !== null &&
        res.data.data.subject_names !== null
      ) {
        this.setState({
          subjects: res.data.data.subject_names
        });
      }
    });
  }

  loadTopicData(sub_id) {
    //console.debug("loadTopicData");
    this.setState({ subjectId: sub_id });
    var tempTopic = [];
    const payload = {
      // subject_id: this.state.subject_id
      subject_id: sub_id
    };
    //console.debug("Subject id : ",payload);
    ApiRequestService({
      method: 'post',
      url: '/getAllTopics',
      data: payload
    }).then(res => {
      // console.debug("topic res=",res.data.data.topic_names);
      this.setState({
        loadingTopics: false
      });
      if (res.data.data.topic_names !== null) {
        tempTopic = res.data.data.topic_names;
        //bug-tracker#282
        this.setState({
          topics: tempTopic,
          categories:[],//bug-tracker#282
          subCategories:[],//bug-tracker#282
          subcategoriesSelected: []//bug-tracker#282
        });
      } else {
        
        this.setState({
          topics: [],
          subCategories:[],//bug-tracker#282
          subcategoriesSelected: []//bug-tracker#282
        });
      }
    });
  }

  selectBoxSubjectHandleChange(event) {
    var sub_id = parseInt(event.target.value, 10);
    this.setState({
      subjectId: sub_id,
      loadingTopics: true
    });

    this.loadTopicData(sub_id);
  }
  selectBoxTopicHandleChange(event) {
    //console.debug( "selectBoxTopicHandleChange =",event.target.value);

    var sub_id = parseInt(this.state.subjectId, 10);
    var top_id = parseInt(event.target.value, 10);
    var cat_id = 0;
    this.setState({ loadingCategories: true });
    this.loadSubcategory(sub_id, top_id, cat_id);
  }

  loadCategory(sub_id, top_id) {
    this.setState({ topicId: top_id });
    const payload = {
      topic_id: top_id,
      subject_id: sub_id
    };
    //console.debug("Topic id : ",payload);
    ApiRequestService({
      method: 'post',
      url: '/getAllCategories',
      data: payload
    }).then(res => {
      this.setState({ loadingCategories: false });
      // console.debug("Get All Categories res :",res.data.data.category_names);
      if (res.data.data.category_names !== null) {
        var tempCategories = [];
        var temCategorySelected = [];
        tempCategories = res.data.data.category_names;

        for (var i = 0; i < tempCategories.length; i++) {
          let tempvalue = {};
          tempvalue['key'] = tempCategories[i].category_id;
          tempvalue['checked'] = true;
          tempvalue['showSubcategory'] = false;
          tempvalue['randomizeCategory'] = true;
          tempvalue['rowSelectedCategory'] = false;
          tempvalue['difficulty_level'] = tempCategories[i].difficulty_level;
          tempvalue['avg_time'] = tempCategories[i].avg_time;

          temCategorySelected.push(tempvalue);
        }
        console.debug('categories:', tempCategories);
        this.setState({
          categories: tempCategories,
          categorySelected: temCategorySelected
        });
      }
    });
  }

  /*selectBoxCategoryHandleChange(event) {
    //console.debug( "selectBoxCategoryHandleChange =",event.target.value);

    var sub_id = parseInt(this.state.subjectId,10);
    var top_id = parseInt(this.state.topicId,10);
    var cat_id = parseInt(event.target.value,10);
    //this.loadSubcategory(sub_id,top_id,cat_id);
  };
*/
  loadSubcategory(sub_id, top_id, cat_id) {
    this.setState({ categoryId: cat_id });
    const payload = {
      topic_id: top_id,
      subject_id: sub_id,
      category_id: cat_id
    };

    ApiRequestService({
      method: 'post',
      url: '/getAllSubCategories',
      data: payload
    }).then(res => {
      console.debug(
        'Get All SubCategories res :',
        res.data.data.subCategory_names
      );

      if (res.data.data.subCategory_names !== null) {
        var tempsubgcategories = [];
        var tempSubgcategoriesSelected = [];
        tempsubgcategories = res.data.data.subCategory_names;

        for (var i = 0; i < tempsubgcategories.length; i++) {
          let tempvalue = {};
          tempvalue['key'] = tempsubgcategories[i].subcategory_id;
          tempvalue['checked'] = false;
          tempvalue['subject_id'] = tempsubgcategories[i].subject_id;
          tempvalue['topic_id'] = tempsubgcategories[i].topic_id;
          tempvalue['category_id'] = tempsubgcategories[i].category_id;
          tempvalue['subcategory_id'] = tempsubgcategories[i].subcategory_id;
          tempvalue['subcategory_name'] =
            tempsubgcategories[i].subcategory_name;
          tempvalue['subcategory_randomize'] = true;
          tempvalue['difficulty_level'] =
            tempsubgcategories[i].difficulty_level;
          tempvalue['avg_time'] = tempsubgcategories[i].avg_time;
          tempvalue['question_count'] = tempsubgcategories[i].question_count;
          tempSubgcategoriesSelected.push(tempvalue);
        }
        console.debug(
          'tempSubgcategoriesSelected = ',
          tempSubgcategoriesSelected
        );
        this.setState({
          subCategories: res.data.data.subCategory_names,
          subcategoriesSelected: tempSubgcategoriesSelected
        });
      }else{
        //bug-tracker#282
        this.setState({
          subCategories:[],
          subcategoriesSelected: []
        });
      }

      this.loadCategory(sub_id, top_id);
    });
  }
  selectBoxSubcategoryHandleChange(event) {
    this.setState({ subcategoryId: parseInt(event.target.value, 10) });
  }
  selectBoxMultipleChoiceHandleChange(event) {
    //console.debug( "selectBoxMultipleChoiceHandleChange =",event.target.value);
    var tempMultipleChoice = parseInt(event.target.value, 10);
    tempMultipleChoice = event.target.value;

    this.setState({ multipleChoice: tempMultipleChoice });
    //console.debug("this.state.multipleChoice =", this.state.multipleChoice);
  }

  showSubcategoryDetails(i) {
    console.debug('showSubcategoryDetails', i);
    var tempCategorySelected = [];
    tempCategorySelected = this.state.categorySelected;
    console.debug(
      'tempCategorySelected=',
      tempCategorySelected[i].showSubcategory
    );
    if (tempCategorySelected[i] !== undefined) {
      console.debug(
        'Before tempCategorySelected[i].showSubcategory',
        tempCategorySelected[i].showSubcategory
      );
      if (tempCategorySelected[i].showSubcategory) {
        tempCategorySelected[i].showSubcategory = false;
      } else {
        tempCategorySelected[i].showSubcategory = true;
      }
      console.debug(
        'After tempCategorySelected[i].showSubcategory',
        tempCategorySelected[i].showSubcategory
      );
      this.setState({ categorySelected: tempCategorySelected });
      //this.onSelectCategory(i);
    }
  }

  selectedDataOnChange(event) {
    console.debug('selectedDataOnChange', event.target.value);

    var tempRemoveCategoriesList = [];
    if (this.state.removeCategoriesList.length > 0) {
      tempRemoveCategoriesList = this.state.removeCategoriesList;
    }
    // if(this.state.removeCategoriesList.length > 0){
    //   tempRemoveCategoriesList= this.state.removeCategoriesList;
    // }
    var index = event.target.value;
    if (document.getElementById(index).checked) {
      tempRemoveCategoriesList.push(event.target.value);
    } else {
      for (var i = 0; i < tempRemoveCategoriesList.length; i++) {
        if (index === tempRemoveCategoriesList[i]) {
          tempRemoveCategoriesList.splice(i, 1);
        }
      }
    }
    console.debug('tempRemoveCategoriesList', tempRemoveCategoriesList);

    this.setState({
      removeCategoriesList: tempRemoveCategoriesList
    });
  }

  isArrayObjectFound(currArray, indexOfValue) {
    // Array - currArray object value - indexOfValue object key -indexValue
    var isFound = false;
    for (var ins = 0; ins < currArray.length; ins++) {
      // console.debug("isArrayObjectFound index ",indexOfValue);
      // console.debug("isArrayObjectFound Array index  ",currArray[ins].index);

      if (currArray[ins].index === indexOfValue) {
        console.debug('isArrayObjectFound is true');
        isFound = true;
      }
    }
    return isFound;
  }

  addCategoryForQuiz() {
    console.debug('subcategoriesSelected', this.state.subcategoriesSelected);
    console.debug('categorySelected', this.state.categorySelected);

    var tempQuizInfoArr = [];
    var tempInsertArr = [];
    if (this.state.quizInfoArr.length > 0) {
      tempQuizInfoArr = this.state.quizInfoArr;
    }
    if (this.state.quizInsertArr.length > 0) {
      tempInsertArr = this.state.quizInsertArr;
    }
    var orderCount = this.state.quizInfoArr.length;
    // for(var )

    console.debug('this.state.categories = ', this.state.categories);
    var tempCategoriesSet = this.state.categoriesSet;
    //BUg id 171
    var isDataFound = false;
    var foundDataDetails = '';
    var foundDataCount = 1;
    var tempCategoryDetailsMap = this.state.categoryDetailsMap;
    var tempCategoriesUniqueArr = this.state.categoriesUniqueArr;

    for (let i = 0; i < this.state.subcategoriesSelected.length; i++) {
      if (this.state.subcategoriesSelected[i].checked === true) {
        //if(categortyId == this.state.subcategoriesSelected[i].category_id){

        var tempQuizInfo = {};
        var tempCatId =  this.state.subcategoriesSelected[i].subject_id +
        '_' +
        this.state.subcategoriesSelected[i].topic_id +
        '_' +
        this.state.subcategoriesSelected[i].category_id;

        var index =
          this.state.subcategoriesSelected[i].subject_id +
          '_' +
          this.state.subcategoriesSelected[i].topic_id +
          '_' +
          this.state.subcategoriesSelected[i].category_id +
          '_' +
          this.state.subcategoriesSelected[i].subcategory_id;

        tempCategoriesSet.add(
          this.state.subcategoriesSelected[i].subject_id +
            '_' +
            this.state.subcategoriesSelected[i].topic_id +
            '_' +
            this.state.subcategoriesSelected[i].category_id
        );
        if (!this.isArrayObjectFound(tempQuizInfoArr, index)) {
          var tempCategoryName = '';

          for (var cat = 0; cat < this.state.categories.length; cat++) {
            if (
              this.state.categories[cat].category_id ===
              this.state.subcategoriesSelected[i].category_id
            ) {
              tempCategoryName = this.state.categories[cat].category_name;
              console.debug(
                'this.state.categories = ',
                this.state.categories[cat]
              );
            }
          }
          orderCount = orderCount + 1;

          tempQuizInfo['subject_id'] = this.state.subcategoriesSelected[
            i
          ].subject_id;
          tempQuizInfo['topic_id'] = this.state.subcategoriesSelected[
            i
          ].topic_id;
          tempQuizInfo['category_id'] = this.state.subcategoriesSelected[
            i
          ].category_id;
          tempQuizInfo['subcategory_id'] = this.state.subcategoriesSelected[
            i
          ].subcategory_id;
          tempQuizInfo['index'] = index;
          tempQuizInfo['order'] = orderCount;
          tempQuizInfo['question_count'] = this.state.subcategoriesSelected[
            i
          ].question_count;
          tempQuizInfo['subcategory_name'] = this.state.subcategoriesSelected[
            i
          ].subcategory_name;
          tempQuizInfo['category_name'] = tempCategoryName;
          tempQuizInfo['randomize_questions'] = 1;
          tempQuizInfo['random_subcategory_order'] = 1;
          tempQuizInfo['subcategory_weight'] = 1;
          tempQuizInfo['non_graded'] = 0;
          tempQuizInfo['category_mastery_count'] = 0;
          tempQuizInfo['category_is_required'] = 1;
          tempQuizInfo['category_at_last'] = 0
          tempQuizInfo['category_at_begining'] = 0
          
          tempQuizInfoArr.push(tempQuizInfo);
          tempInsertArr.push(tempQuizInfo);

          if(tempCategoriesUniqueArr.includes(tempCatId) !== true){
            
            tempCategoriesUniqueArr.push(tempCatId);  

          }

          tempCategoryDetailsMap[tempCatId] = tempQuizInfo;
          

        } else {
          var AlertTempCategoryName = '';
          for (
            var catData = 0;
            catData < this.state.categories.length;
            catData++
          ) {
            if (
              this.state.categories[catData].category_id ===
              this.state.subcategoriesSelected[i].category_id
            ) {
              AlertTempCategoryName = this.state.categories[catData]
                .category_name;
            }
          }
          isDataFound = true;
          foundDataDetails +=
            foundDataCount +
            '. ' +
            this.state.subcategoriesSelected[i].subcategory_name +
            ' of ' +
            AlertTempCategoryName +
            '\n ';
          foundDataCount++;
          // alert(
          //   ' This category of subcategory already exists ' +
          //     this.state.subcategoriesSelected[i].subcategory_name
          // );
        }
        //}
        //bug-tracker#238
        let subCategoriesSelectedLocal = this.state.subcategoriesSelected;
        subCategoriesSelectedLocal[i].checked = false;
        this.setState({subcategoriesSelected:subCategoriesSelectedLocal});
      }
    }
    //bug-tracker#238
    let categorySelectedLocal =  this.state.categorySelected;
    for (let i = 0; i < categorySelectedLocal.length; i++)
    {
      categorySelectedLocal[i].checked = false;
      categorySelectedLocal[i].rowSelectedCategory = false;
    }
    this.setState({categorySelected:categorySelectedLocal})
    //bug-tracker#238 END
    if (isDataFound === true) {
      alert(
        'The following subcategories are already in the selected list. \n ' +
          foundDataDetails +
          '\n Please remove the above from your left menu selection.'
      );
    }
    console.debug('tempAddedQuizData = ', tempAddedQuizData);
    console.debug('tempQuizInfo = ', tempQuizInfoArr);
    console.debug('tempInsertArr = ', tempInsertArr);
    console.debug('tempCategoriesSet.length = ', tempCategoriesSet.size);
    console.debug('tempCategoriesUniqueArr = ', tempCategoriesUniqueArr);
    console.debug('tempCategoryDetailsMap = ', tempCategoryDetailsMap);
    this.setState({
      //addedQuizSubDivList:tempAddedQuizData,
      //BUg id 172
      quizInfoArr: tempQuizInfoArr,
      quizInsertArr: tempInsertArr,
      categoriesSet: tempCategoriesSet,
      masteryUnit: tempCategoriesSet.size,
      categoriesUniqueArr:tempCategoriesUniqueArr,
      categoryDetailsMap:tempCategoryDetailsMap
      //categories: []
    },()=>{
      this.rearrangeCategoryOrder()
    });
  }

   getOrderCategoryArr(quizInfoArr) {
    let catOrderMap = this.getCatOrderMap(quizInfoArr);
    let orderValid = this.logicCheckforFindingNeighbours(catOrderMap);
    let catOrderArr = this.state.categoriesUniqueArr;
    if (orderValid) {
      let catDisorderArr = [];
      Object.keys(catOrderMap).forEach(function (key) {
        let catOrderIndex = Math.min(...catOrderMap[key]);
        catDisorderArr[catOrderIndex] = key;
      });
      let newCatOrderedArr = [];
      catDisorderArr.forEach((value) => {
        if (value !== undefined) {
          newCatOrderedArr.push(value);
        }
      });
      catOrderArr = newCatOrderedArr;
    }
    return catOrderArr;
  }

  getCatOrderMap(quizInfoArr){
    let tempCatHashMap = {};
    (quizInfoArr).forEach(quizInfo=>{
      let catKey = `${quizInfo.subject_id}_${quizInfo.topic_id}_${quizInfo.category_id}`;
      if(!tempCatHashMap[catKey]){
        tempCatHashMap[catKey]  = []
      }
      tempCatHashMap[catKey].push(quizInfo.order);
    })
    return tempCatHashMap
  }

  moveRow(index, isGoingUp, thisObj) {
    console.debug('moveRow index', index);
    console.debug('moveRow isGoingUp ', isGoingUp);
    console.debug('moveRow thisObj', thisObj);
    console.debug('quizInsertArr', this.state.quizInsertArr);
    console.debug('quizInfoArr', this.state.quizInfoArr);

    var tempOrderArr = [];
    var tempQuizInfoArr = this.state.quizInfoArr;
    var arrLength = tempQuizInfoArr.length;

    for (var i = 0; i < tempQuizInfoArr.length; i++) {
      console.debug('tempQuizInfoArr = ', tempQuizInfoArr[i]);
      var swipeIndex = -1;
      if (tempQuizInfoArr[i].index === index) {
        swipeIndex = i;
      }
      if (isGoingUp === true) {
        console.debug('swipeIndex = ', swipeIndex);
        if (swipeIndex !== -1) {
          let j = i - 1;
          if (j !== -1) {
            let tempQuizData_key = tempQuizInfoArr[j];
            //let tempQuizData_order = tempQuizInfoArr[i].order;

            console.debug('tempQuizInfoArr[j] = ', tempQuizInfoArr[j]);
            console.debug('tempQuizInfoArr[j] = ', tempQuizInfoArr[i].order);
            //console.debug('tempQuizData_order= ', tempQuizData_order);
            //tempQuizInfoArr[i].order = tempQuizInfoArr[j].order;
            tempQuizInfoArr[j] = tempQuizInfoArr[i];

            tempQuizInfoArr[i] = tempQuizData_key;
            //tempQuizInfoArr[i].order = tempQuizData_order;

            console.debug('tempQuizInfoArr = ', tempQuizInfoArr);
            tempOrderArr.push(tempQuizInfoArr[j]);
            tempOrderArr.push(tempQuizInfoArr[i]);

            break;
          }
        }
      } else if (isGoingUp === false) {
        if (swipeIndex !== -1) {
          let j = i + 1;
          console.debug('j  = ', j);
          if (j < arrLength) {
            let tempQuizData_key = tempQuizInfoArr[j];
            //let tempQuizData_order = tempQuizInfoArr[i].order;

            //tempQuizInfoArr[i].order = tempQuizInfoArr[j].order;
            tempQuizInfoArr[j] = tempQuizInfoArr[i];

            tempQuizInfoArr[i] = tempQuizData_key;
            //tempQuizInfoArr[i].order = tempQuizData_order;

            console.debug('tempQuizInfoArr order change = ', tempQuizInfoArr);
            tempOrderArr.push(tempQuizInfoArr[j]);
            tempOrderArr.push(tempQuizInfoArr[i]);

            break;
          }
        }
      }
    }
    console.debug('tempOrderArr = ', tempOrderArr);
    console.debug('this.state.quizInfoArr', this.state.quizInfoArr);
    //For fixing the order while moving up/down
    tempQuizInfoArr.map((v,index)=>{
      v.order = index + 1;
      return v;
    });
    let catOrderArr = this.getOrderCategoryArr(tempQuizInfoArr);
    this.setState({ 
      quizInfoArr: tempQuizInfoArr, 
      categoriesUniqueArr: catOrderArr
    });
  }

  checkBoxCategoryOnChange(i) {
    console.debug('checkBoxCategoryOnChange', i);
    var tempCategorySelected = [];
    tempCategorySelected = this.state.categorySelected;
    if (tempCategorySelected[i] !== undefined) {
      if (tempCategorySelected[i].checked) {
        tempCategorySelected[i].checked = false;
      } else {
        tempCategorySelected[i].checked = true;
      }
      this.setState({ categorySelected: tempCategorySelected });
    }
  }

  checkBoxSubcategoryOnChange(thisobj, subcatId) {
    console.debug('checkBoxSubcategoryOnChange', subcatId);
    console.debug('checkBoxSubcategoryOnChange obj', thisobj);
    var index = thisobj;
    var tempSubcategorySelected = [];
    tempSubcategorySelected = this.state.subcategoriesSelected;

    if (tempSubcategorySelected[index] !== undefined) {
      if (tempSubcategorySelected[index].checked) {
        tempSubcategorySelected[index].checked = false;
      } else {
        tempSubcategorySelected[index].checked = true;
      }
      this.setState({ subcategoriesSelected: tempSubcategorySelected });
    }
  }

  checkBoxRandomizeCategoryOnChange(i) {
    console.debug('checkBoxRandomizeCategoryOnChange = ', i);
    console.debug('categorySelected = ', this.state.categorySelected);
    console.debug('rowDispalyArrow = ', this.state.rowDispalyArrow);
    var tempCategorySelected = [];
    tempCategorySelected = this.state.categorySelected;

    var tempSubgcategoriesSelected = [];
    tempSubgcategoriesSelected = this.state.subcategoriesSelected;

    if (tempCategorySelected[i] !== undefined) {
      if (tempCategorySelected[i].randomizeCategory) {
        tempCategorySelected[i].randomizeCategory = false;
        console.debug('tempCategorySelected= ', tempCategorySelected);

        for (var j = 0; j < tempSubgcategoriesSelected.length; j++) {
          //console.debug("tempSubgcategoriesSelected [j].category_id = ",tempSubgcategoriesSelected[j].category_id);
          console.debug(
            'tempCategorySelected [j].category_id = ',
            tempCategorySelected[i].key
          );
          if (
            tempSubgcategoriesSelected[j].category_id ===
            tempCategorySelected[i].key
          ) {
            tempSubgcategoriesSelected[j].subcategory_randomize = false;
          }
        }
      } else {
        tempCategorySelected[i].randomizeCategory = true;
        for (let j = 0; j < tempSubgcategoriesSelected.length; j++) {
          console.debug(
            'tempSubgcategoriesSelected [j].category_id = ',
            tempSubgcategoriesSelected[j].category_id
          );
          console.debug(
            'tempSubgcategoriesSelected [j].category_id = ',
            tempCategorySelected[i].category_id
          );
          if (
            tempSubgcategoriesSelected[j].category_id ===
            tempCategorySelected[i].key
          ) {
            tempSubgcategoriesSelected[j].subcategory_randomize = true;
          }
        }
      }
      this.setState({
        categorySelected: tempCategorySelected,
        subcategoriesSelected: tempSubgcategoriesSelected
      });
      console.debug('tempSubgcategoriesSelected =', tempSubgcategoriesSelected);
      console.debug('tempCategorySelected =', tempCategorySelected);
    }
  }

  checkBoxRandomizeSubcategoryOnChange(i, thisobj) {
    console.debug('subcategory_randomize', i);

    var tempQuizInfoArr = this.state.quizInfoArr;
    if (tempQuizInfoArr[i] !== undefined) {
      //console.debug("randomize_questions",tempQuizInfoArr[i].randomize_questions);
      if (tempQuizInfoArr[i].randomize_questions === 1) {
        tempQuizInfoArr[i].randomize_questions = 0;
      } else {
        tempQuizInfoArr[i].randomize_questions = 1;
      }
      // console.debug("randomize_questions =",tempQuizInfoArr[i].randomize_questions);
      // console.debug("randomize_questions = ",tempQuizInfoArr);

      this.setState({ quizInfoArr: tempQuizInfoArr });
    }

    //var tempSubgcategoriesSelected = this.state.subcategoriesSelected;

    // if(tempSubgcategoriesSelected[i] !== undefined){
    //   console.debug("subcategory_randomize",tempSubgcategoriesSelected[i].subcategory_randomize);
    //   if(tempSubgcategoriesSelected[i].subcategory_randomize == true){
    //     console.debug("subcategory_randomize is true");
    //     tempSubgcategoriesSelected[i].subcategory_randomize = false;
    //   } else{
    //     tempSubgcategoriesSelected[i].subcategory_randomize = true;
    //   }
    //   console.debug("subcategory_randomize =",tempSubgcategoriesSelected[i].subcategory_randomize);
    //   console.debug("subcategory_randomize = ",tempSubgcategoriesSelected);

    //   this.setState({subcategoriesSelected:tempSubgcategoriesSelected});
    // }
  }

  dropfilesHandler(referenceString, selection, files) {
    if (files[0].type.includes('image')) {
      let urlCreator = window.URL || window.webkitURL;
      let imageUrl = urlCreator.createObjectURL(files[0]);
      this.setImage(imageUrl, this.refs[referenceString]);
    }
  }

  onSplashScreenTextChange = value => {
    this.setState({ splashTextEditorObj: value });
    console.debug("value =  ", value);
    let enteredString = RichTextEditor.getHTMLStringFromEditorState(value);
    console.debug(enteredString,enteredString.toString());
    if (enteredString !== null) {
      this.setState({ splashScreenText: enteredString });
    }
    var imgTagCount = enteredString.split('<img ').length-1
    if(imgTagCount >= 1){
      this.setState({ 
        altSplashScreenTextVisible : true,
        imgTagCount :imgTagCount
      })
    }
    if(imgTagCount < 1){
      this.setState({ 
        altSplashScreenTextVisible : false,
        imgTagCount: imgTagCount,
      })
     //this.onAltAnswerChange('')
    }
    console.debug('splashScreenText =' + this.state.splashScreenText);
    // if (this.props.onChange) {

    //   this.props.onChange(
    //     value.toString('html')
    //   );
    // }
  };
  onAltSplashScreenTextChange = value => {
    this.setState({ altSplashScreenObj: value });
    console.debug("value =  ", value);
    let enteredString = this.state.altSplashScreenObj
    console.debug(enteredString.toString());
    if (enteredString !== null) {
      this.setState({ altSplashScreenText: value });
    }
  };

  handleChangeStartDate(timeString, sDate, event) {
    if (sDate !== null) {
      this.setState({
        startDate: moment(sDate)
      });
    }
  }

  handleChangeEndDate(eDate, id) {
    if (eDate !== null) {
      let date = moment(eDate)
      if (id === "date") {
        date.set({"h": 23,"m": 59})
      }
      this.setState({
        endDate: date
      });
    }
  }
  assignmentNameOnChange(e) {
    console.debug('assignmentNameOnChange', e);
    //console.debug("assignmentNameOnChange",e.target.value);
    var tempAssignmentName = e;
    this.setState({
      assignmentName: tempAssignmentName
    });
  }
  masteryConditionOnChange(e) {
    console.debug('masteryConditionOnChange', e.target.value);

    
    if(parseInt(e.target.value,10) <= 0){
      alert("Mastery condition should be greater than zero.");
      return;
    }
    var tempMasteryCondition = e.target.value;
    this.setState({
      masteryCondition: tempMasteryCondition
    });
  }
  masteryUnitOnChange(e) {
    console.debug('masteryUnitOnChange', e.target.value);
    var tempMasteryUnit = e.target.value;
    this.setState({
      masteryUnit: tempMasteryUnit
    });
  }
  maximumAttendPerQuestionOnChange(e) {
    console.debug('maximumAttendPerQuestionOnChange', e.target.value);
    var tempMaximumAttendPerQuestion = e.target.value;
    this.setState({
      maximumAttendPerQuestion: tempMaximumAttendPerQuestion
    });
  }
  noCQCOnChange(e) {
    console.debug('noCQCOnChange', e.target.value);
    var tempNOCQC = e.target.value;
	let tempCategoryDetailsMap = this.state.categoryDetailsMap
	let quizInfoArr = this.state.quizInfoArr
	for (var i = 0; i < quizInfoArr.length; i++) {
		let catID = quizInfoArr[i].subject_id + "_" + quizInfoArr[i].topic_id + "_" + quizInfoArr[i].category_id
		if(tempCategoryDetailsMap[catID].category_nocqc ===undefined || tempCategoryDetailsMap[catID].category_nocqc === "" || tempCategoryDetailsMap[catID].category_nocqc === this.state.NOCQC){
			tempCategoryDetailsMap[catID].category_nocqc = tempNOCQC
		}
	}
    this.setState({
      NOCQC: tempNOCQC,
	  categoryDetailsMap: tempCategoryDetailsMap
    });
  }

  lockOutNChange = (e) => {
    var tempLockOutN = e.target.value
    this.setState({
      LockOutN: tempLockOutN
    });
  }
  quizORTestOnChange(e) {
    //1- QUIZ 2- TEST
    console.log("quizORTestOnChange",e.target.checked);
    if(e.target !== undefined && e.target.checked !== undefined)
    {
      this.setState({quizORTest:e.target.checked,
        allowPractice: !e.target.checked,
        isTestTimerEnabled:false,testTimerValue:0});
    }
   
    /*if (tempQuizORTest === false) {
      this.setState({ quizORTest: true,
        isTest: true,
        isTestTimer:'0',
       });
    } else {
      this.setState({ quizORTest: false,
        isTest: false,
        isTestTimer:'', });
    }
    */
  }
  toggleFullTestQuestion = (event) => {
    let isChecked = event.target.checked;
    this.setState({
      onePageMode: isChecked
    })
  }
  isAbsoluteTimerOnChange(e){
    
    if(e.target !== undefined && e.target.checked !== undefined)
    {
      this.setState({isAbsoluteTimerEnabled: e.target.checked});

}    }


  nonGradedOnChange(e) {
    // console.log("Non Graded Onchange",e.target.checked);
    if(e.target !== undefined && e.target.checked !== undefined)
    {
      this.setState({Is_Nongraded:e.target.checked})
    }
  }
  handleToggleAnonymous = (e) => {
    if(e.target !== undefined && e.target.checked !== undefined)
    {
      this.setState({isAnonymous:e.target.checked})
    }
  }

  handleToggleAllowPartialCredit = (e) => {
    if(e.target !== undefined && e.target.checked !== undefined)
    {
      this.setState({allowPartialCredit:e.target.checked})
    }
  }

  handleToggleAllowPauseCategory = (e) => {
    if(e.target !== undefined && e.target.checked !== undefined)
    {
      this.setState({allowPauseCategory:e.target.checked})
    }
  }
          
  testTimerOnChange(e) {
    //0-is not  test  1- TEST
    /*console.debug('testTimerOnChange', e.target.value);
    var tempIsTestTimer = e.target.value;
    this.setState({
      testTimerValue: tempIsTestTimer
    });
    console.debug('testTimerOnChange', tempIsTestTimer); */

    if(e.target !== undefined && e.target.value !== undefined)
    {
      this.setState({
        testTimerValue: parseInt(e.target.value,10)
      });
    }
  }
  isTestTimerOnChange(e) {
    //0-is not  test  1- TESt
    /*var tempIsTest = this.state.isTest;
    console.debug('isTestOnChange', tempIsTest);
    if (tempIsTest === false) {
      this.setState({ isTest: true,
      isTestTimer:'0',
      quizORTest: true });
      
    } else {
      this.setState({ isTest: false,
        quizORTest: false,
        isTestTimer:'' });
    }*/

    if(e.target !== undefined && e.target.checked !== undefined)
    {
      this.setState({isTestTimerEnabled:e.target.checked});
    }
  }
  FullMarkOptionOnChange(e) {
    if(e.target !== undefined && e.target.checked !== undefined)
    {
      this.setState({isFullMarkOptionEnabled:e.target.checked});
      console.log("FULLMARKOPTIONENABLED",e.target.checked)
    }
  }

  EnableSubsectionOnChange(e) {
    if(e.target !== undefined && e.target.checked !== undefined);
    {
      if(this.appProperties.enableLTI){
        if(e.target.checked === true){
          this.setState({isEnableSubsectionLTI:e.target.checked });
        }else{
          let tempSection = this.state.subsectionList
          let Subsections = []
          tempSection.forEach((subsection) => Subsections.push({label: subsection.label, id: subsection.id, value: false }) );
          this.setState({isEnableSubsectionLTI:e.target.checked, subsectionList: Subsections });
        }
      }else{
        let tempSection = this.state.sections;
        let sections = [];
        tempSection.forEach((section) => sections.push({label: section.label, id: section.id, value: false }) );

        this.setState({sections: sections, propSections: sections, selectedSectionAndSubsectionList: [], 
                        selectedSectionIDInAdd : 0,subsectionList: [], isSubmitEnable: false })

        this.setState({isEnableSubsection:e.target.checked});
      }
       
    }
  }

  randomizeCategoriesOnChange(e) {
    //1- Yes  2- No
    console.debug('randomizeCategoriesOnChange', e);
    var tempRandomizeCategoriesOnChange = parseInt(e, 10);
    this.setState({
      randomizeCategories: tempRandomizeCategoriesOnChange
    });
  }

  orderCheck = (a) => {
    for (let i = 0; i < a.length - 1; i++) {
      if (  a[i] + 1 != a[i+1]) {
          return false; 
      }
    }

    return true;
  }

  logicCheckforFindingNeighbours = (catMap) => {
    let valid = [];
    Object.keys(catMap).map((key)=>{
      valid.push(this.orderCheck(catMap[key]));
    });

    if(valid.includes(false)){
      return false;
    }

    return true;
  }

  SubCategoryCheck = (isTest, quizInfoArr) => {
    let error =0;
      for(let i=0;i<quizInfoArr.length;i++){
        if (isTest && quizInfoArr[i].subcategory_weight > quizInfoArr[i].question_count){
            NotificationManager.error(`You have entered NOCQSC more than the available # of questions in the subcategory, ${quizInfoArr[i].subcategory_name}`, 'Error', 3000);
            error++;
        }else if(quizInfoArr[i].subcategory_weight > 1000){
			NotificationManager.error('Subcategories NOCQSC should be less then or equal to 1000');
			error++;
		}
      }
      if(error > 0){
        return true;
      }
    return false;
  }

  specialCharacterValidation=(str)=>{
    var response = ['/', '\\','*' ,':' ,',' ,'@' ,'&' ,'%' ,'$' ,'#' ,'!'].some(element => str.includes(element));
    return response
  }

  checkForOnePageModeValidation = () => {
    console.debug("this.state", this.state)
    if (this.state.randomizeCategories === 1) {
      NotificationManager.error('Please turn off Random category order ', 'One Page Test Mode', 5000);
      return false;
    }

    for (let i = 0; i < this.state.quizInfoArr.length; i++) {
      const quizInfo = this.state.quizInfoArr[i];
      if (quizInfo.randomize_questions === 1) {
        NotificationManager.error(`Please turn off random question order for the category - "${quizInfo.category_name}"`, 'One Page Test Mode', 5000);
        return false;
      }
    }

    let keys = Object.keys(this.state.categoryDetailsMap);
    for (let i = 0; i < keys.length; i++) {
      const categoryDetail = this.state.categoryDetailsMap[keys[i]];
      if (categoryDetail.random_subcategory_order === 1) {
        NotificationManager.error(`Please turn off random subcategory order for the category - "${categoryDetail.category_name}"`, 'One Page Test Mode', 5000);
        return false;
      }
    }

    let totalQuestionCount = 0;

    let categoryTotalQuestions = {};

    this.state.quizInfoArr.forEach(info => {
      let key = `${info.subject_id}_${info.topic_id}_${info.category_id}`
      if (categoryTotalQuestions[key]) {
        categoryTotalQuestions[key] += info.question_count;
      } else {
        categoryTotalQuestions[key] = info.question_count;
      }
    })

    for (let i = 0; i < keys.length; i++) {

      const categoryDetail = this.state.categoryDetailsMap[keys[i]];
      if (categoryDetail.category_number_of_questions) {
        totalQuestionCount += categoryDetail.category_number_of_questions;  
      } else {
        totalQuestionCount += categoryTotalQuestions[keys[i]];
      }
      
    }
    console.debug("totalQuestionCount>>>", totalQuestionCount)

    if (totalQuestionCount > MAX_QUESTION_COUNT_FOR_ONE_PAGE_TEST) {
      NotificationManager.error(`Total no. of questions supported is less than or equal to ${MAX_QUESTION_COUNT_FOR_ONE_PAGE_TEST}. But you have added ${totalQuestionCount} questions`, 'One Page Test Mode', 5000);
      return false;
    }

    return true;
  }

  createQuiz(shouldPublish) {
    console.debug('Create quiz on click');
	   
    var assignmentName = this.state.assignmentName;
    if (assignmentName.trim() === '') {
      NotificationManager.error('Assignment Name cannot be empty', 'ERROR', 3000);
      return;
    }
    if(this.specialCharacterValidation(assignmentName.trim())){
      NotificationManager.error('Assignment Name cannot contain( /, \\, * , : , comma ,@ , & , % , $ , # , !)', 'ERROR', 3000);
      return;
    }

    //bug-tracker#268
    let testTimerValueLocal = this.state.testTimerValue;
    let isTestTimerEnabledLocal = this.state.isTestTimerEnabled;
    if (isTestTimerEnabledLocal && (isNaN(testTimerValueLocal) || testTimerValueLocal <= 0)) {
      NotificationManager.error('Please add a Test Time, It cannot be Zero', 'ERROR', 3000);
      return;
    }

    var startDate = '';
    var endDate = '';
    var startTime = '';
    var endTime = '';
    var tempstartDate = '';
    var tempEndDate = '';

    if (this.state.startDate !== null && this.state.startDate !== '') {
      tempstartDate = this.state.startDate;

      startDate = tempstartDate.format('DD/MM/YYYY');
      tempstartDate = tempstartDate.format('DD/MM/YYYY HH:mm').split(' ');
      startTime = tempstartDate[1];
    }
    else {
      NotificationManager.error('Start date should not be empty');
      return;
    }
    //else{
    //   startDate =  this.state.defaultStartDate;
    // }
    if (this.state.endDate !== null && this.state.endDate !== '') {
      tempEndDate = this.state.endDate;

      endDate = tempEndDate.format('DD/MM/YYYY');
      tempEndDate = tempEndDate.format('DD/MM/YYYY HH:mm').split(' ');
      endTime = tempEndDate[1];
    }
    else {
      NotificationManager.error('End date should not be empty');
      return;
    }
    // else{
    //   endDate = this.state.defaultEndDate;
    // }

    var masteryCondition = parseInt(this.state.masteryCondition, 10);
    var masteryUnit = parseInt(this.state.masteryUnit, 10);
    var maximumAttendPerQuestion = parseInt(
      this.state.maximumAttendPerQuestion,
      10
    );
    var tempQuizORTest = 0;
    if (this.state.quizORTest) {
      tempQuizORTest = 1;
    }
    var selectedSubjectID = this.state.subjectId;
    var top_id = parseInt(this.state.topicId, 10);

    var sectionId = parseInt(this.props.location.query.section_id, 10);
    var courseId = parseInt(this.props.location.query.course_id, 10);

    var quizInfoArr = [...this.state.quizInfoArr];
    if(quizInfoArr.length === 0){
      NotificationManager.error('Atleast one subcategory should be added to the assignment');
      return
      ;
    }
	if(masteryCondition > 1000){
		NotificationManager.error('Default Mastery should be less then or equal to 1000');
     	return;
	}
	if(maximumAttendPerQuestion > 1000){
		NotificationManager.error('Max. attempts should be less then or equal to 1000');
     	return;
	}
    //TODO:
    let tempCatHashMap = {};
    var isDuplicateSubcategoryCounter = 0;
    var isDuplicateSubcategoryString = "";
    let uniqueIDArr = [];
	let tempCatQuestionCount = {};
    (quizInfoArr).forEach(quizInfo=>{
      let key = quizInfo.subject_id+"_"+quizInfo.topic_id+"_"+quizInfo.category_id+"_"+quizInfo.subcategory_id
      let catKey = `${quizInfo.subject_id}_${quizInfo.topic_id}_${quizInfo.category_id}`;
	  if(tempCatQuestionCount[catKey] === null || tempCatQuestionCount[catKey] === undefined){
		tempCatQuestionCount[catKey] = quizInfo.question_count
	  }else{
		tempCatQuestionCount[catKey] = tempCatQuestionCount[catKey] + quizInfo.question_count
	  }
      if(!tempCatHashMap[catKey]){
        tempCatHashMap[catKey]  = []
      }
      tempCatHashMap[catKey].push(quizInfo.order);
      if(uniqueIDArr.includes(key)){
        isDuplicateSubcategoryCounter++
        isDuplicateSubcategoryString = isDuplicateSubcategoryString +  
          isDuplicateSubcategoryCounter +". "+quizInfo.subcategory_name +
          ' of ' +  quizInfo.category_name + ".\n";
          console.log("Duplicate Key= "+key);
      }
      uniqueIDArr = [...uniqueIDArr, key] 
    })

    console.log("tempCatHashMap", tempCatHashMap);
    let orderValid = this.logicCheckforFindingNeighbours(tempCatHashMap)
    if(!orderValid){
      NotificationManager.error('Please ensure that all the subcategories of a category are placed sequentially next to each other and are not spread out.', 'Invalid Subcategory Order', 10000);
      return
    }

    let isSubcategoryOptionError = this.SubCategoryCheck(this.state.quizORTest, quizInfoArr)

    if(isSubcategoryOptionError) {
      return
    }

    let isCategoryOptionsError = this.CategoryCheck(this.state.quizORTest, tempCatQuestionCount)

    if(isCategoryOptionsError) {
      return
    }

    if(isDuplicateSubcategoryCounter >0){
      alert(subcategoryDuplicateErrorMessageStart +
      isDuplicateSubcategoryString +
      subcategoryDuplicateErrorMessageEnd);
      return;
    }

    var tempRandomizeCategories = this.state.randomizeCategories;

    var testTimerEnabled = 0;
    if (this.state.isTestTimerEnabled === true) {
      testTimerEnabled = 1;
    } else {
      testTimerEnabled = 0;
    }
    //Option to give Full mark if Toggle button enabled
    var fullScoreIfAttempted = 0;
    if (this.state.isFullMarkOptionEnabled === true) {
      fullScoreIfAttempted = 1;
    } else {
      fullScoreIfAttempted = 0;
    }
    // is Is_Nongraded

    var is_nongraded = 0
    if (this.state.Is_Nongraded === true) {

      is_nongraded = 1
    } else {
      is_nongraded = 0
    }
    //
    var fixedAbsoluteTimeEnabled = 0;
    if (this.state.isAbsoluteTimerEnabled === true && this.state.isTestTimerEnabled === true){
      fixedAbsoluteTimeEnabled = 1;
    }else{
      fixedAbsoluteTimeEnabled = 0;
    }
    var tempIsTestTimer = this.state.testTimerValue;

    // console.debug("endDate = ",startDate.format('DD MM YYYY'));
    // console.debug("startDate = ",endDate.format('DD MM YYYY'));

    console.debug('assignmentName = ', assignmentName);
    console.debug('masteryCondition = ', masteryCondition);
    console.debug('masteryUnit = ', masteryUnit);
    console.debug('maximumAttendPerQuestion = ', maximumAttendPerQuestion);
    console.debug('quizORTest = ', tempQuizORTest);

    console.debug('quizInfoArr On save = ', quizInfoArr);
    console.debug('startDate = ', startDate);
    console.debug('endDate = ', endDate);
    console.debug('startTime = ', startTime);
    console.debug('endTime = ', endTime);

    var tempSection = this.state.sections;
    let tempInsertSection = [];
    
    let EnableSubsectionLTI =  this.state.isEnableSubsectionLTI;
    let SubsectionLTI = this.state.subsectionList;
    let tempSectionLTI = [];
    if(EnableSubsectionLTI){
      tempSection.map((section) => {
        if(section.value === true && section.id === this.state.selectSectionID){
          SubsectionLTI.map((subsection) => {
            if(subsection.value === true){
              let tempObj = {}
              tempObj['id'] = section.id;
              tempObj['label'] = section.label;
              tempObj['value'] = section.value;
              tempObj['course_id'] = courseId;
              tempObj['semester_id'] = sectionId;
              tempObj['subsection_id'] = subsection.id;
              tempSectionLTI.push(tempObj);
            };
        })
        }
      });
    };
    console.log('subsectionLTI', tempSectionLTI,SubsectionLTI,tempSection)

    for (var i = 0; i < tempSection.length; i++) {
      console.log('this.state.for',tempSection[i], '---', tempSection[i].value === true, tempSection[i].value )
      if (tempSection[i].value === true) {
        let tempInsert = {};
        tempInsert['id'] = tempSection[i].id;
        tempInsert['label'] = tempSection[i].label;
        tempInsert['value'] = tempSection[i].value;
        tempInsert['course_id'] = courseId;
        tempInsert['semester_id'] = sectionId;
        tempInsertSection.push(tempInsert);
      }
    }

    // Only for Update Quiz
    let tempUpdateSection = [];
    tempSection.forEach((section) => {
      if (section.value === true){
        let tempInsert = {};
        tempInsert['id'] = section.id;
        tempInsert['label'] = section.label;
        tempInsert['value'] = section.value;
        tempInsert['course_id'] = courseId;
        tempInsert['semester_id'] = sectionId;
        tempUpdateSection.push(tempInsert);
      }
    });

    console.log('this.state.for.s1', tempSection,tempUpdateSection);
    console.log('this.state.for.s', tempSection,tempInsertSection);
    if(tempInsertSection.length <= 0 && !this.state.isEnableSubsection){
      console.log("tempInsertSection.length",tempInsertSection.length);
      NotificationManager.error('Please add atleast one section', 'ERROR', 3000);
      return;

    }

    var tempSplashScreenText = this.state.splashScreenText;
    var tempAltSplashScreenText = this.state.altSplashScreenText;  
    var tempNOCQC = parseInt(this.state.NOCQC, 10);
    var tempLockOutN = parseInt(this.state.LockOutN, 10);


	if(tempNOCQC > 1000){
		NotificationManager.error('NOCQC should be less then or equal to 1000');
     	return;
	}
	if(tempLockOutN > 1000){
		NotificationManager.error('Lock Out should be less then or equal to 1000');
     	return;
	}

    //checking alt splash screen text
    console.debug("imgcount ",this.state.imgTagCount)
      if(this.state.imgTagCount >= 1){
        let tempaltSplashScreen = tempAltSplashScreenText
        tempaltSplashScreen = tempaltSplashScreen.replace(/\n/ig, '')
        tempaltSplashScreen = tempaltSplashScreen.replace(/ /g,'')
        let attrTextArr = tempaltSplashScreen.split(';')
        attrTextArr = attrTextArr.filter(function (el) {
          return el !== "";
        });
        console.debug(attrTextArr)
        var attrTextCount = attrTextArr.length
      console.debug(tempaltSplashScreen," ",(attrTextCount%2)," ",this.state.imgTagCount," === ",(attrTextCount/2),"  ",attrTextCount)
        if(tempaltSplashScreen === ''){
        alert('"Title and Alternative Text for all Images in SplashScreen" is Empty. Please enter a valid text.');
        this.setState({
          loading: false,
          saveButtonShow: true,
          loadingSave: false
        });
        return false;
      }
      if((attrTextCount%2) !== 0){
        alert('Title or Alternative text is missing in "Title and Alternative Text for all Images in SplashScreen"');
        this.setState({
          loading: false,
          saveButtonShow: true,
          loadingSave: false
        });
        return false;
      }

      if(this.state.imgTagCount !== (attrTextCount/2)){
        alert('Please enter a valid text for all images in "Title and Alternative Text for all Images in SplashScreen"');
        this.setState({
          loading: false,
          saveButtonShow: true,
          loadingSave: false
        });
        return false;
      }
      var lastChar = tempaltSplashScreen[tempaltSplashScreen.length -1];
      console.debug("last char ",lastChar)
      if(lastChar === ";"){
        alert('Please remove semicolon at the end of the text in "Title and Alternative Text for all Images in SplashScreen"');
        this.setState({
          loading: false,
          saveButtonShow: true,
          loadingSave: false
        });
        return false;
      }
    }
    //checking alt splash screen text

    //Checking if the freeChoice count is greater than the actual freeChoice category
    //let temp1CategoriesUniqueArr =  this.state.categoriesUniqueArr;
    //let temp1CategoryDetailsMap = this.state.categoryDetailsMap;
      let tempFreeChoiceCount = 0
      for(let i = 0; i < this.state.categoriesUniqueArr.length; i++){
        console.debug("temp1CategoryDetailsMap[] ",this.state.categoriesUniqueArr[i])
        if(this.state.categoryDetailsMap[this.state.categoriesUniqueArr[i]].category_is_required === 2){
          tempFreeChoiceCount++
        }
      }
      
    if(tempFreeChoiceCount < this.state.freeChoiceCount){
      NotificationManager.error('Minimum number of Free Choice Categories required to be completed should not be greater than the total number of optional categories in this assignment');
      this.setState({
        loading: false,
        saveButtonShow: true,
        loadingSave: false
      });
      return false
    }
    
    if(tempFreeChoiceCount === this.state.categoriesUniqueArr.length && this.state.freeChoiceCount < 1){
      NotificationManager.error('Since you have only optional cateories in this assignment, the Minimum number of Free Choice Categories required to be completed should be greater than 0');
      this.setState({
        loading: false,
        saveButtonShow: true,
        loadingSave: false
      });
      return false
    }

    let tempSelectedSectionAndSubsectionUp =  this.state.selectedSectionAndSubsectionList;
    let tempSelectedSectionAndSubsectionArr = []
    for(let i_section = 0 ; i_section < tempSelectedSectionAndSubsectionUp.length; i_section++){
      for (let i_subsection = 0; i_subsection < tempSelectedSectionAndSubsectionUp[i_section].subsectionList.length; i_subsection++) {
        let TempSubsectionList = {};
        if(tempSelectedSectionAndSubsectionUp[i_section].subsectionList[i_subsection].value === true){
            TempSubsectionList['id'] =  tempSelectedSectionAndSubsectionUp[i_section].id;
            TempSubsectionList['label'] =  tempSelectedSectionAndSubsectionUp[i_section].section_name
            TempSubsectionList['course_id'] =   parseInt(this.state.course_id, 10);
            TempSubsectionList['subsection_id'] =  tempSelectedSectionAndSubsectionUp[i_section].subsectionList[i_subsection].id;
            TempSubsectionList['subsection_name'] =  tempSelectedSectionAndSubsectionUp[i_section].subsectionList[i_subsection].label;
            tempSelectedSectionAndSubsectionArr.push(TempSubsectionList)
        }
      }
     }
    
    if(!this.state.isEnableLTI && this.state.isEnableSubsection && tempSelectedSectionAndSubsectionArr <= 0){
      NotificationManager.error('Please add atleast one section & subsection', 'ERROR', 3000);
      return;
    };

    if(this.state.isEnableLTI && EnableSubsectionLTI && tempSectionLTI.length <= 0){
      NotificationManager.error('Please add atleast one subsection', 'ERROR', 3000);
      return;
    }

    if(this.state.quizORTest && parseInt(this.state.NOCQC) === 1 && this.state.categoriesUniqueArr.length > 1 && this.state.NocQcqAlertPopupGrant){
      this.setState({
        NocqcAlertVisible: true,
      });
      return
    }

    let TempEnable = this.state.isEnableLTI ? EnableSubsectionLTI : this.state.isEnableSubsection;

    var categoryMasteryUnit = this.CategoryMasteryDataBuild(); 
    var categoryNocqcUnit = this.CategoryNocqcDataBuild();
    var CategoryRSOUnit = this.CategoryRandomSubcatOrderDataBuild();
    var categoryNoQUnit = this.CategoryNumberofQuestionsDataBuild();
    var categoryIsRequiredDataBuild = this.CategoryIsRequiredDataBuild();
    var categoryPositionDataBuild = this.CategoryPositionDataBuild();

    // If assignment is onePageMode, then check if total # of questions are only 20 and all randomizations are off
    if (this.state.quizORTest && this.state.onePageMode && !this.checkForOnePageModeValidation()) {
      return;
    }

    if (this.state.quiz_id == null) {
      const payload = {
        topic_id: top_id,
        subject_id: selectedSubjectID,
        quiz_name: assignmentName,
        start_date: startDate,
        start_time: startTime,
        end_date: endDate,
        end_time: endTime,
        quiz_type: tempQuizORTest,
        mastery_condition: masteryCondition,
        mastery_units: masteryUnit,
        maximum_attempted: maximumAttendPerQuestion,
        semester_id: 0,
        course_id: courseId,
        section_Id: sectionId,
        quiz_details: quizInfoArr,
        quiz_id: 0,
        testTimerEnabled: testTimerEnabled,
        fullScoreIfAttempted:fullScoreIfAttempted,
        fixedAbsoluteTimeEnabled: fixedAbsoluteTimeEnabled,
        test_time: tempIsTestTimer,
        randomize_categories: tempRandomizeCategories,
        sections_list:this.state.isEnableSubsectionLTI ? tempSectionLTI : this.state.isEnableSubsection ? tempSelectedSectionAndSubsectionArr : tempInsertSection,
        splash_screen: tempSplashScreenText,
        alt_splash_screen: tempAltSplashScreenText,
        NoCQC: tempNOCQC,
        lockoutN: tempLockOutN,
        enableSurvey:this.state.enableSurvey,
        category_number_of_questions: categoryNoQUnit,
        category_mastery_count:categoryMasteryUnit,
        category_nocqc: categoryNocqcUnit,
        random_subcategory_order: CategoryRSOUnit,
        category_is_required:categoryIsRequiredDataBuild,
        category_position:categoryPositionDataBuild,
        free_choice_count:this.state.freeChoiceCount,
        subsection_id: this.props.subSection ||  this.props.location.query.subsection === "true" ? parseInt(this.state.subsection_id,10) : 0,
        enable_subsection: TempEnable,
        is_nongraded:is_nongraded,
        allow_practice: this.state.allowPractice,
        is_anonymous: this.state.isAnonymous,
        one_page_mode: this.state.onePageMode,
        status: shouldPublish ? 1 : 0,
        allow_partial_credit: tempQuizORTest === 1 ? false : this.state.allowPartialCredit,
        allow_pause_category: tempQuizORTest === 1 ? false : this.state.allowPauseCategory,
      };
      console.log('payload',payload)

      console.debug('addQuiz = ', payload);
      this.setState({ loadingSave: true });
      ApiRequestService({
        method: 'post',
        //url: '/getAllCategories',
        url: '/addQuiz',
        data: payload
      }).then(res => {
        this.setState({ loadingSave: false });
        console.debug('Get quiz res :', res);
        console.debug(
          'this.props.location.query.sectionDashboard  :',
          this.props.location.query.sectionDashboard
        );

        console.debug('Quiz insert Error', res.data.message);
        if (
          res != null &&
          res.data != null &&
          res.data.message !== null &&
          res.data.message !== ''
        ) {
          alert(res.data.message);
          if (
            res.data.data != undefined &&
            res.data.data != null && 
            res.data.data.quiz_id != undefined &&
            res.data.data.quiz_id != null 
          ){
            console.debug("res.data.data.anonymous_link", res.data.data.anonymous_link)
            this.setState({
              quiz_id: res.data.data.quiz_id,
              DBSnapShotArr: quizInfoArr,
            });
          }
        } else {
          this.setState({
            quiz_id: res.data.data.quiz_id,
            quizInsertArr: [],
            DBSnapShotArr: quizInfoArr,
            DBSnapShotSectionArr: tempInsertSection,
            DBSnapShotSubSectionArr: tempSelectedSectionAndSubsectionArr,
            DBIsSubsectionEnable: this.state.isEnableSubsectionLTI, 
            DBIsSubsectionEnableLTi: this.state.isEnableSubsectionLTI,
            DBSnapshotSubsectionLTI: tempSectionLTI,
            anonymousLink: res.data.data.anonymous_link,
            status: shouldPublish ? 1 : 0
          });
          //alert('Saved successfully!');
          let msg = "Saved successfully!"
          if (shouldPublish && !(this.state.is_lti_enabled && JSON.parse(this.state.is_lti_enabled))) {
            msg = "Saved & Published successfully!"
          }
          NotificationManager.success(msg, 'Success', 3000);
        }
        // if (this.props.location.query.sectionDashboard === 'true') {
        //   browserHistory.push(
        //     baseFolder +
        //       '/sectionsDashboard?section_id=' +
        //       this.props.location.query.section_id +
        //       '&course_id=' +
        //       this.props.location.query.course_id +
        //       '&course_name=' +
        //       this.props.location.query.course_name +
        //       '&section_name=' +
        //       this.props.location.query.section_name
        //   );
        // } else if (this.props.location.query.section_name !== null) {
        //   browserHistory.push(
        //     baseFolder +
        //       '/quizList?section_id=' +
        //       this.props.location.query.section_id +
        //       '&course_id=' +
        //       this.props.location.query.course_id +
        //       '&course_name=' +
        //       this.props.location.query.course_name +
        //       '&section_name=' +
        //       this.props.location.query.section_name
        //   );
        //window.location =  '/quizList?section_id='+this.props.location.query.section_id+'&course_id='+this.props.location.query.course_id;
        // } else {
        //   browserHistory.push(baseFolder + '/CoursesDashboard');
        // }
      });
    } else {
      //Quiz Update

      var tempQuizInsertArr = [];
      var tempQuizDeleteArr = [];
      var tempDBSnapShotArr = [];
      var tempQuizInfoArr = [];
      var deleteArr = [];

      tempQuizDeleteArr = this.state.quizDeleteArr;
      tempDBSnapShotArr = this.state.DBSnapShotArr;
      tempQuizInfoArr = this.state.quizInfoArr;
      tempQuizInsertArr = this.state.quizInsertArr;

      console.debug('tempQuizDeleteArr = ', tempQuizDeleteArr);
      console.debug('tempDBSnapShotArr = ', tempDBSnapShotArr);
      console.debug('tempQuizInfoArr = ', tempQuizInfoArr);
      console.debug('tempDBSnapShotArr = ', tempDBSnapShotArr.len);
      console.debug('tempQuizInsertArr = ', tempQuizInsertArr);

      for (var iArr = 0; iArr < tempDBSnapShotArr.length; iArr++) {
        for (var dArr = 0; dArr < tempQuizDeleteArr.length; dArr++) {
          if (tempQuizDeleteArr[dArr] === tempDBSnapShotArr[iArr].index) {
            deleteArr.push(tempDBSnapShotArr[iArr]);
          }
        }
      }

      for (var a = 0; a < tempQuizInsertArr.length; a++) {
        for (var b = 0; b < tempQuizInfoArr.length; b++) {
          if (tempQuizInsertArr[a].index === tempQuizInfoArr[b].index) {
            //tempQuizInsertArr[a].order = tempQuizInfoArr[b].order
            tempQuizInfoArr.splice(b, 1);
          }
        }
      }

      // console.debug("deleteArr = ",deleteArr);
      // console.debug("tempQuizInsertArr = ",tempQuizInsertArr);
      let courseID = parseInt(this.props.location.query.course_id, 10);
      let sectionID = parseInt(this.props.location.query.section_id, 10);
      let quizID = parseInt(this.state.quiz_id, 10);
      let tempDBSnapShotSectionArr = this.state.DBSnapShotSectionArr;

      let tempSection = this.state.sections;
      let tempDeleteSection = [];

      console.debug('this.state.sections', tempSection);
      console.debug('tempDBSnapShotSectionArr', tempDBSnapShotSectionArr);
      if (tempDBSnapShotSectionArr !== null) {
        for (let i = 0; i < tempDBSnapShotSectionArr.length; i++) {
          for (let j = 0; j < tempSection.length; j++) {
            // console.debug(
            //   'tempDBSnapShotSectionArr[i].id',
            //   tempDBSnapShotSectionArr[i].id
            // );
            // console.debug('tempSection[j].id', tempSection[j].id);

            if (tempDBSnapShotSectionArr[i].id === tempSection[j].id) {
              if (tempSection[j].value === false) {
                var tempDelete = {};
                tempDelete['id'] = tempSection[j].id;
                tempDelete['label'] = tempSection[j].label;
                tempDelete['value'] = tempSection[j].value;
                tempDelete['course_id'] = courseID;
                tempDelete['semester_id'] = sectionID;
                tempDeleteSection.push(tempDelete);
              }
            }
          }
        }
      }
      if (tempDBSnapShotSectionArr !== null) {
        for (let i = 0; i < tempDBSnapShotSectionArr.length; i++) {
          for (let j = 0; j < tempInsertSection.length; j++) {
            if (tempDBSnapShotSectionArr[i].id === tempInsertSection[j].id) {
              //if(tempInsertSection[j].value == false){
              tempInsertSection.splice(j, 1);
              //}
            }
          }
        }
      }
      console.debug('update tempInsertSection ', tempInsertSection);
      console.debug('update tempDeleteSection ', tempDeleteSection);

        let tempDBSnapShotSubSectionArr =  this.state.DBSnapShotSubSectionArr;

        let tempSubSection = tempSelectedSectionAndSubsectionArr;
        let tempDeleteSectionAndSubSection = [];
        let tempInsertSectionAndSubSection = [];

        if(this.state.isEnableSubsection && this.state.isEnableSubsection === this.state.DBIsSubsectionEnable){
          tempDeleteSectionAndSubSection = tempDBSnapShotSubSectionArr.filter(({ subsection_id: subID1 }) => !tempSubSection.some(({ subsection_id: subID2 }) => subID1 === subID2));

          tempInsertSectionAndSubSection = tempSubSection.filter(({subsection_id: subID1 }) => !tempDBSnapShotSubSectionArr.some(({subsection_id: subID2}) => subID1 == subID2));
  
        }
        // LTI MODE
        let tempDBSnapShotSubSectionLTI =  this.state.DBSnapshotSubsectionLTI;
        let tempDeleteSectionAndSubSectionLTI = [];
        let tempInsertSectionAndSubSectionLTI = [];

        if(this.state.isEnableSubsectionLTI && this.state.isEnableSubsectionLTI === this.state.DBIsSubsectionEnableLTi){
          tempDeleteSectionAndSubSectionLTI = tempDBSnapShotSubSectionLTI.filter(({ subsection_id: subID1 }) => !tempSectionLTI.some(({ subsection_id: subID2 }) => subID1 === subID2));

          tempInsertSectionAndSubSectionLTI = tempSectionLTI.filter(({subsection_id: subID1 }) => !tempDBSnapShotSubSectionLTI.some(({subsection_id: subID2}) => subID1 == subID2));
  
        }
        
        let TempDeleteArray = '';
        let TempInsertArray = '';

        let tempBackupSectionArray= [];
        let tempBackupSubSectionArray= [];
        let tempBackupSubSectionArrayLTI= [];

        let TempEnableSubection = this.state.isEnableSubsection;


        if(this.state.isEnableLTI){
          if(this.state.isEnableSubsectionLTI === this.state.DBIsSubsectionEnableLTi){
            if(this.state.isEnableSubsectionLTI ){
              TempDeleteArray = tempDeleteSectionAndSubSectionLTI;
              TempInsertArray = tempInsertSectionAndSubSectionLTI;

              tempBackupSubSectionArrayLTI = tempDBSnapShotSubSectionLTI.filter(({ subsection_id: subID1 }) => tempSectionLTI.some(({ subsection_id: subID2 }) => subID1 === subID2));
              tempBackupSubSectionArrayLTI.push(...tempInsertSectionAndSubSectionLTI);
            }else {
              TempDeleteArray = tempDeleteSection;
              TempInsertArray = tempInsertSection;
              tempBackupSectionArray =  tempDBSnapShotSectionArr.filter(({ id : secID1 }) => !tempDeleteSection.some(({ id: secID2 }) => secID1 === secID2));
              tempBackupSectionArray.push(...tempInsertSection);
            }
        } else {
           if (this.state.isEnableSubsectionLTI ){
              TempDeleteArray = this.state.DBSnapShotSectionArr;
              TempInsertArray = tempSectionLTI;
              tempBackupSubSectionArrayLTI.push(...tempInsertSectionAndSubSectionLTI)
           } else {
              TempDeleteArray = this.state.DBSnapshotSubsectionLTI;
              TempInsertArray = tempUpdateSection;
              tempBackupSectionArray.push(...tempInsertSectionAndSubSectionLTI);
           }
        }
          
        }else if(this.state.isEnableSubsection === this.state.DBIsSubsectionEnable){
            if(this.state.isEnableSubsection ){
              TempDeleteArray = tempDeleteSectionAndSubSection;
              TempInsertArray = tempInsertSectionAndSubSection;

              tempBackupSubSectionArray = tempDBSnapShotSubSectionArr.filter(({ subsection_id: subID1 }) => tempSubSection.some(({ subsection_id: subID2 }) => subID1 === subID2));
              tempBackupSubSectionArray.push(...tempInsertSectionAndSubSection);
            }else {
              TempDeleteArray = tempDeleteSection;
              TempInsertArray = tempInsertSection;
              tempBackupSectionArray =  tempDBSnapShotSectionArr.filter(({ id : secID1 }) => !tempDeleteSection.some(({ id: secID2 }) => secID1 === secID2));
              tempBackupSectionArray.push(...tempInsertSection);
            }
        } else {
           if (this.state.isEnableSubsection ){
              TempDeleteArray = this.state.DBSnapShotSectionArr;
              TempInsertArray = tempSelectedSectionAndSubsectionArr;
              tempBackupSubSectionArray.push(...tempSelectedSectionAndSubsectionArr)
           } else {
              TempDeleteArray = this.state.DBSnapShotSubSectionArr;
              TempInsertArray = tempUpdateSection;
              tempBackupSectionArray.push(...tempSelectedSectionAndSubsectionArr);
           }
        }

       const payload = {
        topic_id: top_id,
        subject_id: selectedSubjectID,
        quiz_name: assignmentName,
        start_date: startDate,
        start_time: startTime,
        end_date: endDate,
        end_time: endTime,
        quiz_type: tempQuizORTest,
        mastery_condition: masteryCondition,
        mastery_units: masteryUnit,
        maximum_attempted: maximumAttendPerQuestion,
        semester_id: 0,
        course_id: courseId,
        section_Id: sectionId,
        quiz_details: tempQuizInsertArr,
        section_id: sectionID,
        quiz_id: quizID,
        quiz_delete_arr: deleteArr,
        quiz_subcat_info: tempQuizInfoArr,
        testTimerEnabled: testTimerEnabled,
        fullScoreIfAttempted:fullScoreIfAttempted,
        fixedAbsoluteTimeEnabled: fixedAbsoluteTimeEnabled,
        test_time: tempIsTestTimer,
        randomize_categories: tempRandomizeCategories,
        sections_list: TempInsertArray,
        sections_delete_list: TempDeleteArray,
        splash_screen: tempSplashScreenText,
        alt_splash_screen: tempAltSplashScreenText,
        NoCQC: tempNOCQC,
        enableSurvey:this.state.enableSurvey,
        category_mastery_count:categoryMasteryUnit,
        category_nocqc:categoryNocqcUnit,
        random_subcategory_order:CategoryRSOUnit,
        category_number_of_questions:categoryNoQUnit,
        category_is_required:categoryIsRequiredDataBuild,
        category_position:categoryPositionDataBuild,
        free_choice_count:this.state.freeChoiceCount,
        subsection_id: this.props.subSection ||  this.props.location.query.subsection === "true" ? parseInt(this.state.subsection_id,10) : 0,
        enable_subsection: TempEnable,
        lockoutN: tempLockOutN,
        is_nongraded:is_nongraded,
        allow_practice: this.state.allowPractice,
        is_anonymous: this.state.isAnonymous,
        one_page_mode: this.state.onePageMode,
        status: shouldPublish ? 1 : 0,
        allow_partial_credit: tempQuizORTest === 1 ? false : this.state.allowPartialCredit,
        allow_pause_category: tempQuizORTest === 1 ? false : this.state.allowPauseCategory,
      };
      // for (let i = 0; i < tempQuizInsertArr.length; i++) {
      //   tempQuizInfoArr.push(tempQuizInsertArr[i]);
      // }
      let TempQuizInfoArr = [...this.state.quizInfoArr]
      console.log('tempQuizInsertArr', tempQuizInsertArr);
      console.log('tempQuizInfoArr', tempQuizInfoArr);

      let newTempQuizArr = [...tempQuizInfoArr, ...tempQuizInsertArr]

      newTempQuizArr.sort((quiz1, quiz2) => (quiz1.order > quiz2.order) ? 1 : -1)

      this.setState({ quizInfoArr: newTempQuizArr });
      console.log('update Quiz : ', payload);
      this.setState({ loadingSave: true });
      ApiRequestService({
        method: 'post',
        //url: '/getAllCategories',
        url: '/addQuiz',
        data: payload
      }).then(res => {
        this.setState({ loadingSave: false });
        console.debug('Get update quiz res :', res);
        if (
          res != null &&
          res.data != null &&
          res.data.message !== null &&
          res.data.message !== ''
        ) {
          alert(res.data.message);
          //quizInfoArr
        } else {
          if (
            res != null &&
            res.data != null &&
            res.data.data != null &&
            res.data.data.quiz_details != null
          ) {
            //update response add to local variable
            console.log('tempQuizInfoArr111',res.data.data)
            this.setState({
               quizInsertArr: [],
               DBSnapShotArr : TempQuizInfoArr,
               DBSnapShotSectionArr: tempBackupSectionArray,
               DBSnapShotSubSectionArr: tempBackupSubSectionArray,
               DBIsSubsectionEnable: TempEnableSubection, 
               DBIsSubsectionEnableLTi: this.state.isEnableSubsectionLTI,
               DBSnapshotSubsectionLTI: tempBackupSubSectionArrayLTI,
               status: shouldPublish ? 1 : 0
            }, ()=>{
              this.rearrangeCategoryOrder()
              this.handleDeleteUserDataForQuiz(false)
              let msg = "Saved successfully!"
              if (shouldPublish && !(this.state.is_lti_enabled && JSON.parse(this.state.is_lti_enabled))) {
                msg = "Saved & Published successfully!"
              }
              NotificationManager.success(msg, 'Success', 3000);
            });
          }
        }
        // browserHistory.push(
        //   baseFolder +
        //     '/quizList?section_id=' +
        //     this.props.location.query.section_id +
        //     '&course_id=' +
        //     this.props.location.query.course_id +
        //     '&course_name=' +
        //     this.props.location.query.course_name +
        //     '&section_name=' +
        //     this.props.location.query.section_name
        // );
        //window.location =  '/quizList?section_id='+this.props.location.query.section_id+'&course_id='+this.props.location.query.course_id;
      });
    }

    
  }

  

  goBack() {

    if(this.props.location.query.course_indx !== null &&
      this.props.location.query.course_indx !== undefined){
      // CAME From Course/Section DASHBOARD        
     
        if (this.props.location.query.section_name !== undefined && 
          this.props.location.query.section_name !== null) {
            console.log("sectionsDashboard");  
            //Came from SECTION DASHBOARD           
              browserHistory.push(
                this.baseFolder+'sectionsDashboard?section_id=' +
                this.props.location.query.section_id +
                '&course_id=' +
                this.props.location.query.course_id +
                '&course_name=' +
                this.props.location.query.course_name +
                '&section_name=' +
                this.props.location.query.section_name+
                '&course_indx='+
                this.props.location.query.course_indx 
              );      
              
          }else{      
            //CoursesDashboard     
            
            browserHistory.push(
              this.baseFolder+'CoursesDashboard?course_indx=' +
              this.props.location.query.course_indx );
          }

         
      }else if( this.state.subsection === "true"){
        browserHistory.push(
          this.baseFolder +
           'subSectionTabs?subsection_id=' +
           this.state.subsection_id +
           '&subsection_name=' +
           this.state.subsection_name +
           '&section_id=' +
           this.state.section_id +
           '&section_name=' +
           this.state.section_name +
           '&course_id=' +
           this.state.course_id +
           '&course_name=' +
           this.state.course_name
           );
        
      } else{
        
         browserHistory.push(
          this.baseFolder +
            'quizList?section_id=' +
            this.props.location.query.section_id +
            '&course_id=' +
            this.props.location.query.course_id +
            '&course_name=' +
            this.props.location.query.course_name +
            '&section_name=' +
            this.props.location.query.section_name +
            '&is_lti_enabled=' +
            this.state.is_lti_enabled
        );
      }

  }

  onAllowPracticeChange = (event) => {
    this.setState({
      allowPractice: event.target.checked
    })
  }

  onSectionChange = (argSelectedSectionIDs) => {
    let seletedSectionID = []
    argSelectedSectionIDs.forEach(row => {
        if(row.id !== 'enableAll' && row.id !== 'enableNone'){
            seletedSectionID.push(row);
        }  
    })
    console.log("seletedSectionID=", seletedSectionID)
    this.setState({
      sections: [...seletedSectionID]
    });
    };

  deleteSelectedSubcategory(index, thisobj) {
    console.debug('deleted  index = ', index);
    console.debug('deleted  thisobj = ', thisobj);
    var tempQuizDeleteArr = [];
    var tempQuizInfoArr = [];
    var tempQuizInsertArr = [];
    var tempDBSnapShotArr = [];
    var tempCategoriesSet = new Set();
    tempQuizInfoArr = this.state.quizInfoArr;
    tempQuizInsertArr = this.state.quizInsertArr;
    tempDBSnapShotArr = this.state.DBSnapShotArr;
    tempCategoriesSet = this.state.categoriesSet;
    if (this.state.quizDeleteArr.length > 0) {
      tempQuizDeleteArr = this.state.quizDeleteArr;
    }
    //console.debug('deleted  index = ', index);
    // Check delete index in insert Array


    var catID = null;
    var matchdCatID = null;

    var tempCatCountMap = {};
    var tempCategoryDetailsMap = this.state.categoryDetailsMap;
    let tempCategoriesUniqueArr =  this.state.categoriesUniqueArr;    
    if (tempQuizInsertArr.length > 0) {
      for (let k = 0; k < parseInt(tempQuizInsertArr.length, 10); k++) {
        console.debug(k,'loop  index  arr',tempCatCountMap,catID,tempQuizInsertArr[k].index);
        catID = tempQuizInsertArr[k].subject_id + "_" + tempQuizInsertArr[k].topic_id + "_"
        + tempQuizInsertArr[k].category_id ;

        if (tempCatCountMap[catID] === undefined){
          tempCatCountMap[catID] = 0;
        }
        tempCatCountMap[catID]++;
      }
      console.debug("tempCountMap ",tempCatCountMap)
      for (let k = 0; k < parseInt(tempQuizInsertArr.length, 10); k++) {
        console.debug(k,'loop  index  arr',tempCatCountMap,catID,tempQuizInsertArr[k].index);
        catID = tempQuizInsertArr[k].subject_id + "_" + tempQuizInsertArr[k].topic_id + "_"
        + tempQuizInsertArr[k].category_id ;

        if (index === tempQuizInsertArr[k].index) {
          console.debug('deleted  index = ', index,matchdCatID);
          tempQuizInsertArr.splice(k, 1); 
          matchdCatID = catID;
          console.log("tempCategoriesSet",tempCategoriesSet);
          console.log("tempCategoriesSet =size",tempCategoriesSet.size);
          //isIndexDelete = false;
          break; 
        }
      }
      console.debug(matchdCatID,tempCatCountMap,tempCatCountMap[matchdCatID],tempQuizInsertArr,tempCategoriesSet)
      if(matchdCatID !== null && tempCatCountMap[matchdCatID] !== undefined && 
        tempCatCountMap[matchdCatID] !== null && 
        tempCatCountMap[matchdCatID] <= 1){
        tempCategoriesSet.delete(matchdCatID);
      }
      tempCatCountMap = null;
      matchdCatID = null;
    }
    // Check delete index in display  Array
    for (var j = 0; j < parseInt(tempQuizInfoArr.length, 10); j++) {
      console.debug('deleted  index in display arr', tempQuizInfoArr[j].index);
      let tempCatId = tempQuizInfoArr[j].subject_id +"_"+tempQuizInfoArr[j].topic_id +"_"+tempQuizInfoArr[j].category_id;
      if (index === tempQuizInfoArr[j].index) {
        console.debug('deleted  index = ', index);
        tempQuizInfoArr.splice(j, 1);
        //isIndexDelete = false;
        //break;
      }

    console.log("Before tempCategoryDetailsMap",tempCategoryDetailsMap);
    console.log("Before tempCategoriesUniqueArr",tempCategoriesUniqueArr);

    
    tempCategoriesUniqueArr =[];
  
    for (var tq = 0; tq < parseInt(tempQuizInfoArr.length, 10); tq++) {

      tempCatId = tempQuizInfoArr[tq].subject_id +"_"+tempQuizInfoArr[tq].topic_id +"_"+tempQuizInfoArr[tq].category_id;
      console.log("tempCatId = ",tempCatId); 
      
      if(tempCategoriesUniqueArr.includes(tempCatId) !== true){

        tempCategoriesUniqueArr.push(tempCatId); 
      }
    }

    console.log("After tempCategoryDetailsMap",tempCategoryDetailsMap);
    console.log("After tempCategoriesUniqueArr",tempCategoriesUniqueArr);



    }
    for (var d = 0; d < tempDBSnapShotArr.length; d++) {
      console.debug('deleted  index in DB arr ', tempDBSnapShotArr[d].index);
      if (index === tempDBSnapShotArr[d].index) {
        console.debug('deleted DBSnapShotArr  index = ', index);
        tempQuizDeleteArr.push(index);
        //isIndexDelete = true;
        break;
      }
    }
    console.debug('tempQuizDeleteArr', tempQuizDeleteArr);
    console.debug('tempQuizInsertArr', tempQuizInsertArr);
    console.debug('tempQuizInfoArr', tempQuizInfoArr);
    console.debug('tempCategoriesSet', tempCategoriesSet);
    //Fix Order change while deleting subcat from the table
    tempQuizInfoArr.map((v, index)=>{
      v.order = index + 1;
      return v;
    });
    this.setState({
      //addedQuizSubDivList:tempAddedQuizSubDivList,
      quizDeleteArr: tempQuizDeleteArr,
      quizInsertArr: tempQuizInsertArr,
      quizInfoArr: tempQuizInfoArr,
      categoriesSet:tempCategoriesSet,
      masteryUnit:tempCategoriesSet.size,
      categoryDetailsMap:tempCategoryDetailsMap,
      categoriesUniqueArr:tempCategoriesUniqueArr

    });
  }

  cancel() {
    console.debug('Cancel():');
    this.goBack();
    //this.addBreadCrumbs();
    // browserHistory.push(
    //   baseFolder +
    //     '/quizList?section_id=' +
    //     this.props.location.query.section_id +
    //     '&course_id=' +
    //     this.props.location.query.course_id +
    //     '&course_name=' +
    //     this.props.location.query.course_name +
    //     '&section_name=' +
    //     this.props.location.query.section_name
    // );
  }

  hoverOn() {
    console.debug('hoverOn');
    //this.setState({hoverState:true});
  }
  hoverOff() {
    //this.setState({hoverState:false});
    console.debug('hoverOff');
  }

  onSelectCategory(i) {
    console.debug('onSelectCategory-subcategoriesSelected = ', this.state.subcategoriesSelected);
    console.debug('categorySelected = ', this.state.categorySelected);
    var tempSubcategoriesSelected = this.state.subcategoriesSelected;
    var tempCategorySelected = this.state.categorySelected;
    if (tempCategorySelected[i].rowSelectedCategory === false) {
      tempCategorySelected[i].rowSelectedCategory = true;
      let hasSubCats  = false;
      
      for (var j = 0; j < tempSubcategoriesSelected.length; j++) {
        if (
          tempCategorySelected[i].key ===
          tempSubcategoriesSelected[j].category_id
        ) {
          tempSubcategoriesSelected[j].checked = true;
          hasSubCats  = true;
        }
      }
      //bug-tracker#271
      //console.log('hasSubCats',hasSubCats);
      if(!hasSubCats)
      {
        NotificationManager.error('The Selected Category has no Subcategories','No SubCategories',5000);
        tempCategorySelected[i].rowSelectedCategory = false;
      }
      
    } else {
      tempCategorySelected[i].rowSelectedCategory = false;
      //this.setState({rowDispalyArrow:false});
      for (let j = 0; j < tempSubcategoriesSelected.length; j++) {
        if (
          tempCategorySelected[i].key ===
          tempSubcategoriesSelected[j].category_id
        ) {
          tempSubcategoriesSelected[j].checked = false;
        }
      }
    }
    this.setState({
      categorySelected: tempCategorySelected,
      subcategoriesSelected: tempSubcategoriesSelected
    });
    //console.debug("After onSelectCategory = ",this.state.rowDispalyArrow);
  }
  optionClicked(optionsList) {
    // var tempDeleteSection = [];
    // for(var i = 0; i < optionsList.length; i++){
    //   if(optionsList[i].value == false){

    //     var tempDelete = {};
    //     tempDelete["id"] = optionsList[i].id;
    //     tempDelete["label"] = optionsList[i].label;
    //     tempDelete["value"] = optionsList[i].value;

    //     tempDeleteSection.push(tempDelete);
    //   }

    // }
    // console.debug("tempDeleteSection",tempDeleteSection);
    console.log('selected optionClicked', optionsList);

    this.setState({
      sections: optionsList
      //deleteSection: tempDeleteSection,
    });
  }
  //LTI Changes
  onSingleSectionSelected = (value, rowData) =>{
    
    let cour_id = parseInt(this.state.course_id,10 );

    const sections = this.state.sections.map(section => {
      var returnValue = {...section,value:false};
    
      if (section.id === value) {
        returnValue.value = true;
      }
      return returnValue
    });

    let payload = {
      section_id: value,
      course_id: cour_id
    }
    console.log('sectionid ', payload);
    ApiRequestService({
      method: 'post',
      url: '/getAllSubSections',
      data: payload
    }).then(res => {
      var tempSubSectionList = [];
        var tempSubSectionArr = res.data.data.subsection_names;
        if (tempSubSectionArr !== null) {
          for (var i = 0; i < tempSubSectionArr.length; i++) {
            var tempObj = {};
            tempObj['label'] = tempSubSectionArr[i].subsection_name;
            tempObj['id'] = tempSubSectionArr[i].subsection_id;
            if(rowData !=  undefined && rowData != [] && rowData.length > 0 ){
              console.log('edit',rowData )
              rowData.map((subsection) => {
                if((tempSubSectionArr[i].subsection_id === subsection.subsection_id)){
                   return tempObj['value'] = true;
                }
              })
            }
            tempSubSectionList.push(tempObj);
          };
        }
         this.setState({
         subsectionList: tempSubSectionList
         });
    });
    this.setState({
      sections: sections,
      selectSectionID:value
    });
  }
  selectedBadgeClicked(optionsList) {
    console.log('selectedBadgeClicked(optionsList)',optionsList)
    // var tempInsertSection = [];
    // console.debug("selectedBadgeClicked",optionsList);
    // for(var i = 0; i < optionsList.length; i++){
    //   if(optionsList[i].value == true){
    //     var tempInsert = {};
    //     tempInsert["id"] = optionsList[i].id;
    //     tempInsert["label"] = optionsList[i].label;
    //     tempInsert["value"] = optionsList[i].value;

    //     tempInsertSection.push(tempInsert);
    //   }
    // }

    this.setState({
      sections: optionsList
      //insertSection: tempInsertSection,
    });
  }
  
  optionClickedInAdd(optionsList) {
    let isSubmitEnable = optionsList.some((option) => option.value === true)
    console.log('this.state.1',isSubmitEnable)
    this.setState({
      subsectionList: optionsList,
      isSubmitEnable: isSubmitEnable
    });
  };

  selectedBadgeClickedInAdd(optionsList) {
    let isSubmitEnable = optionsList.some((option) => option.value === true)
    console.log('this.state.2',isSubmitEnable)

    this.setState({
      subsectionList: optionsList,
      isSubmitEnable: isSubmitEnable
    });
  }


  subcategoryWeightTextOnChange(index,e) {
    console.debug('subcategoryWeightTextOnChange', e.target.value);
    console.debug('index', index);

    if( parseInt(e.target.value,10) === 0){
      alert("Subcategory weight should be atleast 1. Please check weights for all subctegories selected")
    }
	if (numberGreaterThenZero.test(e.target.value)) {
    var tempQuizInfoArr = this.state.quizInfoArr;
		console.debug('tempQuizInfoArr', tempQuizInfoArr[index]);
		if(tempQuizInfoArr[index].subcategory_weight !== undefined && 
		tempQuizInfoArr[index].subcategory_weight !== null ){
				tempQuizInfoArr[index].subcategory_weight = parseInt(e.target.value,10);
		}

		this.setState({
			quizInfoArr: tempQuizInfoArr,
		  });
	}

    console.debug('tempQuizInfoArr = ', tempQuizInfoArr);
    console.debug('quizInfoArr = ', this.state.quizInfoArr);
  }

  hide() {

    this.setState({
      visible: false,
    });
    
  }
  show() {
    console.log("Dialog Show");
    let quizID = parseInt(this.state.quiz_id, 10);
    console.log("quizID =",quizID );
    if(quizID === null &&  quizID === 0 ){
      NotificationManager.error('Assignment id is not vaild', 'ERROR', 3000);
      return;
    }
    //this.getStudentQuizTime();
     this.setState({
        visible: true
      });
    
  }

  enableAnalyticsOnChange = (e,index) => {

   let tempQuizInfoArr = this.state.quizInfoArr;
   tempQuizInfoArr[index].enable_analytics = e.target.checked;

   this.setState({ quizInfoArr: tempQuizInfoArr });
   
  } 
  enableFeedbackOnChange = (e,index) => {
    
       let tempQuizInfoArr = this.state.quizInfoArr;
       tempQuizInfoArr[index].enable_feedback = e.target.checked;
    
       this.setState({ quizInfoArr: tempQuizInfoArr });
       
      }
    

  checkBoxNonGradedOnChange(i, thisobj) {
    console.debug('checkBoxNonGradedOnChange', i);

    var tempQuizInfoArr = this.state.quizInfoArr;
    if (tempQuizInfoArr[i] !== undefined) {
      //console.debug("randomize_questions",tempQuizInfoArr[i].randomize_questions);
      if (tempQuizInfoArr[i].non_graded === 1) {
        tempQuizInfoArr[i].non_graded = 0;
      } else {
        tempQuizInfoArr[i].non_graded = 1;
      }
      // console.debug("randomize_questions =",tempQuizInfoArr[i].randomize_questions);
      // console.debug("randomize_questions = ",tempQuizInfoArr);

      this.setState({ quizInfoArr: tempQuizInfoArr });
    }
  }

  CMHide() {

    this.setState({
      CMWindowVisible: false,
    });
    if (this.state.quizORTest){
     const errorCase = this.CategoryCheck(this.state.quizORTest, this.state.categoriesQuestionsCountMap);
     if(errorCase){
      this.setState({
        CMWindowVisible: true,
      });
     }
    }
  }

  NocqcAlertHide(){
    this.setState({
      NocqcAlertVisible: false,
    });
  }

  NocqcAlertHideandAllowtoSave(){
    this.setState({
      NocQcqAlertPopupGrant: false,
      NocqcAlertVisible: false,
    },()=>this.createQuiz());
  }

  CategoryCheck(isTest, tempCategoryQuestionCount){
    let tempCategoriesUniqueArr =  this.state.categoriesUniqueArr;
    let tempCategoryDetailsMap = this.state.categoryDetailsMap;
    console.log("CategoryCheck", tempCategoryDetailsMap)
    let error =0;
    for(let i=0;i<tempCategoriesUniqueArr.length;i++){
      if (isTest  && tempCategoryDetailsMap[tempCategoriesUniqueArr[i]].category_number_of_questions > tempCategoryQuestionCount[tempCategoriesUniqueArr[i]]){
          NotificationManager.error(`You have entered more than the available # of questions in the category, ${tempCategoryDetailsMap[tempCategoriesUniqueArr[i]].category_name}`, 'Error', 3000);
          error++;
      }
      if (isTest  && tempCategoryDetailsMap[tempCategoriesUniqueArr[i]].hasOwnProperty('category_number_of_questions') && tempCategoryDetailsMap[tempCategoriesUniqueArr[i]].category_number_of_questions > 0 && tempCategoryDetailsMap[tempCategoriesUniqueArr[i]].category_nocqc > tempCategoryDetailsMap[tempCategoriesUniqueArr[i]].category_number_of_questions) {
        NotificationManager.error(`You have entered NOCQC more than the # of questions in the category, ${tempCategoryDetailsMap[tempCategoriesUniqueArr[i]].category_name}`, 'Error', 3000);
        error++;
      }else if (isTest && tempCategoryDetailsMap[tempCategoriesUniqueArr[i]].category_nocqc > tempCategoryQuestionCount[tempCategoriesUniqueArr[i]]) {
          NotificationManager.error(`You have entered NOCQC more than the available # of questions in the category, ${tempCategoryDetailsMap[tempCategoriesUniqueArr[i]].category_name}`, 'Error', 3000);
          error++;
      }else if(tempCategoryDetailsMap[tempCategoriesUniqueArr[i]].category_nocqc > 1000){
		NotificationManager.error('Category Options NOCQC should be less then or equal to 1000');
		error++;
	  }else if(tempCategoryDetailsMap[tempCategoriesUniqueArr[i]].category_mastery_count > 1000){
		NotificationManager.error('Category Options Mastery Condition should be less then or equal to 1000');
		error++;
	  }
    }
    if(error > 0){
      return true;
    }
    return false;
  }

  CMShow() {
    if (this.state.quizORTest){
		this.setState({
			loadingCategoryOptionButton: true,
		})
    	let resp = this.getCategoryQuestions();
		resp.then(res => {
			if (res.data.data !== null && res.data.data !== undefined){
			  this.setState({
				  loadingCategoryOptionButton: false,
				  CMWindowVisible: true,
				categoriesQuestionsCountMap:res.data.data 
			  })
			}
					  
		});
    }else{
		this.setState({
			CMWindowVisible: true,
		})
	}
  }

  getCategoryQuestions(){
    let tempCategoriesUniqueArr =  this.state.categoriesUniqueArr;
    let tempCategoryDetailsMap = this.state.categoryDetailsMap;
    let tempSubCategoriesUniqueArr = [];
    this.state.quizInfoArr.map((quiz,i) =>  tempSubCategoriesUniqueArr[i]= quiz.index);
    const payload = {
      category_key: tempCategoriesUniqueArr,
      subcategory_key: tempSubCategoriesUniqueArr
    }
    let resp = ApiRequestService({
      method: 'post',
      url: '/getCategoryQuestionsCount',
      data: payload
    })
	return resp
	// resp.then(res => {
    //   if (res.data.data !== null && res.data.data !== undefined){
    //     this.setState({
	// 		loadingCategoryOptionButton: false,
	// 		CMWindowVisible: true,
    //       categoriesQuestionsCountMap:res.data.data 
    //     })
    //   }
                
    // });
    
  }

 

  categoryMasteryTextOnChange(index,e) {
    console.debug('categoryMasteryTextOnChange', e.target.value);
    console.debug('index', index);

    var tempIndex = index;
    let tempCategoriesUniqueArr =  this.state.categoriesUniqueArr;
    let tempCategoryDetailsMap = this.state.categoryDetailsMap;
    
    console.log("tempCategoriesUniqueArr = ",tempCategoriesUniqueArr);
    console.log("categoryDetailsMap = ",tempCategoryDetailsMap);
    console.log("categoryDetailsMap = ",tempCategoryDetailsMap[tempCategoriesUniqueArr[tempIndex]]);

    var tempInfoarr = tempCategoryDetailsMap[tempCategoriesUniqueArr[tempIndex]];
    console.log("tempInfoarr= ",tempInfoarr);
    tempInfoarr["category_mastery_count"] = parseInt(e.target.value, 10);
    tempCategoryDetailsMap[tempCategoriesUniqueArr[tempIndex]] = tempInfoarr;
    console.log("tempCategoryDetailsMap",tempCategoryDetailsMap);

    this.setState({
      categoryDetailsMap:tempCategoryDetailsMap,
    })
  }

  categoryNocqcOnChange(index,e) {
    /* console.debug('categoryMasteryTextOnChange', e.target.value);
    console.debug('index', index); */

	if (numberGreaterThenZero.test(e.target.value)) {
		var tempIndex = index;
		let tempCategoriesUniqueArr =  this.state.categoriesUniqueArr;
		let tempCategoryDetailsMap = this.state.categoryDetailsMap;
		
		/* console.log("tempCategoriesUniqueArr = ",tempCategoriesUniqueArr);
		console.log("categoryDetailsMap = ",tempCategoryDetailsMap);
		console.log("categoryDetailsMap = ",tempCategoryDetailsMap[tempCategoriesUniqueArr[tempIndex]]); */

		var tempInfoarr = tempCategoryDetailsMap[tempCategoriesUniqueArr[tempIndex]];
		//console.log("tempInfoarr= ",tempInfoarr);
		tempInfoarr["category_nocqc"] = parseInt(e.target.value, 10);
		tempCategoryDetailsMap[tempCategoriesUniqueArr[tempIndex]] = tempInfoarr;
		//console.log("tempCategoryDetailsMap",tempCategoryDetailsMap);
		this.setState({
		  categoryDetailsMap:tempCategoryDetailsMap,
		})
	}
  }

  categoryNumberofQuestions(index,e) {
    /* console.debug('categoryNumberofQuestions', e.target.value);
    console.debug('index', index);
 */
	if (numberGreaterThenZero.test(e.target.value)) {
		var tempIndex = index;
		let tempCategoriesUniqueArr =  this.state.categoriesUniqueArr;
		let tempCategoryDetailsMap = this.state.categoryDetailsMap;
		
		/* console.log("tempCategoriesUniqueArr = ",tempCategoriesUniqueArr);
		console.log("categoryDetailsMap = ",tempCategoryDetailsMap);
		console.log("categoryDetailsMap = ",tempCategoryDetailsMap[tempCategoriesUniqueArr[tempIndex]]); */

		var tempInfoarr = tempCategoryDetailsMap[tempCategoriesUniqueArr[tempIndex]];
		//console.log("tempInfoarr= ",tempInfoarr);
		tempInfoarr["category_number_of_questions"] = parseInt(e.target.value, 10);
		tempCategoryDetailsMap[tempCategoriesUniqueArr[tempIndex]] = tempInfoarr;
		//console.log("tempCategoryDetailsMap",tempCategoryDetailsMap);

		this.setState({
		categoryDetailsMap:tempCategoryDetailsMap,
		})
	}
  }
  

  CategoryNumberofQuestionsDataBuild(){

    //console.log("CategoryNumberofQuestionsDataBuild:");
    let tempCategoriesUniqueArr =  this.state.categoriesUniqueArr;
    let tempCategoryDetailsMap = this.state.categoryDetailsMap;
    var categoryNoQObj = {};
    var categoryNoQJson = {};
    for(var i = 0; i < tempCategoriesUniqueArr.length; i++){

      categoryNoQObj[tempCategoriesUniqueArr[i]] = tempCategoryDetailsMap[tempCategoriesUniqueArr[i]].category_number_of_questions;

    }

    categoryNoQJson = JSON.stringify(categoryNoQObj);
    //console.log("categoryMaseryJson",categoryNoQJson);
    return categoryNoQJson;
    
  }

  CategoryMasteryDataBuild(){

    console.log("CategoryMasteryDataBuild():");
    let tempCategoriesUniqueArr =  this.state.categoriesUniqueArr;
    let tempCategoryDetailsMap = this.state.categoryDetailsMap;
    var categoryMaseryObj = {};
    var categoryMaseryJson = {};
    for(var i = 0; i < tempCategoriesUniqueArr.length; i++){

      categoryMaseryObj[tempCategoriesUniqueArr[i]] = tempCategoryDetailsMap[tempCategoriesUniqueArr[i]].category_mastery_count;

    }

    categoryMaseryJson = JSON.stringify(categoryMaseryObj);
    console.log("categoryMaseryJson",categoryMaseryJson);
    return categoryMaseryJson;
    
  }

  CategoryNocqcDataBuild(){

    console.log("CategoryNocqcDataBuild():");
    let tempCategoriesUniqueArr =  this.state.categoriesUniqueArr;
    let tempCategoryDetailsMap = this.state.categoryDetailsMap;
    var categoryNocqcObj = {};
    var categoryNocqcJson = {};
    for(var i = 0; i < tempCategoriesUniqueArr.length; i++){

      categoryNocqcObj[tempCategoriesUniqueArr[i]] = tempCategoryDetailsMap[tempCategoriesUniqueArr[i]].category_nocqc ? tempCategoryDetailsMap[tempCategoriesUniqueArr[i]].category_nocqc : this.state.NOCQC;

    }

    categoryNocqcJson = JSON.stringify(categoryNocqcObj);
    console.log("CategoryNocqcJson",categoryNocqcJson);
    return categoryNocqcJson;
    
  }

  CategoryRandomSubcatOrderDataBuild(){
    console.log("CategoryRandomSubcatOrderDataBuild():");
    let tempCategoriesUniqueArr =  this.state.categoriesUniqueArr;
    let tempCategoryDetailsMap = this.state.categoryDetailsMap;
    var categoryRSOObj = {};
    var categoryRSOJson = {};
    for(var i = 0; i < tempCategoriesUniqueArr.length; i++){
      categoryRSOObj[tempCategoriesUniqueArr[i]] = tempCategoryDetailsMap[tempCategoriesUniqueArr[i]].random_subcategory_order;
    }
    categoryRSOJson = JSON.stringify(categoryRSOObj);
    console.log("CategoryRandomSubcatOrderDataBuildJSON",categoryRSOJson);
    return categoryRSOJson;
  }

  CategoryIsRequiredDataBuild(){
    console.log("CategoryIsRequiredDataBuild():");
    let tempCategoriesUniqueArr =  this.state.categoriesUniqueArr;
    let tempCategoryDetailsMap = this.state.categoryDetailsMap;
    var categoryMaseryObj = {};
    var categoryMaseryJson = {};
    for(var i = 0; i < tempCategoriesUniqueArr.length; i++){
      categoryMaseryObj[tempCategoriesUniqueArr[i]] = tempCategoryDetailsMap[tempCategoriesUniqueArr[i]].category_is_required;
    }
    categoryMaseryJson = JSON.stringify(categoryMaseryObj);
    console.log("CategoryIsRequiredDataBuildJSON",categoryMaseryJson);
    return categoryMaseryJson;
  }
 
  CategoryPositionDataBuild(){
    console.log("CategoryIsRequiredDataBuild():");
    let tempCategoriesUniqueArr =  this.state.categoriesUniqueArr;
    let tempCategoryDetailsMap = this.state.categoryDetailsMap;
    var categoryObj = {};
    var categoryJson = {};
    for(var i = 0; i < tempCategoriesUniqueArr.length; i++){
      categoryObj[tempCategoriesUniqueArr[i]] = {
        ['category_at_last'] : tempCategoryDetailsMap[tempCategoriesUniqueArr[i]].category_at_last,
        ['category_at_begining'] : tempCategoryDetailsMap[tempCategoriesUniqueArr[i]].category_at_begining
      };
    }
    categoryJson = JSON.stringify(categoryObj);
    console.log("CategoryIsRequiredDataBuildJSON",categoryJson);
    return categoryJson;
  }

  onIsRequiredSwitchChange =(key,value)=>{
    console.debug("onIsRequiredSwitchChange event ",key, value, this.state.categoryDetailsMap)
    let tempCategoryDetailsMap = this.state.categoryDetailsMap
    tempCategoryDetailsMap[key].category_is_required = value.target.checked ? 1 : 2
    
    if (!value.target.checked) {
      tempCategoryDetailsMap[key].category_at_begining = 2
      tempCategoryDetailsMap[key].category_at_last =  2
    }
    let allCategoriesAreRequired = Object.keys(tempCategoryDetailsMap).some((element) =>{
      if(tempCategoryDetailsMap[element].category_is_required === 2){
        return true
      }
    })
    this.setState({
      allCategoriesAreRequired:allCategoriesAreRequired,
      categoryDetailsMap : tempCategoryDetailsMap
    })
    console.debug("tempCategoryDetailsMap allCategoriesAreRequired",tempCategoryDetailsMap,allCategoriesAreRequired)
  }
 

  onRandomSubcatOrderSwitchChange=(key,value)=>{
    console.debug("onRandomSubcatOrderSwitchChange event ",key, value, this.state.categoryDetailsMap)
    let tempCategoryDetailsMap = this.state.categoryDetailsMap
    tempCategoryDetailsMap[key].random_subcategory_order = value.target.checked ? 1 : 2

    let allRandomSubcatOrder = Object.keys(tempCategoryDetailsMap).some((element) =>{
      if(tempCategoryDetailsMap[element].random_subcategory_order === 2){
        return true
      }
    })
    this.setState({
      allRandomSubcatOrder:allRandomSubcatOrder,
      categoryDetailsMap : tempCategoryDetailsMap
    })
  }

  onCategoryPositionSwitchChange =(key, value, curPositionName, otherPostionName)=>{
    console.debug("onCategoryPositionSwitchChange event ", curPositionName, key, value, this.state.categoryDetailsMap)
    let tempCategoryDetailsMap = this.state.categoryDetailsMap

    tempCategoryDetailsMap[key] = {
      ...tempCategoryDetailsMap[key],
      [curPositionName] : value.target.checked ? 1 : 0,
      [otherPostionName] : value.target.checked ? 0 : tempCategoryDetailsMap[key][otherPostionName]
    }

    Object.keys(tempCategoryDetailsMap).forEach(function(objKey) {
      if((objKey !== key)){
        tempCategoryDetailsMap[objKey] = {
          ...tempCategoryDetailsMap[objKey],
          [curPositionName] :  0
        }
      }
    });

    if(value.target.checked){
      tempCategoryDetailsMap[key] = {
        ...tempCategoryDetailsMap[key],
        category_is_required : 1,
      }
    }

    this.setState({
      categoryDetailsMap : tempCategoryDetailsMap
    })

    if(value.target.checked){
      this.rearrangeCategoryOrder()
    }

    console.debug("tempCategoryDetailsMap ",tempCategoryDetailsMap)
  }

  onFreeChoiceCountChanges=(e)=>{
    console.debug("freeChoice freecount on change key,value ",e.target.value)
    this.setState({
      freeChoiceCount: parseInt(e.target.value, 10)
    })
  }

  
  rearrangeCategoryOrder = () => {
    let categoryDetailsMap = this.state.categoryDetailsMap
    let catergoryAtBegining = []
    let catergoryAtLast = []
    let catergoryAtMiddle = []
    let quizInfoArr = this.state.quizInfoArr
    let newQuizInfoArr = []
    let newCategoriesUniqueArr = []
    let categoryAtBeginingKey = []
    let categoryAtMiddleKey = []
    let categoryAtLastKey = []
    
    console.debug("newQuizInfoArr 1 ",quizInfoArr)

    for (var i = 0; i < quizInfoArr.length; i++) {
      let currentCatID = quizInfoArr[i].subject_id + "_" + quizInfoArr[i].topic_id + "_" + quizInfoArr[i].category_id
      if(categoryDetailsMap[currentCatID].category_at_begining !== undefined && 
        categoryDetailsMap[currentCatID].category_at_begining === 1){
          catergoryAtBegining = [
          ...catergoryAtBegining,
          {
            ...quizInfoArr[i],
            order : catergoryAtBegining.length + 1
          }
        ]
        if (!categoryAtBeginingKey.includes(currentCatID)) {
          categoryAtBeginingKey = [...categoryAtBeginingKey, currentCatID];
        }
      }else if(categoryDetailsMap[currentCatID].category_at_last !== undefined && 
        categoryDetailsMap[currentCatID].category_at_last === 1){
          catergoryAtLast = [
          ...catergoryAtLast,
          {
            ...quizInfoArr[i],
            order : catergoryAtLast.length + 1
          }
        ]

        if (!categoryAtLastKey.includes(currentCatID)) {
          categoryAtLastKey = [...categoryAtLastKey, currentCatID];
        }
      }else{
        catergoryAtMiddle = [
          ...catergoryAtMiddle,
          {
            ...quizInfoArr[i],
            order : catergoryAtMiddle.length + 1
          }
        ]
        if (!categoryAtMiddleKey.includes(currentCatID)) {
          categoryAtMiddleKey = [...categoryAtMiddleKey, currentCatID];
        }
      }
    }

    if(catergoryAtBegining.length > 0 || catergoryAtLast.length > 0){

      newCategoriesUniqueArr = [
        ...categoryAtBeginingKey,
        ...categoryAtMiddleKey,
        ...categoryAtLastKey,
      ];

        newQuizInfoArr = [
          ...catergoryAtBegining
        ]

        for (var i = 0; i < catergoryAtMiddle.length; i++) {
          let currentCatID = catergoryAtMiddle[i].subject_id + "_" + catergoryAtMiddle[i].topic_id + "_" + catergoryAtMiddle[i].category_id
          catergoryAtMiddle[i] = {
            ...catergoryAtMiddle[i],
            order : newQuizInfoArr.length + (i+1)
          }
        }
        
        newQuizInfoArr = [
          ...newQuizInfoArr,
          ...catergoryAtMiddle,
        ]

        for (var i = 0; i < catergoryAtLast.length; i++) {
          let currentCatID = catergoryAtLast[i].subject_id + "_" + catergoryAtLast[i].topic_id + "_" + catergoryAtLast[i].category_id
          catergoryAtLast[i] = {
            ...catergoryAtLast[i],
            order : newQuizInfoArr.length + (i+1)
          }
        }

        newQuizInfoArr = [
          ...newQuizInfoArr,
          ...catergoryAtLast,
        ]
        
      this.setState({
        quizInfoArr : newQuizInfoArr,
        categoriesUniqueArr : newCategoriesUniqueArr
      })

    }

    console.debug("newQuizInfoArr 2 ",newQuizInfoArr)

  }


  /* Section and subsection Table Start */

  SectionAndSubsectionShow() {
    this.setState({SectionAndSubsectionTableVisible: true })
  }


  SectionAndSubsectionHide() {
    this.setState({SectionAndSubsectionTableVisible: false })
  }

  SectionAndSubsectionAddShow() {
    let tempSectionList = [];
    console.log('selectedSectionIDArray', selectedSectionIDArray)

  /*   if(selectedSectionIDArray.length > 0){
       tempSectionList = this.state.sections.filter((section) =>  selectedSectionIDArray.indexOf(section.id) === -1 );
       console.log('selectedSectionIDArray.map',this.state.sections.filter((section) =>  selectedSectionIDArray.indexOf(section.id) === -1 ))
       
    } else{ */
      tempSectionList = this.state.sections;
   /*  } */
    console.log('tempSectionList', tempSectionList)
    this.setState({SectionsListInAdd:tempSectionList, SectionAndSubsectionAddVisible: true })
  }

  SectionAndSubsectionAddHide() {
    this.setState({SectionAndSubsectionAddVisible: false, subsectionList:[], selectedSectionIDInAdd: 0,
      isSubmitEnable: false, EditMode: false, EditSectionId:0 })
  }
  
  onSingleSectionSelectedInAdd = (value, rowData, EditMode) =>{
    let cour_id = parseInt(this.state.course_id,10 );
    const sections = this.state.sections.map(section => {
      var returnValue = {...section,value:false};
      
      if (section.id === value) {
        returnValue.value = true;
      }
      return returnValue
    });
    let payload = {
      section_id: value,
      course_id: cour_id
    }
    console.log('sectionid ', payload);
    ApiRequestService({
      method: 'post',
      url: '/getAllSubSections',
      data: payload
    }).then(res => {
      var tempSubSectionList = [];
        var tempSubSectionArr = res.data.data.subsection_names;
        if (tempSubSectionArr !== null) {
          for (var i = 0; i < tempSubSectionArr.length; i++) {
            var tempObj = {};
            tempObj['label'] = tempSubSectionArr[i].subsection_name;
            tempObj['id'] = tempSubSectionArr[i].subsection_id;
            if(rowData !=  undefined && rowData != [] && rowData.length > 0 ){
              console.log('edit',rowData )
              rowData.map((subsection) => {
                if((tempSubSectionArr[i].subsection_id === subsection.id) && (subsection.value === true)){
                   return tempObj['value'] = true;
                }
              })
            }
            tempSubSectionList.push(tempObj);
          }
        }
         this.setState({
         subsectionList: tempSubSectionList
         });
    });

    console.log('editmode',EditMode)
    if(EditMode === true){
        this.setState({isSubmitEnable: true})
    } else {
        this.setState({isSubmitEnable: false})
    }

    this.setState({
      selectedSectionIDInAdd:value,
      
    });
  };

  onDeleteSectionTableClick(rowData, index) {
    let tempData =  this.state.selectedSectionAndSubsectionList 
    let filteredTempData = tempData.filter((section) => section.id !== rowData.id);
    let filteredSelectedSectionArr = selectedSectionIDArray.filter((id) => id != rowData.id);
    selectedSectionIDArray = filteredSelectedSectionArr;
    this.setState({selectedSectionAndSubsectionList: filteredTempData})
  }
  
  onEditSectionTableClick(rowData, index){
    let sectionListArr = this.state.sections;
    this.setState({selectedSectionIDInAdd : rowData.id, SectionsListInAdd: sectionListArr , 
                    isSubmitEnable: true, EditMode:true, EditSectionId: rowData.id })
    this.onSingleSectionSelectedInAdd(rowData.id, rowData.subsectionList , true);
    this.setState({SectionAndSubsectionAddVisible: true})
  }
  
  SectionAndSubsectionShow() {
    if(this.state && this.state.selectedSectionAndSubsectionList !== []){
      this.state.selectedSectionAndSubsectionList.map((select, index) => {
        console.log('(select, index',select, index)
      })
    }
    this.setState({SectionAndSubsectionTableVisible: true })
  }

  SectionAndSubsectionHide() {
    this.setState({SectionAndSubsectionTableVisible: false })
  }

  OnSubmitSectionAndSubsection() {
    const {selectedSectionIDInAdd, SectionsListInAdd, subsectionList, selectedSectionAndSubsectionList ,
       EditMode, EditSectionId} =  this.state;
    let tempSectionList = [];
    let tempSelectedSectionAndSubsectionList = [];
   
     SectionsListInAdd.map((section) => {
       let tempStore = {};
       if(section.id ==  selectedSectionIDInAdd){
         tempStore.id = selectedSectionIDInAdd;
         tempStore.section_name = section.label;
         tempStore.subsection = []
         subsectionList.map((subsection) => {
           if(subsection && subsection.value === true){
            tempStore.subsection.push(subsection.label)
           }
          });

         tempStore.subsectionList = subsectionList;
         tempSectionList.push(tempStore);
       }
    });
   
    selectedSectionIDArray.push(selectedSectionIDInAdd);
    if(selectedSectionAndSubsectionList.length > 0 ){
      tempSelectedSectionAndSubsectionList.push(...selectedSectionAndSubsectionList);
      let SectionAlreadyExit = null;
      tempSelectedSectionAndSubsectionList.map((section, index) => {
         
        if(section.id === selectedSectionIDInAdd){
          console.log('index',index);
          SectionAlreadyExit = index
          }
      });

    /* Check if the section and subsection Already Exist */
    if(SectionAlreadyExit === null){
        tempSelectedSectionAndSubsectionList.push(...tempSectionList);
     }else{
       /* Compare Section and Subsection */

       if(!EditMode){
        let sectionOld = tempSelectedSectionAndSubsectionList[SectionAlreadyExit];
        let sectionNew = tempSectionList
  
        console.log('subsection', sectionOld,sectionNew);
  
         let subsection = [];
         subsection.push(...sectionOld.subsection);
         subsection.push(...sectionNew[0].subsection);
         subsection = subsection.filter((item, index, inputArray) => {
         return inputArray.indexOf(item) === index ;
         })
         
         // get Subsection name
         
         let SubsectionList = sectionOld.subsectionList;
         SubsectionList.push(...sectionNew[0].subsectionList);
         
         let SectionID = [];
         let DuplicateSection = [];
         
         let FinalArray = SubsectionList.filter((section) => { if(section.value === true){
         DuplicateSection.push(section.id);
         if(!SectionID.includes(section.id) || SectionID.length === 0){
           SectionID.push(section.id)
              return section 
            }
         } 
        });
         
         DuplicateSection = DuplicateSection.filter((item, index, inputArray) => {
         return inputArray.indexOf(item) !== index ;
         });
         
         sectionNew[0].subsection = subsection
         sectionNew[0].subsectionList = FinalArray
         
         if(DuplicateSection.length > 0) {
          let DuplicateSubsection = []
          let SectionName = sectionNew[0].section_name;
          sectionNew[0].subsectionList.map((subsection) => {
            if(DuplicateSection.some((item) => item ==  subsection.id)){
               DuplicateSubsection.push(subsection.label)
            }
          })
          console.log('DuplicateSection', DuplicateSubsection,SectionName )


          NotificationManager.warning(`${DuplicateSubsection.join(', ')} is already present in the selected ${SectionName}`, 'warning', 4000)
         }
         tempSelectedSectionAndSubsectionList.splice(SectionAlreadyExit, 1, ...sectionNew)
       }else {
         tempSelectedSectionAndSubsectionList.splice(SectionAlreadyExit, 1, ...tempSectionList)

       }
     }
    } else {

      tempSelectedSectionAndSubsectionList.push(...tempSectionList);
    }

    if(EditMode && EditSectionId !== selectedSectionIDInAdd ){
    let filteredTempData = tempSelectedSectionAndSubsectionList.filter((section) => section.id !== EditSectionId);
      tempSelectedSectionAndSubsectionList = filteredTempData;
    }

    this.setState({selectedSectionAndSubsectionList: tempSelectedSectionAndSubsectionList, 
                   SectionAndSubsectionAddVisible: false, EditMode:false, EditSectionId: 0,
                   selectedSectionIDInAdd : 0, subsectionList: [], isSubmitEnable: false })
  }

  /* Section and Subsection Table End */

  render() {
    const {isSubmitEnable, isEnableSubsection, isEnableSubsectionLTI, quizORTest} = this.state;
    
    //var inputClassName = {}
    if (this.state.pageLoading) {
      return <LoadingSpinner />;
    }

    var assigmentName = '';

    var tempRowDispalyNone = { display: 'none' };
    var tempRowDispalyBlock = { display: 'block' };

    var tempCategoryMasteryBtnShow = { display: 'block',float: 'left',marginTop:'21px',paddingLeft:'3px'};
    var tempCategoryMasteryBtnHide = { display: 'none',float: 'left',marginTop:'21px',paddingLeft:'3px'};
    const selectedOptionsStyles = {
      color: '#FFFFFF',
      backgroundColor: '#bb0000'
    };
    const optionsListStyles = {
      backgroundColor: '#bb0000',
      color: '#FFFFFF'
    };

    if (this.state.quiz_id == null) {
      assigmentName = <h1 className="fontClass"><b>Create an Assignment below</b></h1>;
    } else {
      assigmentName = <h1 className="fontClass"><b>Edit Assignment</b></h1>;
    }
    var tempQuizInfoArr = this.state.quizInfoArr;

    let selectedCategroyArr = [];
    
    let tempcategoryDetailsMap = this.state.categoryDetailsMap
    let catergoryAtBeginingPresent = Object.keys(tempcategoryDetailsMap).find(key => tempcategoryDetailsMap[key].category_at_begining === 1);
    let catergoryAtLastPresent = Object.keys(tempcategoryDetailsMap).find(key => tempcategoryDetailsMap[key].category_at_last === 1);

    let categoryAtFirstAfterIndex = -1;
    let categoryAtLastBeforeIndex = -1;
    
    if (catergoryAtLastPresent !== undefined && catergoryAtLastPresent !== null) {
      for (let i = tempQuizInfoArr.length - 1; i >= 0; i--) {
        let quiz = tempQuizInfoArr[i]
        if (`${quiz.subject_id}_${quiz.topic_id}_${quiz.category_id}` !== catergoryAtLastPresent) {
          categoryAtLastBeforeIndex = i;
          break;
        }
      }
    }

    if (catergoryAtBeginingPresent !== undefined && catergoryAtBeginingPresent !== null) {
      for (let i = 0; i < tempQuizInfoArr.length; i++) {
        let quiz = tempQuizInfoArr[i]
        if (`${quiz.subject_id}_${quiz.topic_id}_${quiz.category_id}` !== catergoryAtBeginingPresent) {
          categoryAtFirstAfterIndex = i;
          break;
        }
      }
    }

    const tempQuizInfoArrLen = tempQuizInfoArr.length

    for (let i = 0; i < tempQuizInfoArr.length; i++) {
     // if(tempQuizInfoArr.length== 0){
      //  NotificationManager.error('Atleast one subcategory should be added to the quiz');
    //  }
      // console.log("TEMPQUIZINFOARR",tempQuizInfoArr)

      let hideUpwardButton = ( 
          i=== 0
          ||
          (catergoryAtBeginingPresent !== undefined && tempQuizInfoArr[i].index.includes(catergoryAtBeginingPresent))
          ||
          (catergoryAtLastPresent !== undefined && tempQuizInfoArr[i].index.includes(catergoryAtLastPresent))
          ||
          i === categoryAtFirstAfterIndex
        )
      
      let hideDownwardButton = (
        i=== tempQuizInfoArrLen - 1
        ||
        (catergoryAtLastPresent !== undefined && tempQuizInfoArr[i].index.includes(catergoryAtLastPresent))
        ||
        (catergoryAtBeginingPresent !== undefined && tempQuizInfoArr[i].index.includes(catergoryAtBeginingPresent))
        ||
        i === categoryAtLastBeforeIndex
      ) 

      var subId = tempQuizInfoArr[i].category_name + i
      selectedCategroyArr.push(
        <tr style={{ fontSize: '14px' }} key={'catKey' + i}>
          <td style={{ width: '150px' }}>{tempQuizInfoArr[i].category_name}</td>
          <td style={{ width: '143px' }} >
            <label //for={subId}
            >
            {tempQuizInfoArr[i].subcategory_name}
            </label>
          </td>
          <td style={{ width: '70px', paddingLeft: '10px' }}>
            <Toggle
              id={subId}
              checked={
                tempQuizInfoArr[i].randomize_questions === 0 ? false : true
              }
              icons={false}
              width={230}
              onChange={this.checkBoxRandomizeSubcategoryOnChange.bind(this, i)}
            />
          </td>
          <td style={{width: '62px',paddingRight: "5px",paddingLeft: "5px" }}>
          <input type="number" style={{width: '50px' }}
                value={tempQuizInfoArr[i].subcategory_weight}
                onChange={(e) => this.subcategoryWeightTextOnChange(i, e)}
                id={subId}
                className="ColouredTextBox fontClass"
            />
            </td>
            <td style={{ width: '20px', paddingLeft: '5px' }}><center><span style={{fontWeight:"bold"}}  > {tempQuizInfoArr[i].question_count}</span></center></td>
            <td style={{ width: '20px', paddingLeft: '5px' }}>
            <Toggle
                id={subId}
                checked={
                tempQuizInfoArr[i].non_graded !== 0 ? false : true
              }
              icons={false}
              width={230}
              onChange={this.checkBoxNonGradedOnChange.bind(this, i)}
            />
          </td>
          <td style={{ width: '20px', paddingLeft: '5px' }}>
            <Toggle
                id={subId}
                checked={
                tempQuizInfoArr[i].enable_analytics
              }
              icons={false}
              width={230}
              onChange={ event => this.enableAnalyticsOnChange(event,i)}
            />
          </td>
          <td style={{ width: '20px', paddingLeft: '5px' }}>
            <Toggle
                id={subId}
                checked={
                tempQuizInfoArr[i].enable_feedback
                }
              icons={false}
              width={230}
              onChange={ event => this.enableFeedbackOnChange(event,i)}
            />
          </td>

          <td
            style={{ width: '100px', paddingLeft: '10px' }}
            value={tempQuizInfoArr[i].index}
          >
            {i === 0 ? null : <>
              <Button icon style={{ float: 'left' }} 
                onClick={hideUpwardButton ? null : this.moveRow.bind(
                    this,
                    tempQuizInfoArr[i].index,
                    true
                  )}
                  tooltipPosition="top"
                  className="custom-tooltip"
                  tooltipLabel={hideUpwardButton ? `Moving up is disabled\nbecause this category\nis checked either\nAt first or At last\nin category options` : null}
                  // disabled={hideUpwardButton}
                >
                <img
                  style={{ width: '20px', float: 'left', opacity: hideUpwardButton ? 0.3 : 1}}
                  src={upArrowIcon}
                  alt="UP"
                />
              </Button>
            </>}
              {i === tempQuizInfoArrLen - 1 ? null
                :<>
                <Button icon style={{ float: 'right' }}
                onClick={hideDownwardButton ? null : this.moveRow.bind(
                    this,
                    tempQuizInfoArr[i].index,
                    false
                  )}
                  tooltipPosition="top"
                  className="custom-tooltip"
                  tooltipLabel={hideDownwardButton ? `Moving down is disabled\nbecause this category\nis checked either\nAt First or At last\nin category options` : null}
                  // disabled={hideDownwardButton}
                >
                <img
                  style={{ width: '20px', float: 'left',opacity: hideDownwardButton ? 0.4 : 1,  }}
                  src={downArrowIcon}
                  alt="Down"
                />
              </Button>
                </>   }
          </td>
          <td
            style={{ width: '56px', paddingLeft: '10px' }}
            value={tempQuizInfoArr.index}
          >
            <Button icon
              style={{background: "transparent",border: "none"}}
              onClick={this.deleteSelectedSubcategory.bind(this,tempQuizInfoArr[i].index)}>
              <img
                style={{ width: '15px', float: 'left' }}
                src={crossIcon}
               
                alt="delete"
              />
            </Button>
          </td>
        </tr>
      );
    }
    let categoriesMasteryArr =[];
    let tempCategoriesUniqueArr =  this.state.categoriesUniqueArr;
    let tempCategoryDetailsMap = this.state.categoryDetailsMap;
    let tempCategoryQuestionCount = this.state.categoriesQuestionsCountMap
    console.log("tempCategoriesUniqueArr",tempCategoriesUniqueArr);
    for (let c = 0; c < tempCategoriesUniqueArr.length; c++) {
      //console.log("categoryDetailsMap",tempCategoryDetailsMap[tempCategoriesUniqueArr[i]]);
      categoriesMasteryArr.push(  
        <TableRowReact
        key={c}
        selectable={false} >     
       <TableColumn className="CategoryMasteryTextStyleII">
        {tempCategoryDetailsMap[tempCategoriesUniqueArr[c]].category_name}
      </TableColumn>

        {!this.state.quizORTest ? 
          <React.Fragment>
            <TableColumn style={{textAlign: 'center'}} className="CategoryMasteryTextStyleII">
              <input type="number" 
            value={tempCategoryDetailsMap[tempCategoriesUniqueArr[c]].category_mastery_count === undefined || 
              tempCategoryDetailsMap[tempCategoriesUniqueArr[c]].category_mastery_count  === 0 ? 
              this.state.masteryCondition : tempCategoryDetailsMap[tempCategoriesUniqueArr[c]].category_mastery_count}    
            style={{width:"40px"}}    
            onChange={(e) => this.categoryMasteryTextOnChange(c, e)}/>
            </TableColumn>
            <TableColumn style={{textAlign: 'center'}} className="CategoryMasteryTextStyleII">
              <input type="number" 
            value={tempCategoryDetailsMap[tempCategoriesUniqueArr[c]].category_nocqc === undefined || 
              tempCategoryDetailsMap[tempCategoriesUniqueArr[c]].category_nocqc  === 0 ? 
              this.state.NOCQC : tempCategoryDetailsMap[tempCategoriesUniqueArr[c]].category_nocqc}    
            style={{width:"40px"}}    
            onChange={(e) => this.categoryNocqcOnChange(c, e)}/>
            </TableColumn>
            <TableColumn style={{textAlign: 'center'}} className="CategoryMasteryTextStyleII">
                <Toggle
                  id={tempCategoriesUniqueArr[c]+"_RandomSubcategoryOrder"}
                  //ref="Mastery"
                  checked={tempCategoryDetailsMap[tempCategoriesUniqueArr[c]].random_subcategory_order === 1 ? true : false}
                  icons={false}
                  width={230}
                  onChange={(event)=>{this.onRandomSubcatOrderSwitchChange(tempCategoriesUniqueArr[c], event)}}
                  name={tempCategoriesUniqueArr[c]+"_RandomSubcategoryOrder"}
                  className="quizORTestClass"
                />
            </TableColumn> 
            <TableColumn style={{textAlign: 'center'}} className="CategoryMasteryTextStyleII">
                <Toggle
                  id={tempCategoriesUniqueArr[c]+"_isRequired"}
                  //ref="Mastery"
                  checked={tempCategoryDetailsMap[tempCategoriesUniqueArr[c]].category_is_required === 1 ? true : false}
                  icons={false}
                  width={230}
                  onChange={(event)=>{this.onIsRequiredSwitchChange(tempCategoriesUniqueArr[c], event)}}
                  name={tempCategoriesUniqueArr[c]+"_isRequired"}
                  className="quizORTestClass"
                />
            </TableColumn>
            <TableColumn  className="CategoryMasteryTextStyleII">
            <Toggle
              id={tempCategoriesUniqueArr[c]+"_at_begining"}
              //ref="Mastery"
              checked={tempCategoryDetailsMap[tempCategoriesUniqueArr[c]].category_at_begining === 1 ? true : false}
              icons={false}
              width={230}
              onChange={(event)=>{this.onCategoryPositionSwitchChange(tempCategoriesUniqueArr[c], event, "category_at_begining", "category_at_last")}}
              name={tempCategoriesUniqueArr[c]+"_at_begining"}
              className="quizORTestClass"
            />
         </TableColumn>
         <TableColumn style={{textAlign: 'center'}} className="CategoryMasteryTextStyleII">
            <Toggle
              id={tempCategoriesUniqueArr[c]+"_at_last"}
              //ref="Mastery"
              checked={tempCategoryDetailsMap[tempCategoriesUniqueArr[c]].category_at_last === 1 ? true : false}
              icons={false}
              width={230}
              onChange={(event)=>{this.onCategoryPositionSwitchChange(tempCategoriesUniqueArr[c], event, "category_at_last", "category_at_begining")}}
              name={tempCategoriesUniqueArr[c]+"_at_last"}
              className="quizORTestClass"
            />
          </TableColumn>
          </React.Fragment>
          :<React.Fragment>
          <TableColumn style={{textAlign: 'center'}} className="CategoryMasteryTextStyleII">
              <input type="number" 
            value={tempCategoryDetailsMap[tempCategoriesUniqueArr[c]].category_nocqc === undefined || 
              tempCategoryDetailsMap[tempCategoriesUniqueArr[c]].category_nocqc  === 0 ? 
              this.state.NOCQC : tempCategoryDetailsMap[tempCategoriesUniqueArr[c]].category_nocqc}    
            style={{width:"40px"}}    
            onChange={(e) => this.categoryNocqcOnChange(c, e)}/>
            </TableColumn> 
          <TableColumn  className="CategoryMasteryTextStyleII">
          <input type="number" 
          value={tempCategoryDetailsMap[tempCategoriesUniqueArr[c]].category_number_of_questions === undefined || 
            tempCategoryDetailsMap[tempCategoriesUniqueArr[c]].category_number_of_questions  === 0 ? 
            this.state.numbersQuestion : tempCategoryDetailsMap[tempCategoriesUniqueArr[c]].category_number_of_questions}    
          style={{width:"100px"}}    
          onChange={(e) => this.categoryNumberofQuestions(c, e)}/>
        </TableColumn>
        <TableColumn  className="CategoryMasteryTextStyleII">
        <center><span style={{fontWeight:"bold"}}  > {tempCategoryQuestionCount !== undefined && tempCategoryQuestionCount !== null && tempCategoryQuestionCount[tempCategoriesUniqueArr[c]] !== undefined && tempCategoryQuestionCount[tempCategoriesUniqueArr[c]] !== null ? tempCategoryQuestionCount[tempCategoriesUniqueArr[c]] : null}</span></center>
        </TableColumn>
        <TableColumn style={{textAlign: 'center'}} className="CategoryMasteryTextStyleII">
                <Toggle
                  id={tempCategoriesUniqueArr[c]+"_RandomSubcategoryOrder"}
                  //ref="Mastery"
                  checked={tempCategoryDetailsMap[tempCategoriesUniqueArr[c]].random_subcategory_order === 1 ? true : false}
                  icons={false}
                  width={230}
                  onChange={(event)=>{this.onRandomSubcatOrderSwitchChange(tempCategoriesUniqueArr[c], event)}}
                  name={tempCategoriesUniqueArr[c]+"_RandomSubcategoryOrder"}
                  className="quizORTestClass"
                />
        </TableColumn>
        <TableColumn  className="CategoryMasteryTextStyleII">
        <Toggle
          id={tempCategoriesUniqueArr[c]+"_at_begining"}
          //ref="Mastery"
          checked={tempCategoryDetailsMap[tempCategoriesUniqueArr[c]].category_at_begining === 1 ? true : false}
          icons={false}
          width={230}
          onChange={(event)=>{this.onCategoryPositionSwitchChange(tempCategoriesUniqueArr[c], event, "category_at_begining", "category_at_last")}}
          name={tempCategoriesUniqueArr[c]+"_at_begining"}
          className="quizORTestClass"
        />
      </TableColumn>
      <TableColumn  className="CategoryMasteryTextStyleII">
        <Toggle
          id={tempCategoriesUniqueArr[c]+"_at_last"}
          //ref="Mastery"
          checked={tempCategoryDetailsMap[tempCategoriesUniqueArr[c]].category_at_last === 1 ? true : false}
          icons={false}
          width={230}
          onChange={(event)=>{this.onCategoryPositionSwitchChange(tempCategoriesUniqueArr[c], event, "category_at_last", "category_at_begining")}}
          name={tempCategoriesUniqueArr[c]+"_at_last"}
          className="quizORTestClass"
        />
      </TableColumn></React.Fragment>
      }
          
        </TableRowReact>
      );

    }

    let subcateDisplayRow = { display: 'block', width: '100%' };
    let subcateDisplayRowHide = { display: 'none' };
    let loadingTopics = this.state.loadingTopics;
	let loadingCategoryOptionButton = this.state.loadingCategoryOptionButton;
    let loadingCategories = this.state.loadingCategories;
    let categories = this.state.categories;
    let subCategories = this.state.subCategories;
    let showSubcategoryData = this.state.showSubcategoryData;
    let categorySelected = this.state.categorySelected;
    let subcategoriesSelected = this.state.subcategoriesSelected;
    let hoverState = this.state.hoverState;
    let rowDispalyArrow = this.state.rowDispalyArrow;
    let loadingSave = this.state.loadingSave;

    let startDateLocal =  moment(this.state.startDate).toDate();
    let endtDateLocal =  moment(this.state.endDate).toDate();

   const categoryMasterActions = []
   const nocqcAlertActions = []
   categoryMasterActions.push(<Button
    raised
    primary
    style={{marginRight:'10px'}}
    className="buttonColour"
    onClick={this.CMHide}>Done
</Button>  );

nocqcAlertActions.push(
<React.Fragment>
<Button
  raised
  primary
  style={{marginRight:'10px'}}
  className="buttonColour"
  onClick={this.NocqcAlertHideandAllowtoSave}>Yes
</Button><Button
  raised
  primary
  style={{marginRight:'10px'}}
  className="buttonColour"
  onClick={this.NocqcAlertHide}>No
</Button></React.Fragment>  );

/* Section and subsection action */
  const SectionAndSubsectionTableAction = [];
  SectionAndSubsectionTableAction.push(<Button primary cstyle={styles.addButton}
  onClick={this.SectionAndSubsectionHide}>Done</Button>)
/*   SectionAndSubsectionTableAction.push(<Button secondary style={styles.cancelButton}
  onClick={this.SectionAndSubsectionHide}>Close</Button>) */

  let SectionAndSubsectionAddAction = [];
    SectionAndSubsectionAddAction.push(<Button primary cstyle={styles.addButton} disabled={!isSubmitEnable}
    onClick={this.OnSubmitSectionAndSubsection.bind(this)}>Submit</Button>)
    SectionAndSubsectionAddAction.push(<Button secondary style={styles.cancelButton}
    onClick={this.SectionAndSubsectionAddHide}>Close</Button>)
    return (
      <div
        style={{
          paddingLeft: '10px',
          backgroundColor: 'white',
          color: '#576271'
        }}
      >
      <div>
          <DialogContainer
             id="navigation-drawer-demo1"
             aria-label="Navigation Drawer Demo1"
             visible={this.state.visible}
             fullPage
             focusOnMount={false}           
             onHide={this.hide}
          >
          <div>
            <div style={{fontSize:'20px', paddingLeft:'10px', paddingTop:'10px'}}><b>Assignment:</b>{` ${this.state.assignmentName} Configuration`}<Button style={{float:"right", paddingTop: '0px'}} icon onClick={this.hide}>
              close
            </Button>
            <hr/>
            </div>
            <p style={{fontSize:'15px', paddingLeft:'10px'}}>Use this page to make changes to this Quiz that would affect an individual student or a section or a subsection</p>
            <EditWindow
              quizID = {this.state.quiz_id}
              sectionList = {this.state.sectionForQuizTime}
              courseID = {this.state.course_id}
              sectionID = {this.state.section_id}
              isEnableSubsection = {this.state.isEnableSubsection}
              selectedSectionAndSubsection = {this.state.selectedSectionAndSubsectionList}
             ></EditWindow>
          </div>

         
          
          {/*studentQuizDetailsArr*/}

          </DialogContainer>

          <DialogContainer
             id="navigation-drawer-demo"
             aria-label="Navigation Drawer Demo"
            visible={this.state.NocqcAlertVisible}
            width="400px"
            focusOnMount={false}           
            onHide={this.NocqcAlertHide}
            actions={nocqcAlertActions}
            title={<span>Attention!</span>}
          >
          <span>You have more than 1 category assigned in the test and NOCQC =1. Do you wish to proceed?</span>
          </DialogContainer>

          <DialogContainer
             id="navigation-drawer-demo"
             aria-label="Navigation Drawer Demo"
            visible={this.state.CMWindowVisible}
            width="850px"
            focusOnMount={false}           
            onHide={this.CMHide}
            actions={categoryMasterActions}
            title={<React.Fragment>
              <span>Category Options</span>
              <Button icon 
              style={{float:"right", paddingTop: '0px'}}
              onClick={this.CMHide}>
              close
              </Button></React.Fragment>}
          >
          {!quizORTest && this.state.allCategoriesAreRequired ?
            <React.Fragment>
            <label for="freeChoiceCount">
            Minimum number of Free Choice Categories to be completed<br/>(in addition to the required categories)
            </label>
              <input type="number" style={{width: '70px' }}
                value={this.state.freeChoiceCount}
                onChange={(e) => this.onFreeChoiceCountChanges(e)}
                id="freeChoiceCount"
                className="ColouredTextBox fontClass"
            />
            </React.Fragment>
            :""
            }
        <DataTable plain baseId="simple-pagination" className="QuizCategoryOptions">
                  <TableHeader>
                    <TableRowReact>
                      <TableColumn className="SectionWidgetHeaderStyle">
                      Categories
                      </TableColumn>
                      {!this.state.quizORTest ? 
                        <React.Fragment>
                          <TableColumn className="SectionWidgetHeaderStyle">
                          Mastery Condition
                          </TableColumn>
                          <TableColumn className="SectionWidgetHeaderStyle">
                          NOCQC
                          </TableColumn>
                          <TableColumn className="SectionWidgetHeaderStyle">
                          Random Subcategory Order
                          </TableColumn>
                          <TableColumn className="SectionWidgetHeaderStyle">
                          Required
                          </TableColumn>
                          <TableColumn className="SectionWidgetHeaderStyle">
                          At First
                         </TableColumn>
                         <TableColumn className="SectionWidgetHeaderStyle">
                         At Last
                         </TableColumn>
                        </React.Fragment>
                        :<React.Fragment>
                        <TableColumn className="SectionWidgetHeaderStyle">
                          NOCQC
                        </TableColumn>
                        <TableColumn className="SectionWidgetHeaderStyle">
                         # of Questions
                         <center><Button className='nocqcStyle' icon data-tip data-for='num-of-question'>help</Button>
                         <ReactTooltip id='num-of-question' type='light' className='tool-tip'>
                              <span>{"Indicate number of questions to be randomly chosen from the category (chosen according to subcategory weights). If left blank then all questions in the category will be presented."}</span>
                          </ReactTooltip></center>
                        </TableColumn>
                        <TableColumn className="SectionWidgetHeaderStyle">
                        <center># of Available Questions </center>
                       </TableColumn>
                       <TableColumn className="SectionWidgetHeaderStyle">
                          Random Subcategory Order
                        </TableColumn>
                        <TableColumn className="SectionWidgetHeaderStyle">
                        At First
                       </TableColumn>
                       <TableColumn className="SectionWidgetHeaderStyle">
                       At Last
                       </TableColumn></React.Fragment>
                      }
                    </TableRowReact>
                  </TableHeader>
                  <TableBody>
                  {categoriesMasteryArr}
                  </TableBody>
                </DataTable>
            
          {/*Categories mastery*/}
        
          </DialogContainer>
        
        {/* Section and Subection Table */}
        <DialogContainer
            id="navigation-drawer-demo"
            aria-label="Navigation Drawer Demo"
            visible={this.state.SectionAndSubsectionTableVisible}
            width="850px"
            contentClassName="copy-quiz-dialog" 
            focusOnMount={false}           
            onHide={this.SectionAndSubsectionHide}
            actions={SectionAndSubsectionTableAction}
            title={<React.Fragment>
              <span>Sections & Subsections</span>
              <Button icon 
              style={{float:"right", paddingTop: '0px'}}
              onClick={this.SectionAndSubsectionHide}>
              close
              </Button>
              <Button  
              raised
              primary
              className='buttonColour'
              style={{float:"right", marginRight: '10px'}}
              onClick={this.SectionAndSubsectionAddShow}>
              Add Sections & Subsections
              </Button>
              </React.Fragment>}
          >
               <DataTable plain baseId="simple-pagination">
                  <TableHeader>
                    <TableRowReact>
                      <TableColumn className="SectionWidgetHeaderStyle">
                        Sections
                      </TableColumn>
                          <TableColumn className="SectionWidgetHeaderStyle">
                         SubSections
                          </TableColumn>
                          <TableColumn className="SectionWidgetHeaderStyle">
                          Actions
                          </TableColumn>
                    </TableRowReact>
                  </TableHeader>
                  <TableBody>
                  {this.state.selectedSectionAndSubsectionList.map((rowData, index) => (
                    <TableRowReact
                    key={index}
                    selectable={false} > 
                      <TableColumn className="quizTableColumn">
                        {rowData.section_name}
                      </TableColumn>

                      {rowData.subsection.length > 1 ?<CollapsableColumn
                        data={rowData.subsection}
                        className="quizTableColumn"
                      >
                      </CollapsableColumn> :
                      <TableColumn className="quizTableColumn">
                      {rowData.subsection[0]}
                    </TableColumn>}
                    <TableColumn className="quizTableColumn">
                      <Button icon tooltipLabel="Edit" onClick={() => this.onEditSectionTableClick(rowData,index)}>
                          <img src={editIcon} alt="Edit"  />
                        </Button> {'  '}
                        <Button icon tooltipLabel="Delete" onClick={() => this.onDeleteSectionTableClick(rowData,index)}>
                          <img src={crossIcon} alt="Delete"/>
                        </Button>
                     </TableColumn>
                    </TableRowReact>
                  ))}
                </TableBody>
                </DataTable>
            
        
          </DialogContainer>

        {/* Section and Subection Add */}
          <DialogContainer
             id="navigation-drawer-demo"
             aria-label="Navigation Drawer Demo"
             visible={this.state.SectionAndSubsectionAddVisible}
             width="450px"
             focusOnMount={false}   
             modal
             contentClassName="md-grid copy-quiz-dialog"        
             onHide={this.SectionAndSubsectionAddHide}
             actions={SectionAndSubsectionAddAction}
             title={<React.Fragment>
              <span>Sections & Subsections</span>
            {/*   <Button  
              raised
              primary
              className='buttonColour'
              style={{float:"right"}}
              onClick={this.SectionAndSubsectionAddHide}>
              Add Sections & Subsections
              </Button> */}
              </React.Fragment>}
          >
             <React.Fragment>
                        <Cell size={12} className='md-body-4'>
                        <CardTitle style={{padding:'0px', fontSize:'13px'}}>Select Sections</CardTitle>
                        <SelectField
                          id="quiz-section-select"
                          fullWidth={true}
                          onChange={this.onSingleSectionSelectedInAdd}
                          menuItems={this.state.SectionsListInAdd}
                          value={this.state.selectedSectionIDInAdd}
                          itemValue="id"
                          style={{
                            color:"#000d11",
                            fontSize:"14px"
                          }}
                        />
                        </Cell>

                        {this.state.selectedSectionIDInAdd !== 0 && this.state.subsectionList.length > 0  &&
                        <Cell size={12} className='md-body-4'>
                        <CardTitle style={{padding:'0px', fontSize:'13px'}}>Select SubSection</CardTitle>
                        <MultiSelectReact
                          options={this.state.subsectionList}
                          optionClicked={this.optionClickedInAdd.bind(this)}
                          selectedBadgeClicked={this.selectedBadgeClickedInAdd.bind(this)}
                          selectedOptionsStyles={selectedOptionsStyles}
                          optionsListStyles={optionsListStyles}
                        />
                        </Cell>}
                        </React.Fragment>
          </DialogContainer>


        </div>
     
        <div style={{ paddingLeft: '10px', paddingTop: '8px' }}>
          {assigmentName}
          </div>
                  
          <div style={{ float: 'right',marginTop: '-25px'  }}>
            <Grid container>
           <Grid item>
            <div className="floatRight">
              <Toggle
                id="Nongraded/graded"
                checked={this.state.Is_Nongraded}
                icons={false}
                width={230}
                onChange={this.nonGradedOnChange}
                className="nongradedClass"
              />
              </div>

              <p className="floatRight testTimePara">
                <label for="Nongraded/graded">
                Non Graded
                </label>
                <Button className='nocqcStyle' icon data-tip data-for='is_nongraded'>help</Button>
                      <ReactTooltip id='is_nongraded' type='light' className='tool-tip tooltip-width' place='left' >
                        <span>{"If Enabled, Score will not be evaluated in Gradebook Total score or Mean score."}</span>
                      </ReactTooltip>
              </p>
            </Grid>
            <Grid item style={{display:"none"}}>
            <div className="floatRight">
              <Toggle
                id="allowPractice"
                checked={this.state.allowPractice}
                icons={false}
                width={230}
                onChange={this.onAllowPracticeChange}
                className="nongradedClass"
              />
              </div>

              <p className="floatRight testTimePara">
                <label for="Nongraded/graded">
                Allow practice
                </label>
                <Button className='nocqcStyle' icon data-tip data-for='allow_practice'>help</Button>
                <ReactTooltip id='allow_practice' type='light' className='tool-tip tooltip-width' place='left' >
                  <span>{"If enabled, students can practice this assignement"}</span>
                </ReactTooltip>
              </p>
            </Grid>
            <Grid item>
            <div className="floatRight">
              <Toggle
                id="quiz/Test"
                ref="Mastery"
                checked={this.state.quizORTest}
                icons={false}
                width={230}
                onChange={this.quizORTestOnChange}
                className="quizORTestClass"
              />
              </div>
              {/* {this.state.quizORTest ? "Test (one attempt only, timed, no feedback)" :"Mastery practice assignment"} */}
              <p className="floatRight testTimePara">
                <label for="quiz/Test">
                Test
                </label>
                <Button className='nocqcStyle' icon data-tip data-for='test-mode'>help</Button>
                      <ReactTooltip id='test-mode' type='light' className='tool-tip tooltip-width' place='left' >
                        <span>{this.helpTextModel.getHelpTextForKey('Test Mode')}</span>
                      </ReactTooltip>
              </p>
            </Grid>
            {!this.state.quizORTest ? 
            <>
              <Grid item>
                <div className="floatRight">
                  <Toggle
                    id="allow_partial_credit"
                    checked={this.state.allowPartialCredit}
                    icons={false}
                    width={230}
                    onChange={this.handleToggleAllowPartialCredit}
                    className="nongradedClass"
                  />
                </div>

                <p className="floatRight testTimePara">
                  <label for="allow_partial_credit">
                    Allow Partial Credit
                  </label>
                  <Button className='nocqcStyle' icon data-tip data-for='allow_partial_credit'>help</Button>
                  <ReactTooltip id='allow_partial_credit' type='light' className='tool-tip custom-tooltip-width' place='left'>
                    <ul className='anonymous-tooltip'>
                      {this.helpTextModel.getHelpTextForKey('Allow Partial Credit')}
                    </ul>
                  </ReactTooltip>
                </p>
              </Grid>
              <Grid item>
                <div className="floatRight">
                  <Toggle
                    id="allow_pause_category"
                    checked={this.state.allowPauseCategory}
                    icons={false}
                    width={230}
                    onChange={this.handleToggleAllowPauseCategory}
                    className="nongradedClass"
                  />
                </div>

                <p className="floatRight testTimePara">
                  <label for="allow_pause_category">
                    Allow Pause Category
                  </label>
                  <Button className='nocqcStyle' icon data-tip data-for='allow_pause_category'>help</Button>
                  <ReactTooltip id='allow_pause_category' type='light' className='tool-tip custom-tooltip-width' place='left'>
                    <ul className='anonymous-tooltip'>
                      {this.helpTextModel.getHelpTextForKey('Allow Pause Category')}
                    </ul>
                  </ReactTooltip>
                </p>
              </Grid>
            </>
              : null}
            {this.state.is_lti_enabled && JSON.parse(this.state.is_lti_enabled) ? null :
              <Grid item>
                <div className="floatRight">
                  <Toggle
                    id="anonymous_assignment"
                    checked={this.state.isAnonymous}
                    icons={false}
                    width={230}
                    onChange={this.handleToggleAnonymous}
                    className="nongradedClass"
                  />
                </div>

                <p className="floatRight testTimePara">
                  <label for="anonymous_assignment">
                    Anonymous
                  </label>
                  <Button className='nocqcStyle' icon data-tip data-for='is_anonymous'>help</Button>
                  <ReactTooltip id='is_anonymous' type='light' className='tool-tip tooltip-width' place='left' >
                    <ul className='anonymous-tooltip'>
                      <li>If enabled, anyone with anonymous link can attend the assignment without having to register to Stemfluency.</li>
                      <li>Anyone registered with Stemfluency who takes this assignment remains anonymous.</li>
                    </ul>
                  </ReactTooltip>
                </p>
              </Grid>
            }

            {this.state.isAnonymous && !(this.state.is_lti_enabled && JSON.parse(this.state.is_lti_enabled))  ? 
                <Grid item>
                    <ReactTooltip id='copy-anonymous-btn' type='light' className='tool-tip tooltip-width' place='bottom' >
                      {!this.state.quiz_id  ? 
                        <span>Please create the assignment!</span>
                      : <span>Copy Anonymous Link</span>}
                    </ReactTooltip>
                  
                  <Button icon className="text-white"
                    onClick={()=> {
                      console.debug("this.state.anonymousLink", this.state.anonymousLink)
                      navigator.clipboard.writeText(this.state.anonymousLink)
                      NotificationManager.success("Anonymous Link was copied to your clipboard.", "")
                    }}
                    data-tip data-for='copy-anonymous-btn'
                    disabled={this.state.quiz_id === null || this.state.quiz_id === undefined}
                    style={{
                      display:'flex',
                      justifyContent:'center',
                      alignItems:'center'
                    }}
                    >
                    {/* Copy Anonymous Assignment Link */}
                    <div>
                      <FontIcon style={{fontSize:'2rem'}}>link</FontIcon>
                    </div>
                  </Button>
                </Grid>
              : null}
            {this.state.quizORTest ? 
              <Grid item>
              <div className="floatRight">
                <Toggle
                  id="one_page_mode"
                  ref="Mastery"
                  checked={this.state.onePageMode}
                  icons={false}
                  width={230}
                  onChange={this.toggleFullTestQuestion}
                  className="quizORTestClass"
                />
                </div>
                <p className="floatRight testTimePara">
                  <label for="one_page_mode">
                  One Page Mode
                  </label>
                  <Button className='nocqcStyle' icon data-tip data-for='one_page_mode'>help</Button>
                  <ReactTooltip id='one_page_mode' type='light' className='tool-tip tooltip-width' place='left' >
                    <span>All questions are shown at once. When turned ON, all randomization should be turned OFF</span>
                  </ReactTooltip>
                </p>
              </Grid>
            : null}
            {this.state.quiz_id != null ? 
              <React.Fragment>
                <Grid item>
                  <Button flat primary swapTheming className="floatRight"
                    onClick={this.handleAttendQuiz}>
                    {this.state.isQuizAttendedByUser ? "Resume Preview" : "Preview"}
                  </Button>
                </Grid>
                {this.state.isQuizAttendedByUser ? 
                <Grid item>
                  {this.state.resetAttendQuizButtonLoader ?
                    <LoadingSpinner />
                  :
                    <Button flat primary swapTheming className="floatRight"
                      onClick={()=>this.handleDeleteUserDataForQuiz(true)}>
                      {"Reset Preview"}
                    </Button>
                  }
                </Grid>
                :""}
              </React.Fragment>
            :""}
            </Grid>
        </div>

      
        <Grid style={{width:'100%',height:'100px'}}>
          <Cell size={4} phoneSize={4} tabletSize={8}>
            <TextField
              id="assignmentName"
              label="Name"
              lineDirection="center"
              placeholder="Assignment Name"
              inputClassName="fontClass"
              value={this.state.assignmentName}
              onChange={this.assignmentNameOnChange}
              errorText="This field is required."
            />
          </Cell>
          <Cell size={2} phoneSize={2} tabletSize={4}>
                <DatePicker
                  id="startDate"
                  label="Start Date"
                  displayMode="portrait"
                  value={isValidDate(startDateLocal)?startDateLocal:null}
                  onChange={this.handleChangeStartDate}

                />
          </Cell>
          <Cell size={2} phoneSize={2} tabletSize={4}>
              <TimePicker
                  id="startTime"
                  label="Start Time"
                  displayMode="portrait"
                  value={isValidDate(startDateLocal)?startDateLocal:null}
                  onChange={this.handleChangeStartDate}
              />
          </Cell>
          <Cell size={2} phoneSize={2} tabletSize={4}>
              <DatePicker
                  id="endDate"
                  label="End Date"
                  displayMode="portrait"
                  value={isValidDate(endtDateLocal)?endtDateLocal:null}
                  onChange={(_, date) => this.handleChangeEndDate(date, "date")}


                />
            
          </Cell>
          <Cell size={2} phoneSize={2} tabletSize={4}>
              <TimePicker
                  id="endTime"
                  label="End Time"
                  displayMode="portrait"
                  value={isValidDate(endtDateLocal)?endtDateLocal:null}
                  onChange={(_, date) => this.handleChangeEndDate(date, "time")}
                />
            
          </Cell>
          <Cell size={8} phoneSize={2} tabletSize={4}>
          
          </Cell>
        </Grid>
        <div
          className="md-grid" id="md-grid-id-2"
          style={{ color: '#576271', float: 'left', paddingRight: '5px'}}
        >
          <p />
          { !this.state.quizORTest ? <div className="md-cell--2 md-cell--bottom md-center-tabs" style={{width:'150px'}}>
            <div className="masterySubHeading">
              <label for="defaultMastery"><div>Default Mastery<Button className='nocqcStyle' icon data-tip data-for='default-mastery'>help</Button>
                      <ReactTooltip id='default-mastery' type='light' className='tool-tip'>
                        <span>{this.helpTextModel.getHelpTextForKey('Default Mastery')}</span>
                      </ReactTooltip></div>
              </label>
            </div>
            <div className=".md-selection-control-container">
              <input
                id="defaultMastery"
                type="text"
                value={this.state.masteryCondition}
                onChange={this.masteryConditionOnChange}
                className="ColouredTextBox fontClass"
                disabled ={(this.state.quizORTest === true) ? true : false}
              />
            </div>
          </div> : ''}

          { !this.state.quizORTest ? <div className="md-cell--2 md-cell--bottom" style={{width:'150px'}}>
            <div className="masterySubHeading">
              <label for="max.attempts"><div>Max. attempts<Button className='nocqcStyle' icon data-tip data-for='max-attempts'>help</Button>
                      <ReactTooltip id='max-attempts' type='light' className='tool-tip tooltip-width'>
                        <span>{this.helpTextModel.getHelpTextForKey('Max Attempts')}</span>
                      </ReactTooltip></div>
              </label>
              </div>
            <div className="md-selection-control-container">
              <input
                id="max.attempts"
                type="text"
                value={this.state.maximumAttendPerQuestion}
                onChange={this.maximumAttendPerQuestionOnChange}
                className="ColouredTextBox fontClass"
                disabled ={(this.state.quizORTest === true) ? true : false}
              />
            </div>
          </div> : ''}
          <div className="md-cell--1.5 md-cell--bottom">
            <div className="masterySubHeading">
              <label for="nocqcId">NOCQC</label>
              <Button className='nocqcStyle' icon data-tip data-for='nocqc'>help</Button>
                      <ReactTooltip id='nocqc' type='light' className='tool-tip custom-tooltip-width'>
                        <span>{this.helpTextModel.getHelpTextForKey('NOCQC')}</span>
                      </ReactTooltip>
            </div>
            <div className=".md-selection-control-container">
              <input
                id="nocqcId"
                type="text"
                value={this.state.NOCQC}
                onChange={this.noCQCOnChange}
                className="ColouredTextBox fontClass"
              />
            </div>
          </div>
          <div className="md-cell--1.5 md-cell--bottom">
            <div className="masterySubHeading">
              <label for="nocqcId">LockOut</label>
              <Button className='nocqcStyle' icon data-tip data-for='lockoutN'>help</Button>
                      <ReactTooltip id='lockoutN' type='light' className='tool-tip custom-tooltip-width'>
                        <span>{this.helpTextModel.getHelpTextForKey('LockOut')}</span>
                      </ReactTooltip>
            </div>
            <div className=".md-selection-control-container">
              <input
                id="nocqcId"
                type="text"
                value={this.state.LockOutN}
                onChange={this.lockOutNChange}
                className="ColouredTextBox fontClass"
              />
            </div>
          </div>
          <div className="md-cell--3 md-cell--bottom" style={{width: '210px'}}>
            <SelectionControlGroup style={{marginLeft:'0px'}}
              id="selection-control-group-radios-Randomize"
              name="radio-example"
              type="radio"
              label={<div>Random category order<Button className='nocqcStyle' icon data-tip data-for='random-category-order'>help</Button>
              <ReactTooltip id='random-category-order' type='light' className='tool-tip custom-tooltip-width'>
                <span>{this.helpTextModel.getHelpTextForKey('Random category order')}</span>
              </ReactTooltip></div>}
              value={this.state.randomizeCategories}
              controls={[
                {
                  label: 'Yes',
                  value: 1
                },
                {
                  label: 'No',
                  value: 0
                }
              ]}
              onChange={this.randomizeCategoriesOnChange}
              className="radioButtonAlign"
            />  
          </div>
          <div className="md-cell--3 md-cell--bottom">
          
            <div
              className="fontClass-14"
              style={{ paddingTop: '7px', width: '250px' ,color:"#000d11",
              fontSize:"14px",marginTop:'0px'}}
            >
              Section List
              {
                this.appProperties.enableLTI?
                <SelectField
                  id="quiz-section-select"
                  fullWidth={true}
                  onChange={this.onSingleSectionSelected}
                  menuItems={this.state.sections}
                  value={this.state.selectSectionID}
                  itemValue="id"
                  style={{
                    color:"#000d11",
                    fontSize:"14px"
                  }}
                />
                :
                !isEnableSubsection ?
                <SectionDropDown
                  NoLoader={true}
                  QuizCreation={true}
                  selectedCourseID={parseInt(this.state.course_id, 10)}
                  //sectionMap={this.state.propSections}
                  sectionArray = {this.state.propSections}
                  selectBoxID="sectionSelectBox"
                  placeholder="Select   Section"
                  fullWidth
                  onChange={this.onSectionChange}
                  className=" gradebook-dropdown"
                  selectAll={false}/>
                  : 
                 <div  style={{display: 'block',width:'200px',marginTop:'21px',paddingLeft:'3px', marginRight:'10px'}}>
                  {console.log("this.state.isTestTimerEnabled mastery =",this.state.quizORTest) }
                    <Button
                        raised
                        primary                
                        className="buttonColour" onClick={this.SectionAndSubsectionShow}
                       
                        >Sections & Subsections</Button>
                        
                </div>
              }
            </div>
           
          </div>
         

          {this.state.isSubsectionEnabled && <div className="md-cell--1 md-cell--bottom" style={{marginLeft: '70px'}}>

            <div
              className="fontClass-14"
              style={{ paddingTop: '7px', width: '250px' ,color:"#000d11", marginBottom: '5px',
              fontSize:"14px",marginTop:'0px'}}
                >Enable Subsections </div>
              <Toggle
                id="testtimeid"
                ref="test"
                checked={this.appProperties.enableLTI? isEnableSubsectionLTI : isEnableSubsection}
                icons={false}
                width={230}
                onChange={this.EnableSubsectionOnChange}
              />
          
        </div>}
         
          {/**
          Commenting out Survey Radio since it is not being used  
          <div className="md-cell--3 md-cell--bottom">
            <SelectionControlGroup
              id="radioEnableSurvey"
              name="radioEnableSurvey"
              type="radio"
              label="Enable Survey"
              value={this.state.enableSurvey}
              controls={[
                {
                  label: 'Yes',
                  value: true
                },
                {
                  label: 'No',
                  value: false
                }
              ]}
              onChange={this.onEnableSurveyChange}
              className="radioButtonAlign"
            />
          </div>
         
           <SegmentedControl className="segmentedControlClass"
              name="oneDisabled"
              options={[
                { label: 'No time', value: 'noTime', default: true },
                { label: 'Fixed elapsed time', value: 'elapsedTime' },
                { label: 'Fixed absolute time', value: 'Explanation' }
              ]}
              style={{width:'300px'}}
             // setValue={newValue => this.tabOnChange(newValue)}
              //style={styles.SegmentedControlCatDetails} //
            />
          */}
        </div>
        { isEnableSubsectionLTI && this.state.subsectionList.length > 0 &&
        <div
          className="md-grid" id="md-grid-id-2"
          style={{marginLeft:quizORTest ? '-130px' : '', color: '#576271', float: 'left', paddingRight: '5px'}}
        >
      
                <div className="md-cell--2 md-cell--bottom">
                  <div
                    className="fontClass-14"
                    style={{ paddingTop: '7px', width: '250px' ,color:"#000d11",
                    fontSize:"14px",marginTop:'0px'}} >
                      <CardTitle style={{padding:'0px', fontSize:'13px' , marginBottom: '10px'}}>Select SubSection</CardTitle>
                      <MultiSelectReact
                        options={this.state.subsectionList}
                        optionClicked={this.optionClickedInAdd.bind(this)}
                        selectedBadgeClicked={this.selectedBadgeClickedInAdd.bind(this)}
                        selectedOptionsStyles={selectedOptionsStyles}
                        optionsListStyles={optionsListStyles}
                      />
                </div>
                </div>
        </div>
                }
        <div
          style={
            this.state.quizORTest ? tempRowDispalyBlock : tempRowDispalyNone
          }
          className="floatRight testTime"
        > 
          <div className="container">
            <div className="floatRight togglePading">
              <Toggle
                id="testtimeid"
                ref="test"
                checked={this.state.isTestTimerEnabled}
                icons={false}
                width={230}
                onChange={this.isTestTimerOnChange}
              />
            </div>
            <p className="floatRight testTimePara"> <label for="testtimeid">Test Time</label>
            <Button className='nocqcStyle' icon data-tip data-for='test-time'>help</Button>
                      <ReactTooltip id='test-time' type='light' className='tool-tip'>
                        <span>{this.helpTextModel.getHelpTextForKey('Test Time')}</span>
                      </ReactTooltip>
            </p>
            
            <div
              className="floatRight setTime"
              style={
                this.state.isTestTimerEnabled ? tempRowDispalyBlock : tempRowDispalyNone
              }
            >
            <label for="testTimeMinId">
              (in min) &nbsp;
            </label>
              <input
                id="testTimeMinId"
                type="number"
                value={this.state.testTimerValue}
                onChange={this.testTimerOnChange}
                className="ColouredTextBox"
                style={{ opacity: '1' }}
              />
             
              {/* bug id 121 fixes */}
            </div>
          </div>
        </div>

        <div
          style={{ marginLeft: '0px', marginTop: '0px', float: 'left' }}
          className="fontClass"
        >
          {/* {Question Div} */}

          <Grid container>
          <div
            style={{
              float: 'left',
              color: '#576271',
              paddingLeft: '15px',
              paddingRight: '10px'
            }}
          >
            <SelectBox
              columns={this.state.subjects}
              keys={['subject_id', 'subject_name']}
              style={styles.select}
              selectBoxcallBack={this.selectBoxSubjectHandleChange}
              defaultId={this.state.subjectDefaultId}
              labeltxt="Subjects"
            />
          </div>
          <div style={{ float: 'left', color: '#576271' }}>
            
            {loadingTopics ? (
              <LoadingSpinner />
            ) : (
              <SelectBox
                columns={this.state.topics}
                keys={['topic_id', 'topic_name']}
                style={styles.select}
                selectBoxcallBack={this.selectBoxTopicHandleChange}
                defaultId={this.state.topicDefaultId}
                labeltxt="Topics"
              />
            )}
          </div>
          <div  style={{display: 'block',float: 'left',marginTop:'21px',paddingLeft:'3px'}}>
            {console.log("this.state.isTestTimerEnabled mastery =",this.state.quizORTest) }
			{loadingCategoryOptionButton ? 
			<LoadingSpinner /> : 
          <Button
                  raised
                  primary                
                  className="buttonColour" onClick={this.CMShow}
                 
                  >Category Options</Button>
				  }
                  <Button className='nocqcStyle' style={{top:"-12px"}} icon data-tip data-for='category-options'>help</Button>
                      <ReactTooltip id='category-options' type='light' className='tool-tip'>
                        <span>{this.helpTextModel.getHelpTextForKey('Category Options')}</span>
                      </ReactTooltip>
                  
          </div>
          <div>
          <Button
           raised
           primary
           tooltipPosition='bottom'
           style={{marginLeft:'3px',marginTop:'21px'}}
           className="buttonColour"
           onClick={this.show}>Edit due dates and Locks</Button>
            <Button className='nocqcStyle' style={{top:"-12px"}} icon data-tip data-for='edit-due-dates'>help</Button>
                      <ReactTooltip id='edit-due-dates' type='light' className='tool-tip'>
                        <span>{this.helpTextModel.getHelpTextForKey('Edit Due Dates')}</span>
                      </ReactTooltip>
            </div>
            {this.state.quizORTest?
            <Grid item// className="awardFlagSpan" 
            >
          <p className="floatRight testTimePara"> <label for="testtimeid1">Award full score if completed</label><Button className='nocqcStyle' icon data-tip data-for='award-full-score-if-completed'>help</Button>
                      <ReactTooltip id='award-full-score-if-completed' type='light' className='tool-tip'>
                        <span>{this.helpTextModel.getHelpTextForKey('Award full score if completed')}</span>
                      </ReactTooltip></p>
          <Toggle //className="awardToggle" 
            style={{marginLeft:'60px'}}
            id="testtimeid1"
            ref="test1"
            checked={this.state.isFullMarkOptionEnabled}
            icons={false}
            width={230}
            onChange={this.FullMarkOptionOnChange}
          />
          </Grid>:''}
            { this.state.isTestTimerEnabled?
            <Grid item//className = "absoluteTimeToggle"
            >
              <p className="floatRight testTimePara"> <label for="testtimeid1">Fixed Timer</label></p>
              <Toggle //className = "absoluteTimerToggleClass"
                id="testtimeid1"
                ref="test3"
                checked={this.state.isAbsoluteTimerEnabled}
                icons={false}
                width={230}
                onChange={this.isAbsoluteTimerOnChange}
              />
            </Grid>:''}
            </Grid>

          <div className="commonDiv" >
            <div className="leftPanel" style={{height:'400px'}}>
              <div style={{ float: 'center' }}>
                <div className="panelHeading fontClass">
                  Select Categories/Subcategories
                </div>
                <Button className='nocqcStyle' icon data-tip data-for='select-categories-subcategories'>help</Button>
                      <ReactTooltip id='select-categories-subcategories' type='light' className='tool-tip'>
                        <span>{this.helpTextModel.getHelpTextForKey('Select Categories/SubCategories')}</span>
                      </ReactTooltip>
                <Button
                  flat
                  primary
                  swapTheming
                  onClick={this.addCategoryForQuiz}
                  className="floatRight"
                >
                  Add
                </Button>
                <Button className='nocqcStyle' style={{ float: 'right' }} icon data-tip data-for='add-categories-subcategories'>help</Button>
                      <ReactTooltip id='add-categories-subcategories' type='light' className='tool-tip'>
                        <span>{this.helpTextModel.getHelpTextForKey('Add Categories/SubCategories')}</span>
                      </ReactTooltip>
              </div>
              <div>

                <table className="panelTable" style={{height:'367px'}}>
                
                  <thead>
                    <tr className="noStyle">
                      <td style={{ width: '15px' }} />
                      <th style={{ width: '170px' }}>Categories</th>
                      <th title="Difficulty Level" style={{ width: '120px' }}>
                        Accuracy
                      </th>
                      <th style={{ width: '80px' }}>Time</th>
                      <th style={{ width: '50px' }}>Selected</th>
                    </tr>
                  </thead>
                  <tbody
                    style={{
                      height: '300px',
                      overflowY: 'auto',
                      overflowX: 'hidden'
                    }}
                  >
                    {loadingCategories ? (
                      <LoadingSpinner />
                    ) : (
                      categories.map((categories, j) => (
                        <div>
                          <TableRow
                            key={j}
                            data={categories}
                            //pushId ={"topics"}
                            id={categories.category_id}
                            name={categories.category_name}
                            dataSubcategoryArr={subCategories}
                            //title = {"Topics"}
                            type={'quizCreation'}
                            //url = {'category?topic_id=' + topic.topic_id+'&subject_id='
                            //    + subject_id+'&subject_name='+subject_name+
                            //  '&topic_name='+ topic.topic_name}
                            onEditClick={() => this.showSubcategoryDetails(j)}
                            showSubcategoryData={showSubcategoryData}
                            onAddCategory={this.addCategoryForQuiz}
                            checkBoxCategoryOnChange={
                              this.checkBoxCategoryOnChange
                            }
                            checkBoxRandomizeCategoryOnChange={
                              this.checkBoxRandomizeCategoryOnChange
                            }
                            checkBoxRandomizeSubcategoryOnChange={
                              this.checkBoxRandomizeSubcategoryOnChange
                            }
                            categorySelected={categorySelected}
                            subcategoriesSelected={subcategoriesSelected}
                            checkBoxSubcategoryOnChange={
                              this.checkBoxSubcategoryOnChange
                            }
                            hoverOn={this.hoverOn}
                            hoverOff={this.hoverOff}
                            index={j}
                            hideSubcategoryDiv={hideSubcategoryDiv}
                            showSubcategoryDiv={showSubcategoryDiv}
                            hoverState={hoverState}
                            rowDispalyArrow={rowDispalyArrow}
                            onSelectCategory={this.onSelectCategory}
                            instructorSubject = {true}

                          />

                          {subcategoriesSelected.map(
                            (subCat, i) =>
                              subcategoriesSelected[i].category_id ===
                              categories.category_id ? (
                                <tr
                                  onClick={this.checkBoxSubcategoryOnChange.bind(
                                    i,
                                    i
                                  )}
                                  style={
                                    categorySelected[j].showSubcategory
                                      ? subcateDisplayRow
                                      : subcateDisplayRowHide
                                  }
                                >
                                  <td style={{ width: '16px' }} />
                                  <td value={i} style={{ width: '179px' }}>
                                    <div className="">
                                      <button  className='ButtonLink aHrefClass'> {subCategories[i].subcategory_name}</button>
                                      {/* <a  className="aHrefClass" >{subCategories[i].subcategory_name}</a> */}
                                    </div>
                                  </td>
                                  <td className="fixedWidth">
                                    <div>
                                      {
                                        subcategoriesSelected[i]
                                          .difficulty_level
                                      }
                                    </div>
                                  </td>
                                  <td className="fixedWidth">
                                    <div>
                                      {subcategoriesSelected[i].avg_time}
                                    </div>
                                  </td>
                                  <td>
                                    {subcategoriesSelected[i].checked ? (
                                      <img
                                        alt=""
                                        title="Click down"
                                        className="successIconPadding"
                                        src={successIcon}
                                      />
                                    ) : (
                                      <div style={{ width: '50px' }} />
                                    )}
                                  </td>
                                </tr>
                              ) : (
                                ''
                              )
                          )}
                        </div>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="rightPanel" style={{height:'400px'}}>
            <div style={{ float: 'center' }}>
                <p className="panelHeading fontClass">
                  {' '}
                  Chosen Categories/Subcategories
                </p>
                            </div>

              <div style={{ float: 'right' }}>
                <p
                  className="fontClass"
                  style={{
                    color: 'inherit',
                    padding: '5px 10px 0px 0px',
                    fontSize: 'smaller',
                    fontWeight: 'bold'
                  }}
                >
                  {' '}
                  Mastery Units:{this.state.masteryUnit}
                </p>
              </div>
              
              <table className="quizTable" style={{tableLayout :"fixed"}}>
              <tbody style={{height: "365px"}}//,width: "658px"}}>
                  >

                    <tr style={{position:"sticky",fontWeight: "bold"}}>
                    <td style={{paddingLeft:"0px",textAlign:"center", width: '150px' }}>Categories</td>
                    <td style={{paddingLeft:"0px",textAlign:"center", width: '143px' }}>Subcategories</td>
                    <td style={{paddingLeft:"0px",textAlign:"center", width: '70px' }}>
                      <span style={{fontFamily:'inherit',color:'inherit'}}>Random question order</span>
                     
                      <Button className='nocqcStyle' icon data-tip data-for='random-question-order'>help</Button>
                      <ReactTooltip id='random-question-order' type='light' className='tool-tip'>
                        <span>{this.helpTextModel.getHelpTextForKey('Random question order')}</span>
                      </ReactTooltip>
                    </td>
                    <td style={{paddingLeft:"0px",textAlign:"center", width: '20px' }}>
                      <span style={{fontFamily:'inherit',color:'inherit'}} >NOCQSC</span>
                      <Button className='nocqcStyle' icon data-tip data-for='Weights'>help</Button>
                      <ReactTooltip id='Weights' type='light' className='tool-tip custom-tooltip-width'>
                        <span>{this.helpTextModel.getHelpTextForKey('Weights')}</span>
                      </ReactTooltip>
                    </td>
                    <td style={{paddingLeft:"0px",textAlign:"center", width: '20px' }}>
                      <span style={{fontFamily:'inherit',color:'inherit'}} >Available Questions</span>
                      <Button className='nocqcStyle' icon data-tip data-for='Available_Subcategory_Questions'>help</Button>
                      <ReactTooltip id='Available_Subcategory_Questions' type='light' className='tool-tip'>
                        <span>{this.helpTextModel.getHelpTextForKey('Available_Subcategory_Questions')}</span>
                      </ReactTooltip>
                    </td>
                    <td style={{paddingLeft:"0px",textAlign:"center", width: '57px' }}>
                      <span style={{fontFamily:'inherit',color:'inherit'}} >Graded</span>
                      <Button className='nocqcStyle' icon data-tip data-for='Graded'>help</Button>
                      <ReactTooltip id='Graded' type='light' className='tool-tip'>
                        <span>{this.helpTextModel.getHelpTextForKey('Graded')}</span>
                      </ReactTooltip>
                    </td>
                    <td style={{paddingLeft:"0px",textAlign:"center", width: '57px' }}>
                      <span style={{fontFamily:'inherit',color:'inherit'}} >Enable Analytics</span>
                      <Button className='nocqcStyle' icon data-tip data-for='enable-analytics'>help</Button>
                      <ReactTooltip id='enable-analytics' type='light' className='tool-tip'>
                        <span>{this.helpTextModel.getHelpTextForKey('Enable Analytics')}</span>
                      </ReactTooltip>
                    </td>
                    <td style={{paddingLeft:"0px",textAlign:"center", width: '57px' }}>
                      <span style={{fontFamily:'inherit',color:'inherit'}}>Enable Feedback</span>
                      <Button className='nocqcStyle' icon data-tip data-for='enable-feedback'>help</Button>
                      <ReactTooltip id='enable-feedback' type='light' className='tool-tip'>
                        <span>{this.helpTextModel.getHelpTextForKey('Enable Feedback')}</span>
                      </ReactTooltip>
                    </td>
                    <td style={{paddingLeft:"0px",textAlign:"center", width: '100px' }}>Display Order</td>
                    <td style={{paddingLeft:"0px",textAlign:"center", width: '56px'}}>
                      Action
                    </td>
                  </tr>
                
                {selectedCategroyArr}</tbody>
              </table>
             
            </div>
            
          </div>
          
          <Grid className="splashScreenGrid">
            <Cell size={12}>
              <div className="SplashSubHeading">Splash Screen : </div>
            </Cell>
            <Cell size={7}>
              <RichTextEditor
                  style={this.state.style}
                  defaulHeight={2000}
                  value={this.state.splashTextEditorObj}
                  onChange={this.onSplashScreenTextChange}
                  handleDroppedFiles={this.dropfilesHandler.bind(
                    this,
                    'showDetails'
                  )}
                  ref="showDetails"
                /><br/>
              <div style={(this.state.altSplashScreenTextVisible ? {width : "63%", marginLeft: "5%"} : {display:"none"})}>
                <tr>
                  <td> <p style={{fontSize:"medium",color: '#960000'}}><label for="altsplashId">
                    Title and Alternative Text for all Images in SplashScreen
                    </label></p></td>
                  <td><Button className='nocqcStyle' icon tooltipLabel="Format : Title Text for 1st Image ; Alt text 1st Image ; Title Text for 2nd Image ; Alt text for 2nd Image and so on. Don't use semicolon at the end of the text. Use it only to separate Title Text and Alt.">help</Button></td>
                </tr>
              
                <TextField
                id="altsplashId"
                style={{borderStyle: "ridge"}}
                rows={2}
                value={this.state.altSplashScreenObj}
                onChange={this.onAltSplashScreenTextChange}
                name='altSplashScreenEditor'
                />
              </div>
            </Cell>
            <Cell size={5}>
            {loadingSave ? (
                <LoadingSpinner />
              ) : (
                <Button
                  raised
                  primary
                  style={{marginRight:'10px'}}
                  className="buttonColour"
                  onClick={() => {
                    let published = false;
                    if (
                      (this.state.is_lti_enabled && JSON.parse(this.state.is_lti_enabled))
                      || this.state.status === 1
                    ) {
                      published = true
                    }
                    this.createQuiz(published);
                  }}
                >
                  {this.state.quiz_id == null ? 'Create'+(this.state.quizORTest?" Test":" Assignment") : 'Save' +(this.state.quizORTest?" Test":" Assignment")}
                </Button>
              )}
              {this.state.status === 0 && !(this.state.is_lti_enabled && JSON.parse(this.state.is_lti_enabled)) ? 
                  <Button
                    raised
                    primary
                    style={{marginRight:'10px'}}
                    className="buttonColour"
                    onClick={() => {
                      this.createQuiz(true)
                    }}
                  >
                    {this.state.quiz_id == null ? 'Create'+(this.state.quizORTest?" Test":" Assignment") : 'Save' +(this.state.quizORTest?" Test":" Assignment")} & Publish
                  </Button>
                : null}
              
              <Button
                raised
                swapTheming
                className="buttonColour"
                onClick={this.cancel}
              >
                Close
              </Button>
            </Cell>
          </Grid>
          
        </div>
       
      </div>
    );
  }
}
